// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { apiDeleteAlertsUuid, apiDeleteAudit, apiDeleteAuthAccessRevoke, apiDeleteAuthRefreshRevoke, apiDeleteAuxiliaryUuid, apiDeleteClinicalStudiesAdminProcedureUuid, apiDeleteClinicalStudiesAssociationComputedComputedUuidVisitUuid, apiDeleteClinicalStudiesAssociationDerivedDerivedUuidVisitUuid, apiDeleteClinicalStudiesAssociationDiagnosesDiagnosisUuidVisitUuid, apiDeleteClinicalStudiesAssociationEventsEventUuidVisitUuid, apiDeleteClinicalStudiesAssociationMedicalDataMedicalDataUuidVisitUuid, apiDeleteClinicalStudiesAssociationMedicalReportsMedicalReportUuidVisitUuid, apiDeleteClinicalStudiesAssociationMedicationsMedicationUuidVisitUuid, apiDeleteClinicalStudiesAssociationPpgsPpgUuidVisitUuid, apiDeleteClinicalStudiesAssociationQuestionnairesQuestionnaireUuidVisitUuid, apiDeleteClinicalStudiesAssociationSymptomsSymptomUuidVisitUuid, apiDeleteClinicalStudiesEnrollmentUuid, apiDeleteClinicalStudiesStudyVisitUuid, apiDeleteClinicsUuid, apiDeleteComputedUuid, apiDeleteDerivedPpgPpgUuid, apiDeleteDiagnosesUuid, apiDeleteEcgDerivedEcgEcgUuid, apiDeleteEcgUuid, apiDeleteEventsUuid, apiDeleteLimitersUuid, apiDeleteMedicaldataUuid, apiDeleteMedicalReportsUuid, apiDeleteMedicationsUuid, apiDeleteMessagingUuid, apiDeleteMfaSms, apiDeleteMfaTotp, apiDeleteMfaWebauthnCredentialUuid, apiDeleteMonitoringSettingsMonitoringUuid, apiDeleteMonitoringSettingsQuestionnairesUuid, apiDeletePatientsPatientId, apiDeletePhysiciansUuid, apiDeletePpgUuid, apiDeletePushTokensUnregisterToken, apiDeletePushTokensUnregisterUuidToken, apiDeleteQuestionnairesUuid, apiDeleteSchedulesUuid, apiDeleteServiceAccountsKeysKeyUuid, apiDeleteStudyTextUuid, apiDeleteSymptomsUuid, apiDeleteThresholdsUuid, apiDeleteUsersUuid, apiGetAiOutputsUuid, apiGetAiOutputsUuidFeedback, apiGetAlerts, apiGetAlertsAuditRoom, apiGetAlertsMedicalWaitingRoom, apiGetAlertsSourceDataUuid, apiGetAlertsTechnicalWaitingRoom, apiGetAnalyticsAlerts, apiGetAnalyticsAudit, apiGetAnalyticsComputed, apiGetAnalyticsEcg, apiGetAnalyticsEvents, apiGetAnalyticsPpg, apiGetAudit, apiGetAuthAdminLogoutUuid, apiGetAuthIsFresh, apiGetAuthLogout, apiGetAuthLogoutAll, apiGetAuthRefresh, apiGetAuxiliary, apiGetAuxiliaryEcgEcgUuid, apiGetAuxiliaryPpgPpgUuid, apiGetAuxiliaryUuid, apiGetBillingAccount, apiGetBillingLedger, apiGetBillingScreeningUsers, apiGetBillingUsersUserUuidAccount, apiGetClinicalStudies, apiGetClinicalStudiesCalendar, apiGetClinicalStudiesStudyAcronymDefinition, apiGetClinicalStudiesStudyAcronymEnrollPreFill, apiGetClinicalStudiesStudyAcronymOverviewOverall, apiGetClinicalStudiesStudyAcronymOverviewPatientPatientId, apiGetClinicalStudiesStudyAcronymVisits, apiGetClinicalStudiesVisitUuidDataPreFill, apiGetClinics, apiGetComputed, apiGetComputedLast, apiGetComputedPpgPpgUuid, apiGetComputedPpgPpgUuidLvfpIndication, apiGetDerived, apiGetDerivedPpgPpgUuid, apiGetDerivedUuid, apiGetDiagnoses, apiGetDiagnosesList, apiGetEcg, apiGetEcgDerived, apiGetEcgDerivedEcgEcgUuid, apiGetEcgDerivedScpCodes, apiGetEcgDerivedUuid, apiGetEcgUuid, apiGetEvents, apiGetEventsCategories, apiGetHealth, apiGetHealthchecker, apiGetHfBasicMedDataPatientId, apiGetHfComorbiditiesPatientId, apiGetHfExamsPatientId, apiGetHfLabDataPatientId, apiGetHfSymptomsPatientId, apiGetHfVitalsPatientId, apiGetInfo, apiGetLabelstudioRedirectProjectIdPpgUuid, apiGetLabelstudioTaskProjectIdPpgUuid, apiGetLimiters, apiGetMedicaldata, apiGetMedicaldataLast, apiGetMedicaldataList, apiGetMedicalReports, apiGetMedicalReportsDownloadUuid, apiGetMedicalReportsUuid, apiGetMedicalReportsUuidDownloadUrl, apiGetMedicalReportsUuidExtraction, apiGetMedicalReportsUuidUploadUrl, apiGetMedications, apiGetMedicationsMedicationGroups, apiGetMessaging, apiGetMessagingPatientId, apiGetMfaStatus, apiGetMonitoringSettingsMonitoring, apiGetMonitoringSettingsMonitoringPatientId, apiGetMonitoringSettingsQuestionnaires, apiGetPatients, apiGetPatientsCounts, apiGetPatientsMeasurementConfigDefault, apiGetPatientsMinimal, apiGetPatientsPatientId, apiGetPatientsPatientIdAlerts, apiGetPatientsPatientIdComputed, apiGetPatientsPatientIdConsent, apiGetPatientsPatientIdConsents, apiGetPatientsPatientIdDerived, apiGetPatientsPatientIdDiagnoses, apiGetPatientsPatientIdEvents, apiGetPatientsPatientIdGdmt, apiGetPatientsPatientIdHealthPro, apiGetPatientsPatientIdMeasurements, apiGetPatientsPatientIdMedicaldata, apiGetPatientsPatientIdMedications, apiGetPatientsPatientIdMonitoringInfo, apiGetPatientsPatientIdPpgs, apiGetPatientsPatientIdQuestionnaires, apiGetPatientsPatientIdSymptoms, apiGetPatientsPatientIdThresholds, apiGetPatientsPendingConsents, apiGetPhysicians, apiGetPolicies, apiGetPoliciesPermissionsMetadata, apiGetPoliciesUuid, apiGetPpg, apiGetPpgLast, apiGetPpgUuid, apiGetPushNotificationsLog, apiGetQuestionnaires, apiGetQuestionnairesQuestionnaireTypeLanguage, apiGetQuestionnairesShouldFillQuestionnaireTypePatientId, apiGetQuestionnairesStatsQuestionnaireTypeOverall, apiGetQuestionnairesStatsQuestionnaireTypePatientPatientId, apiGetRegistrationPasswordFormFormTypeLanguage, apiGetSchedules, apiGetSchedulesCheckPatientId, apiGetSchedulesCompliancePatientId, apiGetSchedulesNextMeasurementPatientId, apiGetServiceAccounts, apiGetServiceAccountsMe, apiGetServiceAccountsSelf, apiGetStudyText, apiGetStudyTextAboutTextLanguage, apiGetStudyTextConsentConsentTypeMonitoringTypeTextLanguage, apiGetStudyTextMonitoringTypeTextLanguage, apiGetStudyTextUuid, apiGetSymptoms, apiGetSymptomsLast, apiGetSymptomsList, apiGetTasksApiResultTaskId, apiGetTasksApiStatusTaskId, apiGetTasksApiTaskIds, apiGetTasksWorkerListQuicklookTasks, apiGetTasksWorkerListTasks, apiGetTasksWorkerQuicklookSharedTaskId, apiGetTasksWorkerQuicklookShareTaskId, apiGetTasksWorkerQuicklookTaskId, apiGetTasksWorkerQuicklookTaskIdJson, apiGetTasksWorkerQuicklookTaskIdPdf, apiGetTasksWorkerResultTaskId, apiGetTasksWorkerStatusTaskId, apiGetThresholds, apiGetThresholdsDefault, apiGetUsers, apiGetUsersMe, apiGetUsersMonitoringUsers, apiGetUsersPhysicians, apiGetUsersUuidDeleteImpact, apiGetUtilsCountries, apiGetUtilsErrorCodesLanguage, apiGetUtilsSupportContactLanguage, apiGetV2QuestionnairesGetQuestionnaireTypeLanguage, apiGetV2QuestionnairesShouldFillPatientId, apiPostAiFeedback, apiPostAlerts, apiPostAlertsRebuild, apiPostAlertsValidateUuid, apiPostAuthFreshLogin, apiPostAuthLogin, apiPostAuthServiceLogin, apiPostAuthTokenLogin, apiPostAuxiliaryAccelerometer, apiPostAuxiliaryAlivecorAvgBeat, apiPostAuxiliaryGyrometer, apiPostBillingUsers, apiPostClinicalStudiesAdminProcedure, apiPostClinicalStudiesAssociationComputed, apiPostClinicalStudiesAssociationDerived, apiPostClinicalStudiesAssociationDiagnoses, apiPostClinicalStudiesAssociationEvents, apiPostClinicalStudiesAssociationMedicalData, apiPostClinicalStudiesAssociationMedicalReports, apiPostClinicalStudiesAssociationMedications, apiPostClinicalStudiesAssociationPpgs, apiPostClinicalStudiesAssociationQuestionnaires, apiPostClinicalStudiesAssociationSymptoms, apiPostClinicalStudiesEnroll, apiPostClinicalStudiesStudyVisit, apiPostClinics, apiPostComputed, apiPostDerivedBerry, apiPostDerivedViatom, apiPostDiagnoses, apiPostDiagnosesBulk, apiPostEcgAlivecor, apiPostEcgDerivedAlivecor, apiPostEcgGeneric, apiPostEvents, apiPostHfComorbidities, apiPostHfData, apiPostHfExamsEcho, apiPostHfExamsLhc, apiPostHfExamsRhc, apiPostHfSymptoms, apiPostLimiters, apiPostMedicaldata, apiPostMedicaldataBulk, apiPostMedicalReports, apiPostMedicalReportsMultifile, apiPostMedicalReportsUuidExtractionExtractRegion, apiPostMedicalReportsUuidExtractionIngest, apiPostMedicalReportsUuidExtractionReject, apiPostMedicalReportsUuidExtractionRetry, apiPostMedications, apiPostMedicationsBulk, apiPostMessaging, apiPostMfaAdminResetUuid, apiPostMfaBackupCodesRegenerate, apiPostMfaChallengeSmsSend, apiPostMfaChallengeVerify, apiPostMfaChallengeWebauthnOptions, apiPostMfaChallengeWebauthnVerify, apiPostMfaEnrollSmsConfirm, apiPostMfaEnrollSmsStart, apiPostMfaEnrollTotpConfirm, apiPostMfaEnrollTotpStart, apiPostMfaEnrollWebauthnOptions, apiPostMfaEnrollWebauthnVerify, apiPostMonitoringSettingsMonitoring, apiPostMonitoringSettingsQuestionnaires, apiPostPatients, apiPostPatientsPatientAndUser, apiPostPatientsPatientIdAiOutputs, apiPostPatientsPatientIdUser, apiPostPhysicians, apiPostPpgBerry, apiPostPpgGeneric, apiPostPpgMobile, apiPostPpgSamsung, apiPostPpgSmartcare, apiPostPpgViatom, apiPostPushNotificationsSend, apiPostPushNotificationsSendTemplated, apiPostPushNotificationsSendToPatient, apiPostPushTokensRegister, apiPostPushTokensRegisterUuid, apiPostQuestionnaires, apiPostQuestionnairesSkipQuestionnaireTypePatientId, apiPostRegistrationPreregisterPatient, apiPostRegistrationPreregisterPhysician, apiPostSchedules, apiPostServiceAccounts, apiPostServiceAccountsSelf, apiPostServiceAccountsServiceAccountUuidKeys, apiPostStudyText, apiPostSymptoms, apiPostTasksWorkerQuicklookPatient, apiPostTasksWorkerQuicklookPpg, apiPostTasksWorkerSubmitPatient, apiPostTasksWorkerSubmitPpg, apiPostTasksWorkflowBuild, apiPostTasksWorkflowSubmit, apiPostThresholds, apiPostUsers, apiPutAlertsMarkAllSeenPatientId, apiPutAlertsMarkSeenUuid, apiPutAlertsPatientIdWaitingRoom, apiPutAlertsUuid, apiPutAudit, apiPutAuthRequestTokenLogin, apiPutBillingUsersUserUuidCredits, apiPutClinicalStudiesAdminProcedureUuid, apiPutClinicalStudiesAssociationComputedComputedUuidVisitUuid, apiPutClinicalStudiesAssociationDerivedDerivedUuidVisitUuid, apiPutClinicalStudiesAssociationDiagnosesDiagnosisUuidVisitUuid, apiPutClinicalStudiesAssociationEventsEventUuidVisitUuid, apiPutClinicalStudiesAssociationMedicalDataMedicalDataUuidVisitUuid, apiPutClinicalStudiesAssociationMedicalReportsMedicalReportUuidVisitUuid, apiPutClinicalStudiesAssociationMedicationsMedicationUuidVisitUuid, apiPutClinicalStudiesAssociationPpgsPpgUuidVisitUuid, apiPutClinicalStudiesAssociationQuestionnairesQuestionnaireUuidVisitUuid, apiPutClinicalStudiesAssociationSymptomsSymptomUuidVisitUuid, apiPutClinicalStudiesEnrollmentUuid, apiPutClinicalStudiesStudyVisitUuid, apiPutClinicsUuid, apiPutComputedUuid, apiPutDerivedPpgPpgUuid, apiPutDerivedUuid, apiPutDiagnosesUuid, apiPutEcgDerivedEcgEcgUuid, apiPutEcgDerivedUuid, apiPutEcgUuid, apiPutEventsUuid, apiPutLimitersUuid, apiPutMedicaldataUuid, apiPutMedicalReportsUuid, apiPutMedicalReportsUuidExtraction, apiPutMedicationsChangeUuid, apiPutMedicationsUuid, apiPutMessagingUuid, apiPutMonitoringSettingsMonitoringUuid, apiPutMonitoringSettingsQuestionnairesUuid, apiPutPatientsPatientId, apiPutPatientsPatientIdApproveConsentPaper, apiPutPatientsPatientIdApproveConsentTelemonitoring, apiPutPatientsPatientIdConsentsConsentType, apiPutPatientsPatientIdRevokeConsentPaper, apiPutPatientsPatientIdRevokeConsentTelemonitoring, apiPutPhysiciansUuid, apiPutPoliciesUuid, apiPutPpgUuid, apiPutQuestionnairesUuid, apiPutRegistrationFinishPatient, apiPutRegistrationFinishPhysician, apiPutSchedulesUuid, apiPutServiceAccountsServiceAccountUuidOwner, apiPutServiceAccountsServiceAccountUuidStatus, apiPutSymptomsUuid, apiPutTasksWorkerQuicklookHeartcoreMasterPatientId, apiPutTasksWorkerQuicklookHeartcorePatientId, apiPutThresholdsUuid, apiPutUsersChangePassword, apiPutUsersForgotPassword, apiPutUsersResetPassword, apiPutUsersResetUuid, apiPutUsersTemporaryPassUuid, apiPutUsersUuid, apiPutUsersUuidArchive, apiPutUsersUuidUnarchive, type Options } from '../sdk.gen';
import type { DeleteApiV1AlertsByUuidData, DeleteApiV1AlertsByUuidError, DeleteApiV1AlertsByUuidResponse, DeleteApiV1AuditData, DeleteApiV1AuditError, DeleteApiV1AuditResponse, DeleteApiV1AuthAccessRevokeData, DeleteApiV1AuthAccessRevokeError, DeleteApiV1AuthAccessRevokeResponse, DeleteApiV1AuthRefreshRevokeData, DeleteApiV1AuthRefreshRevokeError, DeleteApiV1AuthRefreshRevokeResponse, DeleteApiV1AuxiliaryByUuidData, DeleteApiV1AuxiliaryByUuidError, DeleteApiV1AuxiliaryByUuidResponse, DeleteApiV1ClinicalStudiesAdminProcedureByUuidData, DeleteApiV1ClinicalStudiesAdminProcedureByUuidError, DeleteApiV1ClinicalStudiesAdminProcedureByUuidResponse, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidError, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesEnrollmentByUuidData, DeleteApiV1ClinicalStudiesEnrollmentByUuidError, DeleteApiV1ClinicalStudiesEnrollmentByUuidResponse, DeleteApiV1ClinicalStudiesStudyVisitByUuidData, DeleteApiV1ClinicalStudiesStudyVisitByUuidError, DeleteApiV1ClinicalStudiesStudyVisitByUuidResponse, DeleteApiV1ClinicsByUuidData, DeleteApiV1ClinicsByUuidError, DeleteApiV1ClinicsByUuidResponse, DeleteApiV1ComputedByUuidData, DeleteApiV1ComputedByUuidError, DeleteApiV1ComputedByUuidResponse, DeleteApiV1DerivedPpgByPpgUuidData, DeleteApiV1DerivedPpgByPpgUuidError, DeleteApiV1DerivedPpgByPpgUuidResponse, DeleteApiV1DiagnosesByUuidData, DeleteApiV1DiagnosesByUuidError, DeleteApiV1DiagnosesByUuidResponse, DeleteApiV1EcgByUuidData, DeleteApiV1EcgByUuidError, DeleteApiV1EcgByUuidResponse, DeleteApiV1EcgDerivedEcgByEcgUuidData, DeleteApiV1EcgDerivedEcgByEcgUuidError, DeleteApiV1EcgDerivedEcgByEcgUuidResponse, DeleteApiV1EventsByUuidData, DeleteApiV1EventsByUuidError, DeleteApiV1EventsByUuidResponse, DeleteApiV1LimitersByUuidData, DeleteApiV1LimitersByUuidError, DeleteApiV1LimitersByUuidResponse, DeleteApiV1MedicaldataByUuidData, DeleteApiV1MedicaldataByUuidError, DeleteApiV1MedicaldataByUuidResponse, DeleteApiV1MedicalReportsByUuidData, DeleteApiV1MedicalReportsByUuidError, DeleteApiV1MedicalReportsByUuidResponse, DeleteApiV1MedicationsByUuidData, DeleteApiV1MedicationsByUuidError, DeleteApiV1MedicationsByUuidResponse, DeleteApiV1MessagingByUuidData, DeleteApiV1MessagingByUuidError, DeleteApiV1MessagingByUuidResponse, DeleteApiV1MfaSmsData, DeleteApiV1MfaSmsResponse, DeleteApiV1MfaTotpData, DeleteApiV1MfaTotpResponse, DeleteApiV1MfaWebauthnByCredentialUuidData, DeleteApiV1MfaWebauthnByCredentialUuidError, DeleteApiV1MfaWebauthnByCredentialUuidResponse, DeleteApiV1MonitoringSettingsMonitoringByUuidData, DeleteApiV1MonitoringSettingsMonitoringByUuidError, DeleteApiV1MonitoringSettingsMonitoringByUuidResponse, DeleteApiV1MonitoringSettingsQuestionnairesByUuidData, DeleteApiV1MonitoringSettingsQuestionnairesByUuidError, DeleteApiV1MonitoringSettingsQuestionnairesByUuidResponse, DeleteApiV1PatientsByPatientIdData, DeleteApiV1PatientsByPatientIdError, DeleteApiV1PatientsByPatientIdResponse, DeleteApiV1PhysiciansByUuidData, DeleteApiV1PhysiciansByUuidError, DeleteApiV1PhysiciansByUuidResponse, DeleteApiV1PpgByUuidData, DeleteApiV1PpgByUuidError, DeleteApiV1PpgByUuidResponse, DeleteApiV1PushTokensUnregisterByTokenData, DeleteApiV1PushTokensUnregisterByTokenError, DeleteApiV1PushTokensUnregisterByTokenResponse, DeleteApiV1PushTokensUnregisterByUuidByTokenData, DeleteApiV1PushTokensUnregisterByUuidByTokenError, DeleteApiV1PushTokensUnregisterByUuidByTokenResponse, DeleteApiV1QuestionnairesByUuidData, DeleteApiV1QuestionnairesByUuidError, DeleteApiV1QuestionnairesByUuidResponse, DeleteApiV1SchedulesByUuidData, DeleteApiV1SchedulesByUuidError, DeleteApiV1SchedulesByUuidResponse, DeleteApiV1ServiceAccountsKeysByKeyUuidData, DeleteApiV1ServiceAccountsKeysByKeyUuidError, DeleteApiV1ServiceAccountsKeysByKeyUuidResponse, DeleteApiV1StudyTextByUuidData, DeleteApiV1StudyTextByUuidError, DeleteApiV1StudyTextByUuidResponse, DeleteApiV1SymptomsByUuidData, DeleteApiV1SymptomsByUuidError, DeleteApiV1SymptomsByUuidResponse, DeleteApiV1ThresholdsByUuidData, DeleteApiV1ThresholdsByUuidError, DeleteApiV1ThresholdsByUuidResponse, DeleteApiV1UsersByUuidData, DeleteApiV1UsersByUuidError, DeleteApiV1UsersByUuidResponse, GetApiHealthcheckerData, GetApiHealthcheckerResponse, GetApiHealthData, GetApiHealthResponse, GetApiInfoData, GetApiInfoError, GetApiInfoResponse, GetApiV1AiOutputsByUuidData, GetApiV1AiOutputsByUuidError, GetApiV1AiOutputsByUuidFeedbackData, GetApiV1AiOutputsByUuidFeedbackError, GetApiV1AiOutputsByUuidFeedbackResponse, GetApiV1AiOutputsByUuidResponse, GetApiV1AlertsAuditRoomData, GetApiV1AlertsAuditRoomError, GetApiV1AlertsAuditRoomResponse, GetApiV1AlertsData, GetApiV1AlertsError, GetApiV1AlertsMedicalWaitingRoomData, GetApiV1AlertsMedicalWaitingRoomError, GetApiV1AlertsMedicalWaitingRoomResponse, GetApiV1AlertsResponse, GetApiV1AlertsSourceDataByUuidData, GetApiV1AlertsSourceDataByUuidError, GetApiV1AlertsSourceDataByUuidResponse, GetApiV1AlertsTechnicalWaitingRoomData, GetApiV1AlertsTechnicalWaitingRoomError, GetApiV1AlertsTechnicalWaitingRoomResponse, GetApiV1AnalyticsAlertsData, GetApiV1AnalyticsAlertsError, GetApiV1AnalyticsAlertsResponse, GetApiV1AnalyticsAuditData, GetApiV1AnalyticsAuditError, GetApiV1AnalyticsAuditResponse, GetApiV1AnalyticsComputedData, GetApiV1AnalyticsComputedError, GetApiV1AnalyticsComputedResponse, GetApiV1AnalyticsEcgData, GetApiV1AnalyticsEcgError, GetApiV1AnalyticsEcgResponse, GetApiV1AnalyticsEventsData, GetApiV1AnalyticsEventsError, GetApiV1AnalyticsEventsResponse, GetApiV1AnalyticsPpgData, GetApiV1AnalyticsPpgError, GetApiV1AnalyticsPpgResponse, GetApiV1AuditData, GetApiV1AuditError, GetApiV1AuditResponse, GetApiV1AuthAdminLogoutByUuidData, GetApiV1AuthAdminLogoutByUuidError, GetApiV1AuthAdminLogoutByUuidResponse, GetApiV1AuthIsFreshData, GetApiV1AuthIsFreshError, GetApiV1AuthIsFreshResponse, GetApiV1AuthLogoutAllData, GetApiV1AuthLogoutAllError, GetApiV1AuthLogoutAllResponse, GetApiV1AuthLogoutData, GetApiV1AuthLogoutError, GetApiV1AuthLogoutResponse, GetApiV1AuthRefreshData, GetApiV1AuthRefreshError, GetApiV1AuthRefreshResponse, GetApiV1AuxiliaryByUuidData, GetApiV1AuxiliaryByUuidError, GetApiV1AuxiliaryByUuidResponse, GetApiV1AuxiliaryData, GetApiV1AuxiliaryEcgByEcgUuidData, GetApiV1AuxiliaryEcgByEcgUuidError, GetApiV1AuxiliaryEcgByEcgUuidResponse, GetApiV1AuxiliaryError, GetApiV1AuxiliaryPpgByPpgUuidData, GetApiV1AuxiliaryPpgByPpgUuidError, GetApiV1AuxiliaryPpgByPpgUuidResponse, GetApiV1AuxiliaryResponse, GetApiV1BillingAccountData, GetApiV1BillingAccountError, GetApiV1BillingAccountResponse, GetApiV1BillingLedgerData, GetApiV1BillingLedgerError, GetApiV1BillingLedgerResponse, GetApiV1BillingScreeningUsersData, GetApiV1BillingScreeningUsersError, GetApiV1BillingScreeningUsersResponse, GetApiV1BillingUsersByUserUuidAccountData, GetApiV1BillingUsersByUserUuidAccountError, GetApiV1BillingUsersByUserUuidAccountResponse, GetApiV1ClinicalStudiesByStudyAcronymDefinitionData, GetApiV1ClinicalStudiesByStudyAcronymDefinitionError, GetApiV1ClinicalStudiesByStudyAcronymDefinitionResponse, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillData, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillError, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillResponse, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallData, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallError, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallResponse, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdData, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdError, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdResponse, GetApiV1ClinicalStudiesByStudyAcronymVisitsData, GetApiV1ClinicalStudiesByStudyAcronymVisitsError, GetApiV1ClinicalStudiesByStudyAcronymVisitsResponse, GetApiV1ClinicalStudiesByVisitUuidDataPreFillData, GetApiV1ClinicalStudiesByVisitUuidDataPreFillError, GetApiV1ClinicalStudiesByVisitUuidDataPreFillResponse, GetApiV1ClinicalStudiesCalendarData, GetApiV1ClinicalStudiesCalendarError, GetApiV1ClinicalStudiesCalendarResponse, GetApiV1ClinicalStudiesData, GetApiV1ClinicalStudiesError, GetApiV1ClinicalStudiesResponse, GetApiV1ClinicsData, GetApiV1ClinicsError, GetApiV1ClinicsResponse, GetApiV1ComputedData, GetApiV1ComputedError, GetApiV1ComputedLastData, GetApiV1ComputedLastError, GetApiV1ComputedLastResponse, GetApiV1ComputedPpgByPpgUuidData, GetApiV1ComputedPpgByPpgUuidError, GetApiV1ComputedPpgByPpgUuidLvfpIndicationData, GetApiV1ComputedPpgByPpgUuidLvfpIndicationError, GetApiV1ComputedPpgByPpgUuidLvfpIndicationResponse, GetApiV1ComputedPpgByPpgUuidResponse, GetApiV1ComputedResponse, GetApiV1DerivedByUuidData, GetApiV1DerivedByUuidError, GetApiV1DerivedByUuidResponse, GetApiV1DerivedData, GetApiV1DerivedError, GetApiV1DerivedPpgByPpgUuidData, GetApiV1DerivedPpgByPpgUuidError, GetApiV1DerivedPpgByPpgUuidResponse, GetApiV1DerivedResponse, GetApiV1DiagnosesData, GetApiV1DiagnosesError, GetApiV1DiagnosesListData, GetApiV1DiagnosesListError, GetApiV1DiagnosesListResponse, GetApiV1DiagnosesResponse, GetApiV1EcgByUuidData, GetApiV1EcgByUuidError, GetApiV1EcgByUuidResponse, GetApiV1EcgData, GetApiV1EcgDerivedByUuidData, GetApiV1EcgDerivedByUuidError, GetApiV1EcgDerivedByUuidResponse, GetApiV1EcgDerivedData, GetApiV1EcgDerivedEcgByEcgUuidData, GetApiV1EcgDerivedEcgByEcgUuidError, GetApiV1EcgDerivedEcgByEcgUuidResponse, GetApiV1EcgDerivedError, GetApiV1EcgDerivedResponse, GetApiV1EcgDerivedScpCodesData, GetApiV1EcgDerivedScpCodesError, GetApiV1EcgDerivedScpCodesResponse, GetApiV1EcgError, GetApiV1EcgResponse, GetApiV1EventsCategoriesData, GetApiV1EventsCategoriesError, GetApiV1EventsCategoriesResponse, GetApiV1EventsData, GetApiV1EventsError, GetApiV1EventsResponse, GetApiV1HfBasicMedDataByPatientIdData, GetApiV1HfBasicMedDataByPatientIdError, GetApiV1HfBasicMedDataByPatientIdResponse, GetApiV1HfComorbiditiesByPatientIdData, GetApiV1HfComorbiditiesByPatientIdError, GetApiV1HfComorbiditiesByPatientIdResponse, GetApiV1HfExamsByPatientIdData, GetApiV1HfExamsByPatientIdError, GetApiV1HfExamsByPatientIdResponse, GetApiV1HfLabDataByPatientIdData, GetApiV1HfLabDataByPatientIdError, GetApiV1HfLabDataByPatientIdResponse, GetApiV1HfSymptomsByPatientIdData, GetApiV1HfSymptomsByPatientIdError, GetApiV1HfSymptomsByPatientIdResponse, GetApiV1HfVitalsByPatientIdData, GetApiV1HfVitalsByPatientIdError, GetApiV1HfVitalsByPatientIdResponse, GetApiV1LabelstudioRedirectByProjectIdByPpgUuidData, GetApiV1LabelstudioRedirectByProjectIdByPpgUuidError, GetApiV1LabelstudioTaskByProjectIdByPpgUuidData, GetApiV1LabelstudioTaskByProjectIdByPpgUuidError, GetApiV1LabelstudioTaskByProjectIdByPpgUuidResponse, GetApiV1LimitersData, GetApiV1LimitersError, GetApiV1LimitersResponse, GetApiV1MedicaldataData, GetApiV1MedicaldataError, GetApiV1MedicaldataLastData, GetApiV1MedicaldataLastError, GetApiV1MedicaldataLastResponse, GetApiV1MedicaldataListData, GetApiV1MedicaldataListError, GetApiV1MedicaldataListResponse, GetApiV1MedicaldataResponse, GetApiV1MedicalReportsByUuidData, GetApiV1MedicalReportsByUuidDownloadUrlData, GetApiV1MedicalReportsByUuidDownloadUrlError, GetApiV1MedicalReportsByUuidDownloadUrlResponse, GetApiV1MedicalReportsByUuidError, GetApiV1MedicalReportsByUuidExtractionData, GetApiV1MedicalReportsByUuidExtractionError, GetApiV1MedicalReportsByUuidExtractionResponse, GetApiV1MedicalReportsByUuidResponse, GetApiV1MedicalReportsByUuidUploadUrlData, GetApiV1MedicalReportsByUuidUploadUrlError, GetApiV1MedicalReportsByUuidUploadUrlResponse, GetApiV1MedicalReportsData, GetApiV1MedicalReportsDownloadByUuidData, GetApiV1MedicalReportsDownloadByUuidError, GetApiV1MedicalReportsDownloadByUuidResponse, GetApiV1MedicalReportsError, GetApiV1MedicalReportsResponse, GetApiV1MedicationsData, GetApiV1MedicationsError, GetApiV1MedicationsMedicationGroupsData, GetApiV1MedicationsMedicationGroupsError, GetApiV1MedicationsMedicationGroupsResponse, GetApiV1MedicationsResponse, GetApiV1MessagingByPatientIdData, GetApiV1MessagingByPatientIdError, GetApiV1MessagingByPatientIdResponse, GetApiV1MessagingData, GetApiV1MessagingError, GetApiV1MessagingResponse, GetApiV1MfaStatusData, GetApiV1MfaStatusResponse, GetApiV1MonitoringSettingsMonitoringByPatientIdData, GetApiV1MonitoringSettingsMonitoringByPatientIdError, GetApiV1MonitoringSettingsMonitoringByPatientIdResponse, GetApiV1MonitoringSettingsMonitoringData, GetApiV1MonitoringSettingsMonitoringError, GetApiV1MonitoringSettingsMonitoringResponse, GetApiV1MonitoringSettingsQuestionnairesData, GetApiV1MonitoringSettingsQuestionnairesError, GetApiV1MonitoringSettingsQuestionnairesResponse, GetApiV1PatientsByPatientIdAlertsData, GetApiV1PatientsByPatientIdAlertsError, GetApiV1PatientsByPatientIdAlertsResponse, GetApiV1PatientsByPatientIdComputedData, GetApiV1PatientsByPatientIdComputedError, GetApiV1PatientsByPatientIdComputedResponse, GetApiV1PatientsByPatientIdConsentData, GetApiV1PatientsByPatientIdConsentError, GetApiV1PatientsByPatientIdConsentResponse, GetApiV1PatientsByPatientIdConsentsData, GetApiV1PatientsByPatientIdConsentsError, GetApiV1PatientsByPatientIdConsentsResponse, GetApiV1PatientsByPatientIdData, GetApiV1PatientsByPatientIdDerivedData, GetApiV1PatientsByPatientIdDerivedError, GetApiV1PatientsByPatientIdDerivedResponse, GetApiV1PatientsByPatientIdDiagnosesData, GetApiV1PatientsByPatientIdDiagnosesError, GetApiV1PatientsByPatientIdDiagnosesResponse, GetApiV1PatientsByPatientIdError, GetApiV1PatientsByPatientIdEventsData, GetApiV1PatientsByPatientIdEventsError, GetApiV1PatientsByPatientIdEventsResponse, GetApiV1PatientsByPatientIdGdmtData, GetApiV1PatientsByPatientIdGdmtError, GetApiV1PatientsByPatientIdGdmtResponse, GetApiV1PatientsByPatientIdHealthProData, GetApiV1PatientsByPatientIdHealthProError, GetApiV1PatientsByPatientIdHealthProResponse, GetApiV1PatientsByPatientIdMeasurementsData, GetApiV1PatientsByPatientIdMeasurementsError, GetApiV1PatientsByPatientIdMeasurementsResponse, GetApiV1PatientsByPatientIdMedicaldataData, GetApiV1PatientsByPatientIdMedicaldataError, GetApiV1PatientsByPatientIdMedicaldataResponse, GetApiV1PatientsByPatientIdMedicationsData, GetApiV1PatientsByPatientIdMedicationsError, GetApiV1PatientsByPatientIdMedicationsResponse, GetApiV1PatientsByPatientIdMonitoringInfoData, GetApiV1PatientsByPatientIdMonitoringInfoError, GetApiV1PatientsByPatientIdMonitoringInfoResponse, GetApiV1PatientsByPatientIdPpgsData, GetApiV1PatientsByPatientIdPpgsError, GetApiV1PatientsByPatientIdPpgsResponse, GetApiV1PatientsByPatientIdQuestionnairesData, GetApiV1PatientsByPatientIdQuestionnairesError, GetApiV1PatientsByPatientIdQuestionnairesResponse, GetApiV1PatientsByPatientIdResponse, GetApiV1PatientsByPatientIdSymptomsData, GetApiV1PatientsByPatientIdSymptomsError, GetApiV1PatientsByPatientIdSymptomsResponse, GetApiV1PatientsByPatientIdThresholdsData, GetApiV1PatientsByPatientIdThresholdsError, GetApiV1PatientsByPatientIdThresholdsResponse, GetApiV1PatientsCountsData, GetApiV1PatientsCountsResponse, GetApiV1PatientsData, GetApiV1PatientsError, GetApiV1PatientsMeasurementConfigDefaultData, GetApiV1PatientsMeasurementConfigDefaultError, GetApiV1PatientsMeasurementConfigDefaultResponse, GetApiV1PatientsMinimalData, GetApiV1PatientsMinimalError, GetApiV1PatientsMinimalResponse, GetApiV1PatientsPendingConsentsData, GetApiV1PatientsPendingConsentsError, GetApiV1PatientsPendingConsentsResponse, GetApiV1PatientsResponse, GetApiV1PhysiciansData, GetApiV1PhysiciansError, GetApiV1PhysiciansResponse, GetApiV1PoliciesByUuidData, GetApiV1PoliciesByUuidError, GetApiV1PoliciesByUuidResponse, GetApiV1PoliciesData, GetApiV1PoliciesError, GetApiV1PoliciesPermissionsMetadataData, GetApiV1PoliciesPermissionsMetadataError, GetApiV1PoliciesPermissionsMetadataResponse, GetApiV1PoliciesResponse, GetApiV1PpgByUuidData, GetApiV1PpgByUuidError, GetApiV1PpgByUuidResponse, GetApiV1PpgData, GetApiV1PpgError, GetApiV1PpgLastData, GetApiV1PpgLastError, GetApiV1PpgLastResponse, GetApiV1PpgResponse, GetApiV1PushNotificationsLogData, GetApiV1PushNotificationsLogError, GetApiV1PushNotificationsLogResponse, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageData, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageError, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageResponse, GetApiV1QuestionnairesData, GetApiV1QuestionnairesError, GetApiV1QuestionnairesResponse, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdData, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdError, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdResponse, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallData, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallError, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallResponse, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdData, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdError, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdResponse, GetApiV1RegistrationPasswordFormByFormTypeByLanguageData, GetApiV1RegistrationPasswordFormByFormTypeByLanguageError, GetApiV1RegistrationPasswordFormByFormTypeByLanguageResponse, GetApiV1SchedulesCheckByPatientIdData, GetApiV1SchedulesCheckByPatientIdError, GetApiV1SchedulesCheckByPatientIdResponse, GetApiV1SchedulesComplianceByPatientIdData, GetApiV1SchedulesComplianceByPatientIdError, GetApiV1SchedulesComplianceByPatientIdResponse, GetApiV1SchedulesData, GetApiV1SchedulesError, GetApiV1SchedulesNextMeasurementByPatientIdData, GetApiV1SchedulesNextMeasurementByPatientIdError, GetApiV1SchedulesNextMeasurementByPatientIdResponse, GetApiV1SchedulesResponse, GetApiV1ServiceAccountsData, GetApiV1ServiceAccountsError, GetApiV1ServiceAccountsMeData, GetApiV1ServiceAccountsMeError, GetApiV1ServiceAccountsMeResponse, GetApiV1ServiceAccountsResponse, GetApiV1ServiceAccountsSelfData, GetApiV1ServiceAccountsSelfError, GetApiV1ServiceAccountsSelfResponse, GetApiV1StudyTextAboutByTextByLanguageData, GetApiV1StudyTextAboutByTextByLanguageError, GetApiV1StudyTextAboutByTextByLanguageResponse, GetApiV1StudyTextByMonitoringTypeByTextLanguageData, GetApiV1StudyTextByMonitoringTypeByTextLanguageError, GetApiV1StudyTextByMonitoringTypeByTextLanguageResponse, GetApiV1StudyTextByUuidData, GetApiV1StudyTextByUuidError, GetApiV1StudyTextByUuidResponse, GetApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageData, GetApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageError, GetApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageResponse, GetApiV1StudyTextData, GetApiV1StudyTextError, GetApiV1StudyTextResponse, GetApiV1SymptomsData, GetApiV1SymptomsError, GetApiV1SymptomsLastData, GetApiV1SymptomsLastError, GetApiV1SymptomsLastResponse, GetApiV1SymptomsListData, GetApiV1SymptomsListError, GetApiV1SymptomsListResponse, GetApiV1SymptomsResponse, GetApiV1TasksApiResultByTaskIdData, GetApiV1TasksApiResultByTaskIdError, GetApiV1TasksApiResultByTaskIdResponse, GetApiV1TasksApiStatusByTaskIdData, GetApiV1TasksApiStatusByTaskIdError, GetApiV1TasksApiStatusByTaskIdResponse, GetApiV1TasksApiTaskIdsData, GetApiV1TasksApiTaskIdsError, GetApiV1TasksApiTaskIdsResponse, GetApiV1TasksWorkerListQuicklookTasksData, GetApiV1TasksWorkerListQuicklookTasksError, GetApiV1TasksWorkerListQuicklookTasksResponse, GetApiV1TasksWorkerListTasksData, GetApiV1TasksWorkerListTasksError, GetApiV1TasksWorkerListTasksResponse, GetApiV1TasksWorkerQuicklookByTaskIdData, GetApiV1TasksWorkerQuicklookByTaskIdError, GetApiV1TasksWorkerQuicklookByTaskIdJsonData, GetApiV1TasksWorkerQuicklookByTaskIdJsonError, GetApiV1TasksWorkerQuicklookByTaskIdJsonResponse, GetApiV1TasksWorkerQuicklookByTaskIdPdfData, GetApiV1TasksWorkerQuicklookByTaskIdPdfError, GetApiV1TasksWorkerQuicklookByTaskIdResponse, GetApiV1TasksWorkerQuicklookShareByTaskIdData, GetApiV1TasksWorkerQuicklookShareByTaskIdError, GetApiV1TasksWorkerQuicklookShareByTaskIdResponse, GetApiV1TasksWorkerQuicklookSharedByTaskIdData, GetApiV1TasksWorkerQuicklookSharedByTaskIdError, GetApiV1TasksWorkerQuicklookSharedByTaskIdResponse, GetApiV1TasksWorkerResultByTaskIdData, GetApiV1TasksWorkerResultByTaskIdError, GetApiV1TasksWorkerResultByTaskIdResponse, GetApiV1TasksWorkerStatusByTaskIdData, GetApiV1TasksWorkerStatusByTaskIdError, GetApiV1TasksWorkerStatusByTaskIdResponse, GetApiV1ThresholdsData, GetApiV1ThresholdsDefaultData, GetApiV1ThresholdsDefaultError, GetApiV1ThresholdsDefaultResponse, GetApiV1ThresholdsError, GetApiV1ThresholdsResponse, GetApiV1UsersByUuidDeleteImpactData, GetApiV1UsersByUuidDeleteImpactError, GetApiV1UsersByUuidDeleteImpactResponse, GetApiV1UsersData, GetApiV1UsersError, GetApiV1UsersMeData, GetApiV1UsersMeError, GetApiV1UsersMeResponse, GetApiV1UsersMonitoringUsersData, GetApiV1UsersMonitoringUsersError, GetApiV1UsersMonitoringUsersResponse, GetApiV1UsersPhysiciansData, GetApiV1UsersPhysiciansError, GetApiV1UsersPhysiciansResponse, GetApiV1UsersResponse, GetApiV1UtilsCountriesData, GetApiV1UtilsCountriesError, GetApiV1UtilsCountriesResponse, GetApiV1UtilsErrorCodesByLanguageData, GetApiV1UtilsErrorCodesByLanguageError, GetApiV1UtilsErrorCodesByLanguageResponse, GetApiV1UtilsSupportContactByLanguageData, GetApiV1UtilsSupportContactByLanguageError, GetApiV1UtilsSupportContactByLanguageResponse, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageData, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageError, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageResponse, GetApiV2QuestionnairesShouldFillByPatientIdData, GetApiV2QuestionnairesShouldFillByPatientIdError, GetApiV2QuestionnairesShouldFillByPatientIdResponse, PostApiV1AiFeedbackData, PostApiV1AiFeedbackError, PostApiV1AiFeedbackResponse, PostApiV1AlertsData, PostApiV1AlertsError, PostApiV1AlertsRebuildData, PostApiV1AlertsRebuildError, PostApiV1AlertsRebuildResponse, PostApiV1AlertsResponse, PostApiV1AlertsValidateByUuidData, PostApiV1AlertsValidateByUuidError, PostApiV1AlertsValidateByUuidResponse, PostApiV1AuthFreshLoginData, PostApiV1AuthFreshLoginError, PostApiV1AuthFreshLoginResponse, PostApiV1AuthLoginData, PostApiV1AuthLoginError, PostApiV1AuthLoginResponse, PostApiV1AuthServiceLoginData, PostApiV1AuthServiceLoginError, PostApiV1AuthServiceLoginResponse, PostApiV1AuthTokenLoginData, PostApiV1AuthTokenLoginError, PostApiV1AuthTokenLoginResponse, PostApiV1AuxiliaryAccelerometerData, PostApiV1AuxiliaryAccelerometerError, PostApiV1AuxiliaryAccelerometerResponse, PostApiV1AuxiliaryAlivecorAvgBeatData, PostApiV1AuxiliaryAlivecorAvgBeatError, PostApiV1AuxiliaryAlivecorAvgBeatResponse, PostApiV1AuxiliaryGyrometerData, PostApiV1AuxiliaryGyrometerError, PostApiV1AuxiliaryGyrometerResponse, PostApiV1BillingUsersData, PostApiV1BillingUsersError, PostApiV1BillingUsersResponse, PostApiV1ClinicalStudiesAdminProcedureData, PostApiV1ClinicalStudiesAdminProcedureError, PostApiV1ClinicalStudiesAdminProcedureResponse, PostApiV1ClinicalStudiesAssociationComputedData, PostApiV1ClinicalStudiesAssociationComputedError, PostApiV1ClinicalStudiesAssociationComputedResponse, PostApiV1ClinicalStudiesAssociationDerivedData, PostApiV1ClinicalStudiesAssociationDerivedError, PostApiV1ClinicalStudiesAssociationDerivedResponse, PostApiV1ClinicalStudiesAssociationDiagnosesData, PostApiV1ClinicalStudiesAssociationDiagnosesError, PostApiV1ClinicalStudiesAssociationDiagnosesResponse, PostApiV1ClinicalStudiesAssociationEventsData, PostApiV1ClinicalStudiesAssociationEventsError, PostApiV1ClinicalStudiesAssociationEventsResponse, PostApiV1ClinicalStudiesAssociationMedicalDataData, PostApiV1ClinicalStudiesAssociationMedicalDataError, PostApiV1ClinicalStudiesAssociationMedicalDataResponse, PostApiV1ClinicalStudiesAssociationMedicalReportsData, PostApiV1ClinicalStudiesAssociationMedicalReportsError, PostApiV1ClinicalStudiesAssociationMedicalReportsResponse, PostApiV1ClinicalStudiesAssociationMedicationsData, PostApiV1ClinicalStudiesAssociationMedicationsError, PostApiV1ClinicalStudiesAssociationMedicationsResponse, PostApiV1ClinicalStudiesAssociationPpgsData, PostApiV1ClinicalStudiesAssociationPpgsError, PostApiV1ClinicalStudiesAssociationPpgsResponse, PostApiV1ClinicalStudiesAssociationQuestionnairesData, PostApiV1ClinicalStudiesAssociationQuestionnairesError, PostApiV1ClinicalStudiesAssociationQuestionnairesResponse, PostApiV1ClinicalStudiesAssociationSymptomsData, PostApiV1ClinicalStudiesAssociationSymptomsError, PostApiV1ClinicalStudiesAssociationSymptomsResponse, PostApiV1ClinicalStudiesEnrollData, PostApiV1ClinicalStudiesEnrollError, PostApiV1ClinicalStudiesEnrollResponse, PostApiV1ClinicalStudiesStudyVisitData, PostApiV1ClinicalStudiesStudyVisitError, PostApiV1ClinicalStudiesStudyVisitResponse, PostApiV1ClinicsData, PostApiV1ClinicsError, PostApiV1ClinicsResponse, PostApiV1ComputedData, PostApiV1ComputedError, PostApiV1ComputedResponse, PostApiV1DerivedBerryData, PostApiV1DerivedBerryError, PostApiV1DerivedBerryResponse, PostApiV1DerivedViatomData, PostApiV1DerivedViatomError, PostApiV1DerivedViatomResponse, PostApiV1DiagnosesBulkData, PostApiV1DiagnosesBulkError, PostApiV1DiagnosesBulkResponse, PostApiV1DiagnosesData, PostApiV1DiagnosesError, PostApiV1DiagnosesResponse, PostApiV1EcgAlivecorData, PostApiV1EcgAlivecorError, PostApiV1EcgAlivecorResponse, PostApiV1EcgDerivedAlivecorData, PostApiV1EcgDerivedAlivecorError, PostApiV1EcgDerivedAlivecorResponse, PostApiV1EcgGenericData, PostApiV1EcgGenericError, PostApiV1EcgGenericResponse, PostApiV1EventsData, PostApiV1EventsError, PostApiV1EventsResponse, PostApiV1HfComorbiditiesData, PostApiV1HfComorbiditiesError, PostApiV1HfComorbiditiesResponse, PostApiV1HfDataData, PostApiV1HfDataError, PostApiV1HfDataResponse, PostApiV1HfExamsEchoData, PostApiV1HfExamsEchoError, PostApiV1HfExamsEchoResponse, PostApiV1HfExamsLhcData, PostApiV1HfExamsLhcError, PostApiV1HfExamsLhcResponse, PostApiV1HfExamsRhcData, PostApiV1HfExamsRhcError, PostApiV1HfExamsRhcResponse, PostApiV1HfSymptomsData, PostApiV1HfSymptomsError, PostApiV1HfSymptomsResponse, PostApiV1LimitersData, PostApiV1LimitersError, PostApiV1LimitersResponse, PostApiV1MedicaldataBulkData, PostApiV1MedicaldataBulkError, PostApiV1MedicaldataBulkResponse, PostApiV1MedicaldataData, PostApiV1MedicaldataError, PostApiV1MedicaldataResponse, PostApiV1MedicalReportsByUuidExtractionExtractRegionData, PostApiV1MedicalReportsByUuidExtractionExtractRegionError, PostApiV1MedicalReportsByUuidExtractionExtractRegionResponse, PostApiV1MedicalReportsByUuidExtractionIngestData, PostApiV1MedicalReportsByUuidExtractionIngestError, PostApiV1MedicalReportsByUuidExtractionIngestResponse, PostApiV1MedicalReportsByUuidExtractionRejectData, PostApiV1MedicalReportsByUuidExtractionRejectError, PostApiV1MedicalReportsByUuidExtractionRejectResponse, PostApiV1MedicalReportsByUuidExtractionRetryData, PostApiV1MedicalReportsByUuidExtractionRetryError, PostApiV1MedicalReportsByUuidExtractionRetryResponse, PostApiV1MedicalReportsData, PostApiV1MedicalReportsError, PostApiV1MedicalReportsMultifileData, PostApiV1MedicalReportsMultifileError, PostApiV1MedicalReportsMultifileResponse, PostApiV1MedicalReportsResponse, PostApiV1MedicationsBulkData, PostApiV1MedicationsBulkError, PostApiV1MedicationsBulkResponse, PostApiV1MedicationsData, PostApiV1MedicationsError, PostApiV1MedicationsResponse, PostApiV1MessagingData, PostApiV1MessagingError, PostApiV1MessagingResponse, PostApiV1MfaAdminResetByUuidData, PostApiV1MfaAdminResetByUuidError, PostApiV1MfaAdminResetByUuidResponse, PostApiV1MfaBackupCodesRegenerateData, PostApiV1MfaBackupCodesRegenerateResponse, PostApiV1MfaChallengeSmsSendData, PostApiV1MfaChallengeSmsSendError, PostApiV1MfaChallengeSmsSendResponse, PostApiV1MfaChallengeVerifyData, PostApiV1MfaChallengeVerifyError, PostApiV1MfaChallengeVerifyResponse, PostApiV1MfaChallengeWebauthnOptionsData, PostApiV1MfaChallengeWebauthnOptionsError, PostApiV1MfaChallengeWebauthnOptionsResponse, PostApiV1MfaChallengeWebauthnVerifyData, PostApiV1MfaChallengeWebauthnVerifyError, PostApiV1MfaChallengeWebauthnVerifyResponse, PostApiV1MfaEnrollSmsConfirmData, PostApiV1MfaEnrollSmsConfirmError, PostApiV1MfaEnrollSmsConfirmResponse, PostApiV1MfaEnrollSmsStartData, PostApiV1MfaEnrollSmsStartError, PostApiV1MfaEnrollSmsStartResponse, PostApiV1MfaEnrollTotpConfirmData, PostApiV1MfaEnrollTotpConfirmError, PostApiV1MfaEnrollTotpConfirmResponse, PostApiV1MfaEnrollTotpStartData, PostApiV1MfaEnrollTotpStartError, PostApiV1MfaEnrollTotpStartResponse, PostApiV1MfaEnrollWebauthnOptionsData, PostApiV1MfaEnrollWebauthnOptionsError, PostApiV1MfaEnrollWebauthnOptionsResponse, PostApiV1MfaEnrollWebauthnVerifyData, PostApiV1MfaEnrollWebauthnVerifyError, PostApiV1MfaEnrollWebauthnVerifyResponse, PostApiV1MonitoringSettingsMonitoringData, PostApiV1MonitoringSettingsMonitoringError, PostApiV1MonitoringSettingsMonitoringResponse, PostApiV1MonitoringSettingsQuestionnairesData, PostApiV1MonitoringSettingsQuestionnairesError, PostApiV1MonitoringSettingsQuestionnairesResponse, PostApiV1PatientsByPatientIdAiOutputsData, PostApiV1PatientsByPatientIdAiOutputsError, PostApiV1PatientsByPatientIdAiOutputsResponse, PostApiV1PatientsByPatientIdUserData, PostApiV1PatientsByPatientIdUserError, PostApiV1PatientsByPatientIdUserResponse, PostApiV1PatientsData, PostApiV1PatientsError, PostApiV1PatientsPatientAndUserData, PostApiV1PatientsPatientAndUserError, PostApiV1PatientsPatientAndUserResponse, PostApiV1PatientsResponse, PostApiV1PhysiciansData, PostApiV1PhysiciansError, PostApiV1PhysiciansResponse, PostApiV1PpgBerryData, PostApiV1PpgBerryError, PostApiV1PpgBerryResponse, PostApiV1PpgGenericData, PostApiV1PpgGenericError, PostApiV1PpgGenericResponse, PostApiV1PpgMobileData, PostApiV1PpgMobileError, PostApiV1PpgMobileResponse, PostApiV1PpgSamsungData, PostApiV1PpgSamsungError, PostApiV1PpgSamsungResponse, PostApiV1PpgSmartcareData, PostApiV1PpgSmartcareError, PostApiV1PpgSmartcareResponse, PostApiV1PpgViatomData, PostApiV1PpgViatomError, PostApiV1PpgViatomResponse, PostApiV1PushNotificationsSendData, PostApiV1PushNotificationsSendError, PostApiV1PushNotificationsSendResponse, PostApiV1PushNotificationsSendTemplatedData, PostApiV1PushNotificationsSendTemplatedError, PostApiV1PushNotificationsSendTemplatedResponse, PostApiV1PushNotificationsSendToPatientData, PostApiV1PushNotificationsSendToPatientError, PostApiV1PushNotificationsSendToPatientResponse, PostApiV1PushTokensRegisterByUuidData, PostApiV1PushTokensRegisterByUuidError, PostApiV1PushTokensRegisterByUuidResponse, PostApiV1PushTokensRegisterData, PostApiV1PushTokensRegisterError, PostApiV1PushTokensRegisterResponse, PostApiV1QuestionnairesData, PostApiV1QuestionnairesError, PostApiV1QuestionnairesResponse, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdData, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdError, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdResponse, PostApiV1RegistrationPreregisterPatientData, PostApiV1RegistrationPreregisterPatientError, PostApiV1RegistrationPreregisterPatientResponse, PostApiV1RegistrationPreregisterPhysicianData, PostApiV1RegistrationPreregisterPhysicianError, PostApiV1RegistrationPreregisterPhysicianResponse, PostApiV1SchedulesData, PostApiV1SchedulesError, PostApiV1SchedulesResponse, PostApiV1ServiceAccountsByServiceAccountUuidKeysData, PostApiV1ServiceAccountsByServiceAccountUuidKeysError, PostApiV1ServiceAccountsByServiceAccountUuidKeysResponse, PostApiV1ServiceAccountsData, PostApiV1ServiceAccountsError, PostApiV1ServiceAccountsResponse, PostApiV1ServiceAccountsSelfData, PostApiV1ServiceAccountsSelfError, PostApiV1ServiceAccountsSelfResponse, PostApiV1StudyTextData, PostApiV1StudyTextError, PostApiV1StudyTextResponse, PostApiV1SymptomsData, PostApiV1SymptomsError, PostApiV1SymptomsResponse, PostApiV1TasksWorkerQuicklookPatientData, PostApiV1TasksWorkerQuicklookPatientError, PostApiV1TasksWorkerQuicklookPatientResponse, PostApiV1TasksWorkerQuicklookPpgData, PostApiV1TasksWorkerQuicklookPpgError, PostApiV1TasksWorkerQuicklookPpgResponse, PostApiV1TasksWorkerSubmitPatientData, PostApiV1TasksWorkerSubmitPatientError, PostApiV1TasksWorkerSubmitPatientResponse, PostApiV1TasksWorkerSubmitPpgData, PostApiV1TasksWorkerSubmitPpgError, PostApiV1TasksWorkerSubmitPpgResponse, PostApiV1TasksWorkflowBuildData, PostApiV1TasksWorkflowBuildError, PostApiV1TasksWorkflowBuildResponse, PostApiV1TasksWorkflowSubmitData, PostApiV1TasksWorkflowSubmitError, PostApiV1TasksWorkflowSubmitResponse, PostApiV1ThresholdsData, PostApiV1ThresholdsError, PostApiV1ThresholdsResponse, PostApiV1UsersData, PostApiV1UsersError, PostApiV1UsersResponse, PutApiV1AlertsByPatientIdWaitingRoomData, PutApiV1AlertsByPatientIdWaitingRoomError, PutApiV1AlertsByPatientIdWaitingRoomResponse, PutApiV1AlertsByUuidData, PutApiV1AlertsByUuidError, PutApiV1AlertsByUuidResponse, PutApiV1AlertsMarkAllSeenByPatientIdData, PutApiV1AlertsMarkAllSeenByPatientIdError, PutApiV1AlertsMarkAllSeenByPatientIdResponse, PutApiV1AlertsMarkSeenByUuidData, PutApiV1AlertsMarkSeenByUuidError, PutApiV1AlertsMarkSeenByUuidResponse, PutApiV1AuditData, PutApiV1AuditError, PutApiV1AuditResponse, PutApiV1AuthRequestTokenLoginData, PutApiV1AuthRequestTokenLoginError, PutApiV1AuthRequestTokenLoginResponse, PutApiV1BillingUsersByUserUuidCreditsData, PutApiV1BillingUsersByUserUuidCreditsError, PutApiV1BillingUsersByUserUuidCreditsResponse, PutApiV1ClinicalStudiesAdminProcedureByUuidData, PutApiV1ClinicalStudiesAdminProcedureByUuidError, PutApiV1ClinicalStudiesAdminProcedureByUuidResponse, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidError, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponse, PutApiV1ClinicalStudiesEnrollmentByUuidData, PutApiV1ClinicalStudiesEnrollmentByUuidError, PutApiV1ClinicalStudiesEnrollmentByUuidResponse, PutApiV1ClinicalStudiesStudyVisitByUuidData, PutApiV1ClinicalStudiesStudyVisitByUuidError, PutApiV1ClinicalStudiesStudyVisitByUuidResponse, PutApiV1ClinicsByUuidData, PutApiV1ClinicsByUuidError, PutApiV1ClinicsByUuidResponse, PutApiV1ComputedByUuidData, PutApiV1ComputedByUuidError, PutApiV1ComputedByUuidResponse, PutApiV1DerivedByUuidData, PutApiV1DerivedByUuidError, PutApiV1DerivedByUuidResponse, PutApiV1DerivedPpgByPpgUuidData, PutApiV1DerivedPpgByPpgUuidError, PutApiV1DerivedPpgByPpgUuidResponse, PutApiV1DiagnosesByUuidData, PutApiV1DiagnosesByUuidError, PutApiV1DiagnosesByUuidResponse, PutApiV1EcgByUuidData, PutApiV1EcgByUuidError, PutApiV1EcgByUuidResponse, PutApiV1EcgDerivedByUuidData, PutApiV1EcgDerivedByUuidError, PutApiV1EcgDerivedByUuidResponse, PutApiV1EcgDerivedEcgByEcgUuidData, PutApiV1EcgDerivedEcgByEcgUuidError, PutApiV1EcgDerivedEcgByEcgUuidResponse, PutApiV1EventsByUuidData, PutApiV1EventsByUuidError, PutApiV1EventsByUuidResponse, PutApiV1LimitersByUuidData, PutApiV1LimitersByUuidError, PutApiV1LimitersByUuidResponse, PutApiV1MedicaldataByUuidData, PutApiV1MedicaldataByUuidError, PutApiV1MedicaldataByUuidResponse, PutApiV1MedicalReportsByUuidData, PutApiV1MedicalReportsByUuidError, PutApiV1MedicalReportsByUuidExtractionData, PutApiV1MedicalReportsByUuidExtractionError, PutApiV1MedicalReportsByUuidExtractionResponse, PutApiV1MedicalReportsByUuidResponse, PutApiV1MedicationsByUuidData, PutApiV1MedicationsByUuidError, PutApiV1MedicationsByUuidResponse, PutApiV1MedicationsChangeByUuidData, PutApiV1MedicationsChangeByUuidError, PutApiV1MedicationsChangeByUuidResponse, PutApiV1MessagingByUuidData, PutApiV1MessagingByUuidError, PutApiV1MessagingByUuidResponse, PutApiV1MonitoringSettingsMonitoringByUuidData, PutApiV1MonitoringSettingsMonitoringByUuidError, PutApiV1MonitoringSettingsMonitoringByUuidResponse, PutApiV1MonitoringSettingsQuestionnairesByUuidData, PutApiV1MonitoringSettingsQuestionnairesByUuidError, PutApiV1MonitoringSettingsQuestionnairesByUuidResponse, PutApiV1PatientsByPatientIdApproveConsentPaperData, PutApiV1PatientsByPatientIdApproveConsentPaperError, PutApiV1PatientsByPatientIdApproveConsentPaperResponse, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringData, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringError, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringResponse, PutApiV1PatientsByPatientIdConsentsByConsentTypeData, PutApiV1PatientsByPatientIdConsentsByConsentTypeError, PutApiV1PatientsByPatientIdConsentsByConsentTypeResponse, PutApiV1PatientsByPatientIdData, PutApiV1PatientsByPatientIdError, PutApiV1PatientsByPatientIdResponse, PutApiV1PatientsByPatientIdRevokeConsentPaperData, PutApiV1PatientsByPatientIdRevokeConsentPaperError, PutApiV1PatientsByPatientIdRevokeConsentPaperResponse, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringData, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringError, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringResponse, PutApiV1PhysiciansByUuidData, PutApiV1PhysiciansByUuidError, PutApiV1PhysiciansByUuidResponse, PutApiV1PoliciesByUuidData, PutApiV1PoliciesByUuidError, PutApiV1PoliciesByUuidResponse, PutApiV1PpgByUuidData, PutApiV1PpgByUuidError, PutApiV1PpgByUuidResponse, PutApiV1QuestionnairesByUuidData, PutApiV1QuestionnairesByUuidError, PutApiV1QuestionnairesByUuidResponse, PutApiV1RegistrationFinishPatientData, PutApiV1RegistrationFinishPatientError, PutApiV1RegistrationFinishPatientResponse, PutApiV1RegistrationFinishPhysicianData, PutApiV1RegistrationFinishPhysicianError, PutApiV1RegistrationFinishPhysicianResponse, PutApiV1SchedulesByUuidData, PutApiV1SchedulesByUuidError, PutApiV1SchedulesByUuidResponse, PutApiV1ServiceAccountsByServiceAccountUuidOwnerData, PutApiV1ServiceAccountsByServiceAccountUuidOwnerError, PutApiV1ServiceAccountsByServiceAccountUuidOwnerResponse, PutApiV1ServiceAccountsByServiceAccountUuidStatusData, PutApiV1ServiceAccountsByServiceAccountUuidStatusError, PutApiV1ServiceAccountsByServiceAccountUuidStatusResponse, PutApiV1SymptomsByUuidData, PutApiV1SymptomsByUuidError, PutApiV1SymptomsByUuidResponse, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdData, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdError, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdResponse, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdData, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdError, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdResponse, PutApiV1ThresholdsByUuidData, PutApiV1ThresholdsByUuidError, PutApiV1ThresholdsByUuidResponse, PutApiV1UsersByUuidArchiveData, PutApiV1UsersByUuidArchiveError, PutApiV1UsersByUuidArchiveResponse, PutApiV1UsersByUuidData, PutApiV1UsersByUuidError, PutApiV1UsersByUuidResponse, PutApiV1UsersByUuidUnarchiveData, PutApiV1UsersByUuidUnarchiveError, PutApiV1UsersByUuidUnarchiveResponse, PutApiV1UsersChangePasswordData, PutApiV1UsersChangePasswordError, PutApiV1UsersChangePasswordResponse, PutApiV1UsersForgotPasswordData, PutApiV1UsersForgotPasswordError, PutApiV1UsersForgotPasswordResponse, PutApiV1UsersResetByUuidData, PutApiV1UsersResetByUuidError, PutApiV1UsersResetByUuidResponse, PutApiV1UsersResetPasswordData, PutApiV1UsersResetPasswordError, PutApiV1UsersResetPasswordResponse, PutApiV1UsersTemporaryPassByUuidData, PutApiV1UsersTemporaryPassByUuidError, PutApiV1UsersTemporaryPassByUuidResponse } from '../types.gen';

/**
 * Request Token Login
 *
 * Request a one-time token login link. The token is valid for 5 minutes.
 * Always returns success to prevent email enumeration.
 *
 * <br /> **Rate Limited:** Protected against flooding.  Maximum 1 request per **5 minutes** per email.  Always returns success to prevent email enumeration.
 */
export const apiPutAuthRequestTokenLoginMutation = (options?: Partial<Options<PutApiV1AuthRequestTokenLoginData>>): UseMutationOptions<PutApiV1AuthRequestTokenLoginResponse, PutApiV1AuthRequestTokenLoginError, Options<PutApiV1AuthRequestTokenLoginData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1AuthRequestTokenLoginResponse, PutApiV1AuthRequestTokenLoginError, Options<PutApiV1AuthRequestTokenLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutAuthRequestTokenLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Token Login
 *
 * Login with one-time token. This endpoint validates the token from the
 * email link, marks it as used, and issues fresh JWT access and refresh
 * tokens - unless MFA applies to this account, in which case a challenge
 * is returned instead (see `status` field). The access token expires in
 * 15 minutes, and the refresh token is valid for 60 minutes.
 */
export const apiPostAuthTokenLoginMutation = (options?: Partial<Options<PostApiV1AuthTokenLoginData>>): UseMutationOptions<PostApiV1AuthTokenLoginResponse, PostApiV1AuthTokenLoginError, Options<PostApiV1AuthTokenLoginData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuthTokenLoginResponse, PostApiV1AuthTokenLoginError, Options<PostApiV1AuthTokenLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAuthTokenLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Login
 *
 * Login user and authorize. Returns **fresh** access and refresh tokens
 * and sets access/refresh cookies - unless MFA applies to this account,
 * in which case a challenge is returned instead (see `status` field) and
 * the client must complete it via the `/mfa` endpoints before it has
 * tokens. The access token expires in 15 minutes, and the refresh token
 * is valid for 60 minutes.
 *
 * <br /> **Rate Limited:** Protected against brute-force attacks.  Maximum **20 failed attempts**  per **15 minutes**  per username. Exceeding triggers exponential backoff  (starting at 60 seconds,  up to 1 hours).  Successful login resets the counter.
 */
export const apiPostAuthLoginMutation = (options?: Partial<Options<PostApiV1AuthLoginData>>): UseMutationOptions<PostApiV1AuthLoginResponse, PostApiV1AuthLoginError, Options<PostApiV1AuthLoginData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuthLoginResponse, PostApiV1AuthLoginError, Options<PostApiV1AuthLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAuthLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Service Login
 *
 * Exchange a service-account API key for a **non-fresh** access token
 * (OAuth2 client-credentials style). The token expires in 15 minutes;
 * re-exchange before expiry. No refresh token and no cookies are issued —
 * header-only clients.
 *
 * **Rate Limited:** **20 failed attempts** per **15 minutes** per API
 * key lock that key out with exponential backoff; a successful exchange
 * resets the counter. A key matching no account is not counted, since the
 * caller's address is attacker-chosen and the key's entropy is what stops
 * guessing.
 */
export const apiPostAuthServiceLoginMutation = (options?: Partial<Options<PostApiV1AuthServiceLoginData>>): UseMutationOptions<PostApiV1AuthServiceLoginResponse, PostApiV1AuthServiceLoginError, Options<PostApiV1AuthServiceLoginData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuthServiceLoginResponse, PostApiV1AuthServiceLoginError, Options<PostApiV1AuthServiceLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAuthServiceLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Fresh Login
 *
 * Fresh user login (re-authentication). Returns a **fresh** access token
 * and sets cookies - unless MFA applies, in which case a challenge is
 * returned instead (see `status` field); completing it via `/mfa/
 * challenge/verify` issues a fresh access token only, same as this
 * endpoint would. Unlike the standard `login` endpoint, this never
 * returns a new refresh token. The fresh access token expires in 15
 * minutes.
 *
 * <br /> **Rate Limited:** Protected against brute-force attacks.  Maximum **20 failed attempts**  per **15 minutes**  per username. Exceeding triggers exponential backoff  (starting at 60 seconds,  up to 1 hours).  Successful login resets the counter.
 */
export const apiPostAuthFreshLoginMutation = (options?: Partial<Options<PostApiV1AuthFreshLoginData>>): UseMutationOptions<PostApiV1AuthFreshLoginResponse, PostApiV1AuthFreshLoginError, Options<PostApiV1AuthFreshLoginData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuthFreshLoginResponse, PostApiV1AuthFreshLoginError, Options<PostApiV1AuthFreshLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAuthFreshLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const apiGetAuthRefreshQueryKey = (options?: Options<GetApiV1AuthRefreshData>) => createQueryKey('getApiV1AuthRefresh', options);

/**
 * Refresh Token
 *
 * Refresh user token and cookies. Returns a **not fresh** access token and a
 * new refresh token. Each refresh token can be used exactly once - after a
 * successful refresh, the previous refresh token is immediately invalidated.
 * Store the returned `refresh_token` and use it for the next refresh call.
 * A refresh counts as a login for the inactivity check and ends a password
 * reset the user asked for, but not one an admin requested.
 * The access token expires in 15 minutes, and the new refresh token is
 * valid for 60 minutes.
 */
export const apiGetAuthRefreshOptions = (options?: Options<GetApiV1AuthRefreshData>) => queryOptions<GetApiV1AuthRefreshResponse, GetApiV1AuthRefreshError, GetApiV1AuthRefreshResponse, ReturnType<typeof apiGetAuthRefreshQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuthRefresh({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuthRefreshQueryKey(options)
});

export const apiGetAuthIsFreshQueryKey = (options?: Options<GetApiV1AuthIsFreshData>) => createQueryKey('getApiV1AuthIsFresh', options);

/**
 * Is Fresh
 *
 * Check whether the access token of the current user is **fresh** or not.
 */
export const apiGetAuthIsFreshOptions = (options?: Options<GetApiV1AuthIsFreshData>) => queryOptions<GetApiV1AuthIsFreshResponse, GetApiV1AuthIsFreshError, GetApiV1AuthIsFreshResponse, ReturnType<typeof apiGetAuthIsFreshQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuthIsFresh({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuthIsFreshQueryKey(options)
});

export const apiGetAuthLogoutQueryKey = (options?: Options<GetApiV1AuthLogoutData>) => createQueryKey('getApiV1AuthLogout', options);

/**
 * Logout
 *
 * Logout user. This endpoint un-sets cookies and revokes access and refresh
 * tokens.
 */
export const apiGetAuthLogoutOptions = (options?: Options<GetApiV1AuthLogoutData>) => queryOptions<GetApiV1AuthLogoutResponse, GetApiV1AuthLogoutError, GetApiV1AuthLogoutResponse, ReturnType<typeof apiGetAuthLogoutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuthLogout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuthLogoutQueryKey(options)
});

export const apiGetAuthLogoutAllQueryKey = (options?: Options<GetApiV1AuthLogoutAllData>) => createQueryKey('getApiV1AuthLogoutAll', options);

/**
 * Logout All
 *
 * Logout user from **all** active sessions. This invalidates every access
 * and refresh token issued to this user up to this point, regardless of
 * device or client. Also un-sets cookies for the current session.
 *
 * This works by storing the current timestamp. Any token issued at
 * or before this timestamp will be treated as revoked. The Redis key expires
 * after the refresh token lifetime and is cleaned up automatically.
 */
export const apiGetAuthLogoutAllOptions = (options?: Options<GetApiV1AuthLogoutAllData>) => queryOptions<GetApiV1AuthLogoutAllResponse, GetApiV1AuthLogoutAllError, GetApiV1AuthLogoutAllResponse, ReturnType<typeof apiGetAuthLogoutAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuthLogoutAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuthLogoutAllQueryKey(options)
});

export const apiGetAuthAdminLogoutByUuidQueryKey = (options: Options<GetApiV1AuthAdminLogoutByUuidData>) => createQueryKey('getApiV1AuthAdminLogoutByUuid', options);

/**
 * Admin Logout User
 *
 * Admin endpoint to logout a user (or service account) from **all** active
 * sessions by their UUID. This invalidates every access and refresh token
 * issued to the target account up to this point.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiGetAuthAdminLogoutByUuidOptions = (options: Options<GetApiV1AuthAdminLogoutByUuidData>) => queryOptions<GetApiV1AuthAdminLogoutByUuidResponse, GetApiV1AuthAdminLogoutByUuidError, GetApiV1AuthAdminLogoutByUuidResponse, ReturnType<typeof apiGetAuthAdminLogoutByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuthAdminLogoutUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuthAdminLogoutByUuidQueryKey(options)
});

/**
 * Revoke Access Token
 *
 * Revoke access token for the current user.
 */
export const apiDeleteAuthAccessRevokeMutation = (options?: Partial<Options<DeleteApiV1AuthAccessRevokeData>>): UseMutationOptions<DeleteApiV1AuthAccessRevokeResponse, DeleteApiV1AuthAccessRevokeError, Options<DeleteApiV1AuthAccessRevokeData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1AuthAccessRevokeResponse, DeleteApiV1AuthAccessRevokeError, Options<DeleteApiV1AuthAccessRevokeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteAuthAccessRevoke({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Refresh Token
 *
 * Revoke refresh token for the current user.
 */
export const apiDeleteAuthRefreshRevokeMutation = (options?: Partial<Options<DeleteApiV1AuthRefreshRevokeData>>): UseMutationOptions<DeleteApiV1AuthRefreshRevokeResponse, DeleteApiV1AuthRefreshRevokeError, Options<DeleteApiV1AuthRefreshRevokeData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1AuthRefreshRevokeResponse, DeleteApiV1AuthRefreshRevokeError, Options<DeleteApiV1AuthRefreshRevokeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteAuthRefreshRevoke({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetUsersMeQueryKey = (options?: Options<GetApiV1UsersMeData>) => createQueryKey('getApiV1UsersMe', options);

/**
 * Get Me
 *
 * Get the current user. Humans only — the response schemas are
 * human-shaped; service accounts introspect via
 * `GET /service-accounts/me`.
 */
export const apiGetUsersMeOptions = (options?: Options<GetApiV1UsersMeData>) => queryOptions<GetApiV1UsersMeResponse, GetApiV1UsersMeError, GetApiV1UsersMeResponse, ReturnType<typeof apiGetUsersMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetUsersMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetUsersMeQueryKey(options)
});

/**
 * Forgot Password
 *
 * Ask for a password reset for a given email. This puts a user connected to
 * the provided email into a reset, keeping an admin's reset or a deactivation
 * as it is. This endpoint sends a reset mail to
 * the given user's email that includes an URL pointing to the `reset-password`
 * endpoint, including encoded one-time tokens.  The email is sent using API
 * background tasks and this endpoint return a task ID, which then might be
 * inquired for status using the `tasks/api/status/` endpoint. The token
 * expires after 12:00:00 hours.
 */
export const apiPutUsersForgotPasswordMutation = (options?: Partial<Options<PutApiV1UsersForgotPasswordData>>): UseMutationOptions<PutApiV1UsersForgotPasswordResponse, PutApiV1UsersForgotPasswordError, Options<PutApiV1UsersForgotPasswordData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UsersForgotPasswordResponse, PutApiV1UsersForgotPasswordError, Options<PutApiV1UsersForgotPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutUsersForgotPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset Password
 *
 * Reset password. To be used after obtaining tokens from the `forgot_password`
 * endpoint.
 */
export const apiPutUsersResetPasswordMutation = (options?: Partial<Options<PutApiV1UsersResetPasswordData>>): UseMutationOptions<PutApiV1UsersResetPasswordResponse, PutApiV1UsersResetPasswordError, Options<PutApiV1UsersResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UsersResetPasswordResponse, PutApiV1UsersResetPasswordError, Options<PutApiV1UsersResetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutUsersResetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change Password
 *
 * Change the password of the current user.
 */
export const apiPutUsersChangePasswordMutation = (options?: Partial<Options<PutApiV1UsersChangePasswordData>>): UseMutationOptions<PutApiV1UsersChangePasswordResponse, PutApiV1UsersChangePasswordError, Options<PutApiV1UsersChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UsersChangePasswordResponse, PutApiV1UsersChangePasswordError, Options<PutApiV1UsersChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutUsersChangePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetUsersQueryKey = (options?: Options<GetApiV1UsersData>) => createQueryKey('getApiV1Users', options);

/**
 * Get Users
 *
 * Get the list of all users. For monitoring users querying, returns users with
 * self-visibility only and if the role is managing, will also filter on
 * connected patient ID based on patient visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetUsersOptions = (options?: Options<GetApiV1UsersData>) => queryOptions<GetApiV1UsersResponse, GetApiV1UsersError, GetApiV1UsersResponse, ReturnType<typeof apiGetUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetUsersQueryKey(options)
});

/**
 * Create User
 *
 * Create a new user. Passwords are validated and must have at least 10
 * characters and contain at least one uppercase letter, one lowercase letter,
 * and one digit. The role's default permissions must be within the ones you
 * hold yourself (`403` otherwise).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostUsersMutation = (options?: Partial<Options<PostApiV1UsersData>>): UseMutationOptions<PostApiV1UsersResponse, PostApiV1UsersError, Options<PostApiV1UsersData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1UsersResponse, PostApiV1UsersError, Options<PostApiV1UsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetUsersPhysiciansQueryKey = (options?: Options<GetApiV1UsersPhysiciansData>) => createQueryKey('getApiV1UsersPhysicians', options);

/**
 * Get Physicians
 *
 * Get the list of all users that are in the patient managing role (i.e., their
 * data-visibility access is **managed**). Full-visibility users see all such
 * users; other users see only users whose connected physician is within their
 * visibility scope (assigned physicians, assigned clinics' physicians, or
 * physicians in their regions), i.e. users without a connected physician are
 * not listed for them.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetUsersPhysiciansOptions = (options?: Options<GetApiV1UsersPhysiciansData>) => queryOptions<GetApiV1UsersPhysiciansResponse, GetApiV1UsersPhysiciansError, GetApiV1UsersPhysiciansResponse, ReturnType<typeof apiGetUsersPhysiciansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetUsersPhysicians({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetUsersPhysiciansQueryKey(options)
});

export const apiGetUsersMonitoringUsersQueryKey = (options?: Options<GetApiV1UsersMonitoringUsersData>) => createQueryKey('getApiV1UsersMonitoringUsers', options);

/**
 * Get Monitoring Users
 *
 * Get the list of monitoring users, i.e. users that have access policies
 * with monitoring_active=True and appropriate permissions. Optional query
 * parameters can filter by country (via the countries array) and/or region
 * (integer ID within the given country, requires country). This endpoint
 * cannot be called by a **self-only** user role nor a screening account.
 * Full-visibility users see every monitoring user, i.e. the users eligible
 * now, not only existing assignments; other users see only those already
 * assigned to a physician or clinic within their visibility scope, or to a
 * physician of a patient within it, those managing a patient within it, and
 * those whose access policy lists a physician, clinic or region within it.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetUsersMonitoringUsersOptions = (options?: Options<GetApiV1UsersMonitoringUsersData>) => queryOptions<GetApiV1UsersMonitoringUsersResponse, GetApiV1UsersMonitoringUsersError, GetApiV1UsersMonitoringUsersResponse, ReturnType<typeof apiGetUsersMonitoringUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetUsersMonitoringUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetUsersMonitoringUsersQueryKey(options)
});

/**
 * Reset User
 *
 * Reset the user given its UUID. Non-admin users (monitoring access) can only
 * reset users with **lower access**, admins can reset **anyone**. Resetting a
 * user updates their status. Optionally, send reset email to the user. This
 * endpoint raises exception when used on protected users.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutUsersResetByUuidMutation = (options?: Partial<Options<PutApiV1UsersResetByUuidData>>): UseMutationOptions<PutApiV1UsersResetByUuidResponse, PutApiV1UsersResetByUuidError, Options<PutApiV1UsersResetByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UsersResetByUuidResponse, PutApiV1UsersResetByUuidError, Options<PutApiV1UsersResetByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutUsersResetUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Temporary Password
 *
 * Create a temporary password for a given user by its UUID. Temporary password
 * is created from one adjective, two nouns at random from a predefined
 * dictionary of most used words (localized to the user's preferred language),
 * and random number of digits. Temporary password must be changed by the user
 * (using the `/users/change-password` endpoint, before the expiry). For
 * `token_expiry_timedelta`, we use `timedelta` data type, which`pydantic`
 * (de)serializes to JSON using ISO 8601 standard on durations (see
 * [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutUsersTemporaryPassByUuidMutation = (options?: Partial<Options<PutApiV1UsersTemporaryPassByUuidData>>): UseMutationOptions<PutApiV1UsersTemporaryPassByUuidResponse, PutApiV1UsersTemporaryPassByUuidError, Options<PutApiV1UsersTemporaryPassByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UsersTemporaryPassByUuidResponse, PutApiV1UsersTemporaryPassByUuidError, Options<PutApiV1UsersTemporaryPassByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutUsersTemporaryPassUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetUsersByUuidDeleteImpactQueryKey = (options: Options<GetApiV1UsersByUuidDeleteImpactData>) => createQueryKey('getApiV1UsersByUuidDeleteImpact', options);

/**
 * Get Delete Impact
 *
 * Report what deleting this user would do, counted per category. `blockers`
 * refuse the `DELETE` outright; `requires_archive_first` refuses it until the
 * account is archived. `423` on protected users, as the `DELETE` answers.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiGetUsersByUuidDeleteImpactOptions = (options: Options<GetApiV1UsersByUuidDeleteImpactData>) => queryOptions<GetApiV1UsersByUuidDeleteImpactResponse, GetApiV1UsersByUuidDeleteImpactError, GetApiV1UsersByUuidDeleteImpactResponse, ReturnType<typeof apiGetUsersByUuidDeleteImpactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetUsersUuidDeleteImpact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetUsersByUuidDeleteImpactQueryKey(options)
});

/**
 * Archive User
 *
 * Archive the user given its UUID: the row stays, the account dies. `409`
 * when it is already archived or is a patient user (self-only visibility),
 * who is deleted instead; `403` on the caller's own account, `423` on
 * protected users. Service accounts they own are flagged
 * `owner_deactivated`, the same as deactivating or deleting the owner.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutUsersByUuidArchiveMutation = (options?: Partial<Options<PutApiV1UsersByUuidArchiveData>>): UseMutationOptions<PutApiV1UsersByUuidArchiveResponse, PutApiV1UsersByUuidArchiveError, Options<PutApiV1UsersByUuidArchiveData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UsersByUuidArchiveResponse, PutApiV1UsersByUuidArchiveError, Options<PutApiV1UsersByUuidArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutUsersUuidArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unarchive User
 *
 * Bring an archived user back as far as an admin password reset; what
 * archival stripped is **not** restored. `409` when the user is not archived.
 * Service accounts they own that were flagged `owner_deactivated` go back
 * to `active`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutUsersByUuidUnarchiveMutation = (options?: Partial<Options<PutApiV1UsersByUuidUnarchiveData>>): UseMutationOptions<PutApiV1UsersByUuidUnarchiveResponse, PutApiV1UsersByUuidUnarchiveError, Options<PutApiV1UsersByUuidUnarchiveData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UsersByUuidUnarchiveResponse, PutApiV1UsersByUuidUnarchiveError, Options<PutApiV1UsersByUuidUnarchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutUsersUuidUnarchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete User
 *
 * Delete the user given its UUID. `409` with the `delete-impact` report under
 * `data` when rows block the delete, or when a staff user with an attribution
 * trail is not archived yet; `423` on protected users. Service accounts they
 * own are flagged `owner_deactivated` first — `owner_uuid` is `ON DELETE SET
 * NULL`, so an unflagged account would become indistinguishable from an
 * org-owned one while still holding the deleted user's visibility snapshot.
 * Ones already switched off (`not_active`) are retired: they cannot carry
 * the flag, which is a usable status.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteUsersByUuidMutation = (options?: Partial<Options<DeleteApiV1UsersByUuidData>>): UseMutationOptions<DeleteApiV1UsersByUuidResponse, DeleteApiV1UsersByUuidError, Options<DeleteApiV1UsersByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1UsersByUuidResponse, DeleteApiV1UsersByUuidError, Options<DeleteApiV1UsersByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteUsersUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update User
 *
 * Update/edit the user given its UUID. Update schema can also append patient
 * ID to the list of managed patient IDs if the updated user is in the
 * **managed** user role. This endpoint raises exception when used on protected
 * users.
 *
 * **Warning**: if username is the same as email in the original user being
 * updated, and update changes one of these, both username and email will be
 * updated accordingly! When both `email` and `username` are part of update
 * body, `username` has preference. Note, that when changing username, the
 * check on uniqueness is performed as usernames must be unique. Setting an
 * `email` another user holds needs admin access, `409` otherwise.
 *
 * **Physicians and clinics**: a newly assigned physician (`physicians` or
 * `append_physicians`) or clinic (`clinics` or `append_clinics`) gets the
 * monitoring-user checks of `PUT /physicians/{uuid}` or
 * `PUT /clinics/{uuid}`: `405` for a user without visibility over it, before
 * any write. Those already assigned are not re-checked.
 *
 * **Feature flags**: a payload containing only `feature_flags`, targeting a
 * user with a connected patient, is also allowed for a non-admin caller who
 * has medical-update permission and visibility over that patient. A user
 * without a connected patient (physician, staff) can only have their flags
 * set by an admin, including by themselves. Each flag also carries a
 * `user_editable` bit: a user updating their own flags may only change
 * those currently marked user-editable; changing `user_editable` itself,
 * or a locked flag's value, requires staff-level (monitoring) permission
 * or higher. Sent flag sub-fields that already match the current state
 * are treated as not sent, so round-tripping a previously fetched object
 * back is a no-op rather than a permission error.
 *
 * **Fresh token**: sending `username`, `email`, `role`, or
 * `connected_patient_id` requires a **fresh** access token; any other
 * payload does not.
 */
export const apiPutUsersByUuidMutation = (options?: Partial<Options<PutApiV1UsersByUuidData>>): UseMutationOptions<PutApiV1UsersByUuidResponse, PutApiV1UsersByUuidError, Options<PutApiV1UsersByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1UsersByUuidResponse, PutApiV1UsersByUuidError, Options<PutApiV1UsersByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutUsersUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Totp Enroll Start
 *
 * Begin TOTP enrollment. Generates a new secret and returns its
 * provisioning URI (as text and as a QR code) - the secret is not
 * persisted until confirmed with a valid code via `/enroll/totp/confirm`.
 */
export const apiPostMfaEnrollTotpStartMutation = (options?: Partial<Options<PostApiV1MfaEnrollTotpStartData>>): UseMutationOptions<PostApiV1MfaEnrollTotpStartResponse, PostApiV1MfaEnrollTotpStartError, Options<PostApiV1MfaEnrollTotpStartData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaEnrollTotpStartResponse, PostApiV1MfaEnrollTotpStartError, Options<PostApiV1MfaEnrollTotpStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaEnrollTotpStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Totp Enroll Confirm
 *
 * Confirm TOTP enrollment: verify the first code against the secret from
 * `/enroll/totp/start`, persist the encrypted secret, and generate backup
 * codes on first-ever enrollment (shown once). The voluntary (settings)
 * path may also replace an already-enrolled secret - a mandatory-path
 * submission against an already-enrolled account is instead rejected by
 * `_resolve_enrolling_user` before this function is ever reached. If this
 * completes a login-time mandatory enrollment, also mints tokens and
 * consumes the enrollment challenge.
 */
export const apiPostMfaEnrollTotpConfirmMutation = (options?: Partial<Options<PostApiV1MfaEnrollTotpConfirmData>>): UseMutationOptions<PostApiV1MfaEnrollTotpConfirmResponse, PostApiV1MfaEnrollTotpConfirmError, Options<PostApiV1MfaEnrollTotpConfirmData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaEnrollTotpConfirmResponse, PostApiV1MfaEnrollTotpConfirmError, Options<PostApiV1MfaEnrollTotpConfirmData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaEnrollTotpConfirm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sms Enroll Start
 *
 * Begin SMS enrollment: send a code to the given number. The number is
 * held with the code until `/enroll/sms/confirm` proves possession, and
 * only then written to the account.
 */
export const apiPostMfaEnrollSmsStartMutation = (options?: Partial<Options<PostApiV1MfaEnrollSmsStartData>>): UseMutationOptions<PostApiV1MfaEnrollSmsStartResponse, PostApiV1MfaEnrollSmsStartError, Options<PostApiV1MfaEnrollSmsStartData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaEnrollSmsStartResponse, PostApiV1MfaEnrollSmsStartError, Options<PostApiV1MfaEnrollSmsStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaEnrollSmsStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sms Enroll Confirm
 *
 * Confirm SMS enrollment with the code from `/enroll/sms/start`: writes
 * the verified number and switches the method on, generating backup codes
 * on first-ever enrollment. Completes the login when it finishes a
 * mandatory enrollment challenge.
 */
export const apiPostMfaEnrollSmsConfirmMutation = (options?: Partial<Options<PostApiV1MfaEnrollSmsConfirmData>>): UseMutationOptions<PostApiV1MfaEnrollSmsConfirmResponse, PostApiV1MfaEnrollSmsConfirmError, Options<PostApiV1MfaEnrollSmsConfirmData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaEnrollSmsConfirmResponse, PostApiV1MfaEnrollSmsConfirmError, Options<PostApiV1MfaEnrollSmsConfirmData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaEnrollSmsConfirm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Regenerate Backup Codes
 *
 * Regenerate backup codes. Invalidates all previous codes. Requires a
 * fresh token, same as other sensitive account-security operations.
 * Requires an already-enrolled primary method (TOTP, passkey or SMS) - a
 * login challenge only ever offers `backup_code` alongside one of those
 * (see `enrolled_methods`), so codes issued without one could never
 * actually be used to complete a login.
 */
export const apiPostMfaBackupCodesRegenerateMutation = (options?: Partial<Options<PostApiV1MfaBackupCodesRegenerateData>>): UseMutationOptions<PostApiV1MfaBackupCodesRegenerateResponse, DefaultError, Options<PostApiV1MfaBackupCodesRegenerateData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaBackupCodesRegenerateResponse, DefaultError, Options<PostApiV1MfaBackupCodesRegenerateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaBackupCodesRegenerate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify Challenge
 *
 * Verify an MFA code against a login-time challenge and, on success, mint
 * tokens. Rate-limited per challenge (`MFA_MAX_VERIFY_ATTEMPTS`); once
 * exhausted the challenge is discarded and the client must restart from
 * `/auth/login`.
 */
export const apiPostMfaChallengeVerifyMutation = (options?: Partial<Options<PostApiV1MfaChallengeVerifyData>>): UseMutationOptions<PostApiV1MfaChallengeVerifyResponse, PostApiV1MfaChallengeVerifyError, Options<PostApiV1MfaChallengeVerifyData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaChallengeVerifyResponse, PostApiV1MfaChallengeVerifyError, Options<PostApiV1MfaChallengeVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaChallengeVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sms Challenge Send
 *
 * Text a code for a login-time challenge that offers SMS. Nothing is sent
 * until the user asks, and a resend never resets the challenge's failed
 * attempts. Cooldown and caps answer `200` with `sent: false`.
 */
export const apiPostMfaChallengeSmsSendMutation = (options?: Partial<Options<PostApiV1MfaChallengeSmsSendData>>): UseMutationOptions<PostApiV1MfaChallengeSmsSendResponse, PostApiV1MfaChallengeSmsSendError, Options<PostApiV1MfaChallengeSmsSendData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaChallengeSmsSendResponse, PostApiV1MfaChallengeSmsSendError, Options<PostApiV1MfaChallengeSmsSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaChallengeSmsSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webauthn Enroll Options
 */
export const apiPostMfaEnrollWebauthnOptionsMutation = (options?: Partial<Options<PostApiV1MfaEnrollWebauthnOptionsData>>): UseMutationOptions<PostApiV1MfaEnrollWebauthnOptionsResponse, PostApiV1MfaEnrollWebauthnOptionsError, Options<PostApiV1MfaEnrollWebauthnOptionsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaEnrollWebauthnOptionsResponse, PostApiV1MfaEnrollWebauthnOptionsError, Options<PostApiV1MfaEnrollWebauthnOptionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaEnrollWebauthnOptions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webauthn Enroll Verify
 */
export const apiPostMfaEnrollWebauthnVerifyMutation = (options?: Partial<Options<PostApiV1MfaEnrollWebauthnVerifyData>>): UseMutationOptions<PostApiV1MfaEnrollWebauthnVerifyResponse, PostApiV1MfaEnrollWebauthnVerifyError, Options<PostApiV1MfaEnrollWebauthnVerifyData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaEnrollWebauthnVerifyResponse, PostApiV1MfaEnrollWebauthnVerifyError, Options<PostApiV1MfaEnrollWebauthnVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaEnrollWebauthnVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webauthn Challenge Options
 */
export const apiPostMfaChallengeWebauthnOptionsMutation = (options?: Partial<Options<PostApiV1MfaChallengeWebauthnOptionsData>>): UseMutationOptions<PostApiV1MfaChallengeWebauthnOptionsResponse, PostApiV1MfaChallengeWebauthnOptionsError, Options<PostApiV1MfaChallengeWebauthnOptionsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaChallengeWebauthnOptionsResponse, PostApiV1MfaChallengeWebauthnOptionsError, Options<PostApiV1MfaChallengeWebauthnOptionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaChallengeWebauthnOptions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Webauthn Challenge Verify
 */
export const apiPostMfaChallengeWebauthnVerifyMutation = (options?: Partial<Options<PostApiV1MfaChallengeWebauthnVerifyData>>): UseMutationOptions<PostApiV1MfaChallengeWebauthnVerifyResponse, PostApiV1MfaChallengeWebauthnVerifyError, Options<PostApiV1MfaChallengeWebauthnVerifyData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaChallengeWebauthnVerifyResponse, PostApiV1MfaChallengeWebauthnVerifyError, Options<PostApiV1MfaChallengeWebauthnVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaChallengeWebauthnVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMfaStatusQueryKey = (options?: Options<GetApiV1MfaStatusData>) => createQueryKey('getApiV1MfaStatus', options);

/**
 * Mfa Status
 */
export const apiGetMfaStatusOptions = (options?: Options<GetApiV1MfaStatusData>) => queryOptions<GetApiV1MfaStatusResponse, DefaultError, GetApiV1MfaStatusResponse, ReturnType<typeof apiGetMfaStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMfaStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMfaStatusQueryKey(options)
});

/**
 * Remove Totp
 */
export const apiDeleteMfaTotpMutation = (options?: Partial<Options<DeleteApiV1MfaTotpData>>): UseMutationOptions<DeleteApiV1MfaTotpResponse, DefaultError, Options<DeleteApiV1MfaTotpData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MfaTotpResponse, DefaultError, Options<DeleteApiV1MfaTotpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMfaTotp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Passkey
 */
export const apiDeleteMfaWebauthnByCredentialUuidMutation = (options?: Partial<Options<DeleteApiV1MfaWebauthnByCredentialUuidData>>): UseMutationOptions<DeleteApiV1MfaWebauthnByCredentialUuidResponse, DeleteApiV1MfaWebauthnByCredentialUuidError, Options<DeleteApiV1MfaWebauthnByCredentialUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MfaWebauthnByCredentialUuidResponse, DeleteApiV1MfaWebauthnByCredentialUuidError, Options<DeleteApiV1MfaWebauthnByCredentialUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMfaWebauthnCredentialUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Sms
 *
 * Switch SMS off as a factor. The verified number stays on the account -
 * it may still be the patient's login identity.
 */
export const apiDeleteMfaSmsMutation = (options?: Partial<Options<DeleteApiV1MfaSmsData>>): UseMutationOptions<DeleteApiV1MfaSmsResponse, DefaultError, Options<DeleteApiV1MfaSmsData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MfaSmsResponse, DefaultError, Options<DeleteApiV1MfaSmsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMfaSms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Reset Mfa
 *
 * Admin recovery path for a user who has lost every MFA method. Clears
 * all enrolled methods (next login will require re-enrollment), clears
 * any active per-user verify lockout (otherwise the freshly-cleared
 * account still can't complete that re-enrollment), and revokes all of
 * the user's existing sessions. Requires a fresh token from the acting
 * admin - this is the single most destructive MFA action in the system,
 * and `@auth_permissions_doc(..., fresh=True)` alone only feeds the
 * generated docs, it doesn't enforce anything.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostMfaAdminResetByUuidMutation = (options?: Partial<Options<PostApiV1MfaAdminResetByUuidData>>): UseMutationOptions<PostApiV1MfaAdminResetByUuidResponse, PostApiV1MfaAdminResetByUuidError, Options<PostApiV1MfaAdminResetByUuidData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MfaAdminResetByUuidResponse, PostApiV1MfaAdminResetByUuidError, Options<PostApiV1MfaAdminResetByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMfaAdminResetUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetServiceAccountsQueryKey = (options?: Options<GetApiV1ServiceAccountsData>) => createQueryKey('getApiV1ServiceAccounts', options);

/**
 * List Service Accounts
 *
 * Admin-only: list every service account with its key metadata.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetServiceAccountsOptions = (options?: Options<GetApiV1ServiceAccountsData>) => queryOptions<GetApiV1ServiceAccountsResponse, GetApiV1ServiceAccountsError, GetApiV1ServiceAccountsResponse, ReturnType<typeof apiGetServiceAccountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetServiceAccounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetServiceAccountsQueryKey(options)
});

/**
 * Create Service Account
 *
 * Admin-only: create an org- or user-owned service account with custom
 * permission bits and visibility. FORBIDDEN_SERVICE_PERMISSIONS are
 * rejected (422, via the schema's own validator), and bits you do not
 * hold yourself are refused (403). A named owner must be a live human
 * (409): an account handed to a deactivated one would be invisible to
 * the owner-lifecycle hooks.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostServiceAccountsMutation = (options?: Partial<Options<PostApiV1ServiceAccountsData>>): UseMutationOptions<PostApiV1ServiceAccountsResponse, PostApiV1ServiceAccountsError, Options<PostApiV1ServiceAccountsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ServiceAccountsResponse, PostApiV1ServiceAccountsError, Options<PostApiV1ServiceAccountsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostServiceAccounts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Service Account Status
 *
 * Admin-only: set a service account's status. Any status other than
 * `active` kills every outstanding token with the commit and refuses
 * new exchanges: authz re-reads the status on each request. `retired`
 * is terminal (409 on any change out of it); `not_active` is the
 * reversible kill-switch. Clearing `owner_deactivated` with `active`
 * is refused (409) while the owner is still deactivated or archived —
 * the same rule `PUT /owner` applies to a named heir, and refused
 * outright once the owner is deleted — `PUT /owner` is the only way
 * out then. Un-parking a `not_active` account is not refused: it
 * carries no flag to clear. Reviving an account whose bits reach past
 * the caller's own is refused (403) - its keys come back with it.
 * A protected account cannot be retired (423); `not_active` still kills it.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutServiceAccountsByServiceAccountUuidStatusMutation = (options?: Partial<Options<PutApiV1ServiceAccountsByServiceAccountUuidStatusData>>): UseMutationOptions<PutApiV1ServiceAccountsByServiceAccountUuidStatusResponse, PutApiV1ServiceAccountsByServiceAccountUuidStatusError, Options<PutApiV1ServiceAccountsByServiceAccountUuidStatusData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ServiceAccountsByServiceAccountUuidStatusResponse, PutApiV1ServiceAccountsByServiceAccountUuidStatusError, Options<PutApiV1ServiceAccountsByServiceAccountUuidStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutServiceAccountsServiceAccountUuidStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Service Account Owner
 *
 * Admin-only: hand a service account to another human, or to nobody
 * (`null`, org-owned). A named owner also clears `owner_deactivated`
 * back to `active`, which is bounded like `/status`: reviving a machine
 * the caller cannot use is refused. Keys and permissions are untouched,
 * so a handover prompted by losing trust in the previous owner has to
 * be paired with `DELETE /service-accounts/keys/{key_uuid}`; bits the
 * new owner does not hold are logged and audited as
 * `exceeds_new_owner`. `retired` accounts still change hands: the
 * status is terminal, the attribution is not.
 *
 * The new owner must be a live human - a machine may not own a machine
 * (404), and a deactivated human would leave the account un-flagged
 * with nobody to review it (409). Naming *yourself* on an account whose
 * bits reach past your own is refused (403): ownership is a key away.
 * A protected account stays org-owned: naming an owner is refused (423),
 * since the owner's deletion would retire it once parked.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutServiceAccountsByServiceAccountUuidOwnerMutation = (options?: Partial<Options<PutApiV1ServiceAccountsByServiceAccountUuidOwnerData>>): UseMutationOptions<PutApiV1ServiceAccountsByServiceAccountUuidOwnerResponse, PutApiV1ServiceAccountsByServiceAccountUuidOwnerError, Options<PutApiV1ServiceAccountsByServiceAccountUuidOwnerData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ServiceAccountsByServiceAccountUuidOwnerResponse, PutApiV1ServiceAccountsByServiceAccountUuidOwnerError, Options<PutApiV1ServiceAccountsByServiceAccountUuidOwnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutServiceAccountsServiceAccountUuidOwner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetServiceAccountsSelfQueryKey = (options?: Options<GetApiV1ServiceAccountsSelfData>) => createQueryKey('getApiV1ServiceAccountsSelf', options);

/**
 * List Own Service Accounts
 *
 * List service accounts owned by the caller, with their key metadata.
 * Needs no permission bits: for a non-admin owner this is the only
 * source of a `key_uuid`, and losing `CREATE_SERVICE_ACCOUNTS` must
 * not cost the ability to revoke a key already issued.
 */
export const apiGetServiceAccountsSelfOptions = (options?: Options<GetApiV1ServiceAccountsSelfData>) => queryOptions<GetApiV1ServiceAccountsSelfResponse, GetApiV1ServiceAccountsSelfError, GetApiV1ServiceAccountsSelfResponse, ReturnType<typeof apiGetServiceAccountsSelfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetServiceAccountsSelf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetServiceAccountsSelfQueryKey(options)
});

/**
 * Create Own Service Account
 *
 * Self-service create: owner is always the caller. Granted permissions
 * are the service template intersected with the caller's own resolved
 * bits (an account can never exceed its creator); visibility is copied
 * (snapshot, not live-linked) from the caller's policy at creation time.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Create Service Accounts (53)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostServiceAccountsSelfMutation = (options?: Partial<Options<PostApiV1ServiceAccountsSelfData>>): UseMutationOptions<PostApiV1ServiceAccountsSelfResponse, PostApiV1ServiceAccountsSelfError, Options<PostApiV1ServiceAccountsSelfData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ServiceAccountsSelfResponse, PostApiV1ServiceAccountsSelfError, Options<PostApiV1ServiceAccountsSelfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostServiceAccountsSelf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetServiceAccountsMeQueryKey = (options?: Options<GetApiV1ServiceAccountsMeData>) => createQueryKey('getApiV1ServiceAccountsMe', options);

/**
 * Get Service Account Me
 *
 * Identity of the calling service account — the machine-side
 * counterpart of `GET /users/me`, which serves human-shaped schemas
 * and so rejects service tokens. Requires no permission bits.
 */
export const apiGetServiceAccountsMeOptions = (options?: Options<GetApiV1ServiceAccountsMeData>) => queryOptions<GetApiV1ServiceAccountsMeResponse, GetApiV1ServiceAccountsMeError, GetApiV1ServiceAccountsMeResponse, ReturnType<typeof apiGetServiceAccountsMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetServiceAccountsMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetServiceAccountsMeQueryKey(options)
});

/**
 * Issue Api Key
 *
 * Issue a new API key (admin, or an owner who still holds
 * `CREATE_SERVICE_ACCOUNTS`). On **both** arms the caller must hold
 * every bit the account holds (403): the key is a login as that account,
 * so minting one for a wider account is the grant `POST
 * /service-accounts/` refuses, taken from a row instead of a payload.
 * Bounding the admin arm alone left the refusal four calls away — mint a
 * user at your own level, grant it `CREATE_SERVICE_ACCOUNTS`, hand the
 * account to it, issue the key as it — so an owner narrower than the
 * account it owns can no longer rotate its keys; an admin who does hold
 * the bits still can.
 * Rejects a 3rd active key (409) — revoke
 * one first. Plaintext is returned exactly once, here. An account in
 * any status but `active` is refused (409) — `owner_deactivated`
 * included: the flag keeps existing keys working, it does not license a
 * new 365-day one behind an owner who is gone.
 */
export const apiPostServiceAccountsByServiceAccountUuidKeysMutation = (options?: Partial<Options<PostApiV1ServiceAccountsByServiceAccountUuidKeysData>>): UseMutationOptions<PostApiV1ServiceAccountsByServiceAccountUuidKeysResponse, PostApiV1ServiceAccountsByServiceAccountUuidKeysError, Options<PostApiV1ServiceAccountsByServiceAccountUuidKeysData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ServiceAccountsByServiceAccountUuidKeysResponse, PostApiV1ServiceAccountsByServiceAccountUuidKeysError, Options<PostApiV1ServiceAccountsByServiceAccountUuidKeysData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostServiceAccountsServiceAccountUuidKeys({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Api Key
 *
 * Revoke a key (admin or the account's owner) and kill the outstanding
 * sessions minted from it. Scoped to this key, so retiring one half of
 * an overlap rotation leaves the other's tokens working; use
 * `PUT /{uuid}/status` to kill an account outright. Idempotent.
 *
 * Needs no `CREATE_SERVICE_ACCOUNTS`, unlike issuance: losing the bit
 * must not cost you the ability to kill a key already issued.
 */
export const apiDeleteServiceAccountsKeysByKeyUuidMutation = (options?: Partial<Options<DeleteApiV1ServiceAccountsKeysByKeyUuidData>>): UseMutationOptions<DeleteApiV1ServiceAccountsKeysByKeyUuidResponse, DeleteApiV1ServiceAccountsKeysByKeyUuidError, Options<DeleteApiV1ServiceAccountsKeysByKeyUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ServiceAccountsKeysByKeyUuidResponse, DeleteApiV1ServiceAccountsKeysByKeyUuidError, Options<DeleteApiV1ServiceAccountsKeysByKeyUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteServiceAccountsKeysKeyUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register Push Token Self
 *
 * Register push notification token for current user.
 */
export const apiPostPushTokensRegisterMutation = (options?: Partial<Options<PostApiV1PushTokensRegisterData>>): UseMutationOptions<PostApiV1PushTokensRegisterResponse, PostApiV1PushTokensRegisterError, Options<PostApiV1PushTokensRegisterData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PushTokensRegisterResponse, PostApiV1PushTokensRegisterError, Options<PostApiV1PushTokensRegisterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPushTokensRegister({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unregister Push Token Self
 *
 * Unregister push notification token for current user.
 */
export const apiDeletePushTokensUnregisterByTokenMutation = (options?: Partial<Options<DeleteApiV1PushTokensUnregisterByTokenData>>): UseMutationOptions<DeleteApiV1PushTokensUnregisterByTokenResponse, DeleteApiV1PushTokensUnregisterByTokenError, Options<DeleteApiV1PushTokensUnregisterByTokenData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PushTokensUnregisterByTokenResponse, DeleteApiV1PushTokensUnregisterByTokenError, Options<DeleteApiV1PushTokensUnregisterByTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeletePushTokensUnregisterToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register Push Token Admin
 *
 * Register push notification token for specified user (admin only).
 */
export const apiPostPushTokensRegisterByUuidMutation = (options?: Partial<Options<PostApiV1PushTokensRegisterByUuidData>>): UseMutationOptions<PostApiV1PushTokensRegisterByUuidResponse, PostApiV1PushTokensRegisterByUuidError, Options<PostApiV1PushTokensRegisterByUuidData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PushTokensRegisterByUuidResponse, PostApiV1PushTokensRegisterByUuidError, Options<PostApiV1PushTokensRegisterByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPushTokensRegisterUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unregister Push Token Admin
 *
 * Unregister push notification token for specified user (admin only).
 * Validates that the token belongs to the specified user.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeletePushTokensUnregisterByUuidByTokenMutation = (options?: Partial<Options<DeleteApiV1PushTokensUnregisterByUuidByTokenData>>): UseMutationOptions<DeleteApiV1PushTokensUnregisterByUuidByTokenResponse, DeleteApiV1PushTokensUnregisterByUuidByTokenError, Options<DeleteApiV1PushTokensUnregisterByUuidByTokenData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PushTokensUnregisterByUuidByTokenResponse, DeleteApiV1PushTokensUnregisterByUuidByTokenError, Options<DeleteApiV1PushTokensUnregisterByUuidByTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeletePushTokensUnregisterUuidToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPoliciesPermissionsMetadataQueryKey = (options?: Options<GetApiV1PoliciesPermissionsMetadataData>) => createQueryKey('getApiV1PoliciesPermissionsMetadata', options);

/**
 * Get Permissions Metadata
 *
 * Get permission bits metadata for UI rendering.
 *
 * Returns permission definitions grouped by category.
 * Categories and descriptions are derived from enum names.
 */
export const apiGetPoliciesPermissionsMetadataOptions = (options?: Options<GetApiV1PoliciesPermissionsMetadataData>) => queryOptions<GetApiV1PoliciesPermissionsMetadataResponse, GetApiV1PoliciesPermissionsMetadataError, GetApiV1PoliciesPermissionsMetadataResponse, ReturnType<typeof apiGetPoliciesPermissionsMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPoliciesPermissionsMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPoliciesPermissionsMetadataQueryKey(options)
});

export const apiGetPoliciesQueryKey = (options?: Options<GetApiV1PoliciesData>) => createQueryKey('getApiV1Policies', options);

/**
 * Get Access Policies
 *
 * Get the list of all access policies.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPoliciesOptions = (options?: Options<GetApiV1PoliciesData>) => queryOptions<GetApiV1PoliciesResponse, GetApiV1PoliciesError, GetApiV1PoliciesResponse, ReturnType<typeof apiGetPoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPoliciesQueryKey(options)
});

export const apiGetPoliciesByUuidQueryKey = (options: Options<GetApiV1PoliciesByUuidData>) => createQueryKey('getApiV1PoliciesByUuid', options);

/**
 * Get Access Policy By Uuid
 *
 * Get an access policy based on the given UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPoliciesByUuidOptions = (options: Options<GetApiV1PoliciesByUuidData>) => queryOptions<GetApiV1PoliciesByUuidResponse, GetApiV1PoliciesByUuidError, GetApiV1PoliciesByUuidResponse, ReturnType<typeof apiGetPoliciesByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPoliciesUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPoliciesByUuidQueryKey(options)
});

/**
 * Update Access Policy
 *
 * Update an access policy given its UUID. A bit this update adds must be
 * one you hold yourself (`403` otherwise); removing is refused only on a
 * protected account (`423`), short of `VISIBILITY_SELF`, which narrows.
 * See `PERMISSIONS.md`, "Granting is bounded by the granter's bits".
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutPoliciesByUuidMutation = (options?: Partial<Options<PutApiV1PoliciesByUuidData>>): UseMutationOptions<PutApiV1PoliciesByUuidResponse, PutApiV1PoliciesByUuidError, Options<PutApiV1PoliciesByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PoliciesByUuidResponse, PutApiV1PoliciesByUuidError, Options<PutApiV1PoliciesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPoliciesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPhysiciansQueryKey = (options?: Options<GetApiV1PhysiciansData>) => createQueryKey('getApiV1Physicians', options);

/**
 * Get Physicians
 *
 * Get list of physicians visible to the current user. Full-visibility users
 * see all physicians; other users see physicians within their visibility
 * scope (assigned physicians, assigned clinics' physicians, or physicians in
 * their regions).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPhysiciansOptions = (options?: Options<GetApiV1PhysiciansData>) => queryOptions<GetApiV1PhysiciansResponse, GetApiV1PhysiciansError, GetApiV1PhysiciansResponse, ReturnType<typeof apiGetPhysiciansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPhysicians({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPhysiciansQueryKey(options)
});

/**
 * Create Physician
 *
 * Create a new physician. The physician can be "empty" (clinic(s) and
 * patients) can be added later, or can be created with a list of clinics by
 * their UUIDs and/or list of patients by their IDs. Users without full
 * visibility must hold physician, clinics, or regions visibility, may not
 * connect users, may only reference clinics and patients within their
 * visibility scope, and the new physician must end up visible to them:
 * physician-visibility users get it assigned to their access policy, others
 * must create it within their regions or in one of their clinics. Note that
 * the geographical region (country, region) of a physician and their
 * associated clinic(s) and patients must match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPhysiciansMutation = (options?: Partial<Options<PostApiV1PhysiciansData>>): UseMutationOptions<PostApiV1PhysiciansResponse, PostApiV1PhysiciansError, Options<PostApiV1PhysiciansData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PhysiciansResponse, PostApiV1PhysiciansError, Options<PostApiV1PhysiciansData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPhysicians({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Physician
 *
 * Delete physician by its UUID, scoped to the user's visibility. The deleted
 * physician is automatically removed from a list of physicians of _all_
 * clinics, _all_ patients, all assigned monitoring users, and all access
 * policies.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeletePhysiciansByUuidMutation = (options?: Partial<Options<DeleteApiV1PhysiciansByUuidData>>): UseMutationOptions<DeleteApiV1PhysiciansByUuidResponse, DeleteApiV1PhysiciansByUuidError, Options<DeleteApiV1PhysiciansByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PhysiciansByUuidResponse, DeleteApiV1PhysiciansByUuidError, Options<DeleteApiV1PhysiciansByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeletePhysiciansUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Physician
 *
 * Update physician by its UUID. Users without full visibility may neither
 * connect nor disconnect users. Note that the geographical region (country,
 * region) of a physician and their associated clinic(s) and patients must
 * match. A newly assigned monitoring user (`assigned_users` or
 * `append_assigned_users`) must be active, have an access policy and
 * visibility over the physician. Users already assigned and not removed by
 * the same update are re-checked only when it changes the physician's
 * country, region or clinics.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutPhysiciansByUuidMutation = (options?: Partial<Options<PutApiV1PhysiciansByUuidData>>): UseMutationOptions<PutApiV1PhysiciansByUuidResponse, PutApiV1PhysiciansByUuidError, Options<PutApiV1PhysiciansByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PhysiciansByUuidResponse, PutApiV1PhysiciansByUuidError, Options<PutApiV1PhysiciansByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPhysiciansUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetClinicsQueryKey = (options?: Options<GetApiV1ClinicsData>) => createQueryKey('getApiV1Clinics', options);

/**
 * Get Clinics
 *
 * Get list of clinics visible to the current user. Full-visibility users
 * see all clinics; clinic-visibility users see assigned clinics;
 * region-visibility users see clinics in their regions;
 * physician-visibility users see no clinics.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicsOptions = (options?: Options<GetApiV1ClinicsData>) => queryOptions<GetApiV1ClinicsResponse, GetApiV1ClinicsError, GetApiV1ClinicsResponse, ReturnType<typeof apiGetClinicsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicsQueryKey(options)
});

/**
 * Create Clinic
 *
 * Create a new clinic. The clinic can be "empty" (physicians can be added
 * later), or can be created with a list of physicians by their UUIDs. Users
 * without full visibility must hold clinics or regions visibility, may only
 * reference physicians within their visibility scope, and the new clinic
 * must end up visible to them: clinic-visibility users get it assigned to
 * their access policy, region-visibility users must create it within their
 * regions. Note that the geographical region (country, region) of a clinic
 * and its physicians must match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicsMutation = (options?: Partial<Options<PostApiV1ClinicsData>>): UseMutationOptions<PostApiV1ClinicsResponse, PostApiV1ClinicsError, Options<PostApiV1ClinicsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicsResponse, PostApiV1ClinicsError, Options<PostApiV1ClinicsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinics({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Clinic
 *
 * Delete clinic by its UUID, scoped to the user's visibility. The deleted
 * clinic is automatically removed from a list of clinics of _all_
 * physicians, all assigned monitoring users, and all access policies.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicsByUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicsByUuidData>>): UseMutationOptions<DeleteApiV1ClinicsByUuidResponse, DeleteApiV1ClinicsByUuidError, Options<DeleteApiV1ClinicsByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicsByUuidResponse, DeleteApiV1ClinicsByUuidError, Options<DeleteApiV1ClinicsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Clinic
 *
 * Update clinic by its UUID. Note that the geographical region (country,
 * region) of a clinic and its physicians must match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicsByUuidMutation = (options?: Partial<Options<PutApiV1ClinicsByUuidData>>): UseMutationOptions<PutApiV1ClinicsByUuidResponse, PutApiV1ClinicsByUuidError, Options<PutApiV1ClinicsByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicsByUuidResponse, PutApiV1ClinicsByUuidError, Options<PutApiV1ClinicsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preregister Physician
 *
 * Preregister a physician. Pre-registration is akin to creating a new user,
 * except the new user is set as _not active_, and their password is not set.
 * This endpoint sends a registration mail to the given user's email that
 * includes an URL pointing to the `finish-physician` endpoint, including
 * encoded one-time tokens.  For `expiry_timedelta`, we use `timedelta` data
 * type, which`pydantic` (de)serializes to JSON using ISO 8601 standard on
 * durations (see [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)).
 * The email is sent using API background tasks and this endpoint return a task
 * ID, which then might be inquired for status using the `tasks/api/status/`
 * endpoint. The `physician` role's default permissions must be within the
 * ones you hold yourself (`403` otherwise).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostRegistrationPreregisterPhysicianMutation = (options?: Partial<Options<PostApiV1RegistrationPreregisterPhysicianData>>): UseMutationOptions<PostApiV1RegistrationPreregisterPhysicianResponse, PostApiV1RegistrationPreregisterPhysicianError, Options<PostApiV1RegistrationPreregisterPhysicianData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1RegistrationPreregisterPhysicianResponse, PostApiV1RegistrationPreregisterPhysicianError, Options<PostApiV1RegistrationPreregisterPhysicianData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostRegistrationPreregisterPhysician({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Finish Registration Physician
 *
 * Finish registration of a physician. This endpoint takes tokens from the
 * `preregister_physician` endpoint and passwords the user wishes to use, saves
 * the password to the DB, and sets the user as active.
 */
export const apiPutRegistrationFinishPhysicianMutation = (options?: Partial<Options<PutApiV1RegistrationFinishPhysicianData>>): UseMutationOptions<PutApiV1RegistrationFinishPhysicianResponse, PutApiV1RegistrationFinishPhysicianError, Options<PutApiV1RegistrationFinishPhysicianData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1RegistrationFinishPhysicianResponse, PutApiV1RegistrationFinishPhysicianError, Options<PutApiV1RegistrationFinishPhysicianData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutRegistrationFinishPhysician({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preregister Patient
 *
 * Preregister a patient. Pre-registration is akin to creating a new user,
 * except the new user is set as _not active_, and their password is not set.
 * This endpoint sends a registration mail to the given user's email that
 * includes an URL pointing to the `finish-patient` endpoint, including
 * encoded one-time tokens.  For `expiry_timedelta`, we use `timedelta` data
 * type, which`pydantic` (de)serializes to JSON using ISO 8601 standard on
 * durations (see [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)).
 * The email is sent using API background tasks and this endpoint return a task
 * ID, which then might be inquired for status using the `tasks/api/status/`
 * endpoint. Subject to filtering by data visibility dimension, i.e.,
 * patient-managing roles can pre-register patient user only when their
 * `connected_patient_id` is managed by them.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostRegistrationPreregisterPatientMutation = (options?: Partial<Options<PostApiV1RegistrationPreregisterPatientData>>): UseMutationOptions<PostApiV1RegistrationPreregisterPatientResponse, PostApiV1RegistrationPreregisterPatientError, Options<PostApiV1RegistrationPreregisterPatientData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1RegistrationPreregisterPatientResponse, PostApiV1RegistrationPreregisterPatientError, Options<PostApiV1RegistrationPreregisterPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostRegistrationPreregisterPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Finish Registration Patient
 *
 * Finish registration of a patient. This endpoint takes tokens from the
 * `preregister_patient` endpoint and passwords the user wishes to use, saves
 * the password to the DB, and sets the user as active.
 */
export const apiPutRegistrationFinishPatientMutation = (options?: Partial<Options<PutApiV1RegistrationFinishPatientData>>): UseMutationOptions<PutApiV1RegistrationFinishPatientResponse, PutApiV1RegistrationFinishPatientError, Options<PutApiV1RegistrationFinishPatientData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1RegistrationFinishPatientResponse, PutApiV1RegistrationFinishPatientError, Options<PutApiV1RegistrationFinishPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutRegistrationFinishPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetRegistrationPasswordFormByFormTypeByLanguageQueryKey = (options: Options<GetApiV1RegistrationPasswordFormByFormTypeByLanguageData>) => createQueryKey('getApiV1RegistrationPasswordFormByFormTypeByLanguage', options);

/**
 * Password Form
 *
 * Finish registration web form. This endpoint serves a simple web form given
 * the form type (finish patient registration, finish physician registration,
 * or password reset) and language. The web form is rendered from a `Jinja2`
 * template; the token and expiry token are given as query parameters, and the
 * submit button then redirects to the respective endpoint for finishing the
 * registration or resetting the password.
 */
export const apiGetRegistrationPasswordFormByFormTypeByLanguageOptions = (options: Options<GetApiV1RegistrationPasswordFormByFormTypeByLanguageData>) => queryOptions<GetApiV1RegistrationPasswordFormByFormTypeByLanguageResponse, GetApiV1RegistrationPasswordFormByFormTypeByLanguageError, GetApiV1RegistrationPasswordFormByFormTypeByLanguageResponse, ReturnType<typeof apiGetRegistrationPasswordFormByFormTypeByLanguageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetRegistrationPasswordFormFormTypeLanguage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetRegistrationPasswordFormByFormTypeByLanguageQueryKey(options)
});

export const apiGetPatientsPendingConsentsQueryKey = (options?: Options<GetApiV1PatientsPendingConsentsData>) => createQueryKey('getApiV1PatientsPendingConsents', options);

/**
 * Get Pending Consents
 *
 * Visible patients, neither archived nor deceased, with a required consent
 * never signed or stale - the work list of consent administration. Identity
 * fields and per-type state only, as in their identity rows in the patient
 * lists; `unsignable` marks a consent with no text to sign until one is
 * published in the patient's scope.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPendingConsentsOptions = (options?: Options<GetApiV1PatientsPendingConsentsData>) => queryOptions<GetApiV1PatientsPendingConsentsResponse, GetApiV1PatientsPendingConsentsError, GetApiV1PatientsPendingConsentsResponse, ReturnType<typeof apiGetPatientsPendingConsentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPendingConsents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsPendingConsentsQueryKey(options)
});

export const apiGetPatientsByPatientIdConsentsQueryKey = (options: Options<GetApiV1PatientsByPatientIdConsentsData>) => createQueryKey('getApiV1PatientsByPatientIdConsents', options);

/**
 * Get Patient Consents
 *
 * Every consent type required in the patient's scope or on their ledger,
 * with its state: `granted`, `not_granted` (never signed), `revoked`, or
 * `stale` (granted on a text since replaced for them by anything but a
 * patch version).
 */
export const apiGetPatientsByPatientIdConsentsOptions = (options: Options<GetApiV1PatientsByPatientIdConsentsData>) => queryOptions<GetApiV1PatientsByPatientIdConsentsResponse, GetApiV1PatientsByPatientIdConsentsError, GetApiV1PatientsByPatientIdConsentsResponse, ReturnType<typeof apiGetPatientsByPatientIdConsentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdConsents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdConsentsQueryKey(options)
});

/**
 * Update Patient Consent
 *
 * Grant or revoke a consent, appending one ledger row; a grant takes a
 * method the type allows (422 otherwise), a revoke any the caller may use.
 * A grant of a type with a text binds to the text shown: `study_text_uuid`
 * and the `content_hash` of its template; a type without one takes neither.
 * `method=app` is the patient's own signature (`MEDICAL_UPDATE`, fresh
 * token) and must sign the current version; `paper` takes
 * `MONITORING_UPDATE` and patient visibility; `admin` (`MEDICAL_UPDATE`,
 * an admin who can see the patient, fresh token) may record an older
 * version of a resolving lineage, granted when only its patch differs and
 * stale at once otherwise, unless the patient signed a newer one (409). A
 * revoke carries no text, needs the consent granted or stale, and records
 * the withdrawal channel as `method`.
 */
export const apiPutPatientsByPatientIdConsentsByConsentTypeMutation = (options?: Partial<Options<PutApiV1PatientsByPatientIdConsentsByConsentTypeData>>): UseMutationOptions<PutApiV1PatientsByPatientIdConsentsByConsentTypeResponse, PutApiV1PatientsByPatientIdConsentsByConsentTypeError, Options<PutApiV1PatientsByPatientIdConsentsByConsentTypeData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PatientsByPatientIdConsentsByConsentTypeResponse, PutApiV1PatientsByPatientIdConsentsByConsentTypeError, Options<PutApiV1PatientsByPatientIdConsentsByConsentTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPatientsPatientIdConsentsConsentType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPatientsCountsQueryKey = (options?: Options<GetApiV1PatientsCountsData>) => createQueryKey('getApiV1PatientsCounts', options);

/**
 * Get Patient Counts
 *
 * Seerlinq patient counter! List number of patients in our DB and group them
 * based on: `patient_status`, `monitoring_type`, and `country`. Note that
 * patients are allowed to be in more than study and that patient is counted
 * towards all studies they are participating in.
 */
export const apiGetPatientsCountsOptions = (options?: Options<GetApiV1PatientsCountsData>) => queryOptions<GetApiV1PatientsCountsResponse, DefaultError, GetApiV1PatientsCountsResponse, ReturnType<typeof apiGetPatientsCountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsCounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsCountsQueryKey(options)
});

export const apiGetPatientsQueryKey = (options?: Options<GetApiV1PatientsData>) => createQueryKey('getApiV1Patients', options);

/**
 * Get Patients
 *
 * List all patients in the DB. This endpoint is subject to filtering by data
 * visibility dimension. Users with **self-only** visibility only get a list of
 * patient IDs, while higher access levels get a full schema response. The
 * `load_type` parameter controls how patients' connected data are returned:
 * `load_type=basic` returns just basic patient data without any related
 * medical data and `load_type=clinical` returns counts of related medical
 * (and other) data. Every row carries its per-type consent state. For users
 * with `WRITE`, a patient missing a required consent is an identity row:
 * name, country, region, consent state, `informed_consent` and timestamps,
 * every other field null or `0`; the `patient_status` and `monitoring_type`
 * filters keep it whatever they ask for.
 */
export const apiGetPatientsOptions = (options?: Options<GetApiV1PatientsData>) => queryOptions<GetApiV1PatientsResponse, GetApiV1PatientsError, GetApiV1PatientsResponse, ReturnType<typeof apiGetPatientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const apiGetPatientsInfiniteQueryKey = (options?: Options<GetApiV1PatientsData>): QueryKey<Options<GetApiV1PatientsData>> => createQueryKey('getApiV1Patients', options, true);

/**
 * Get Patients
 *
 * List all patients in the DB. This endpoint is subject to filtering by data
 * visibility dimension. Users with **self-only** visibility only get a list of
 * patient IDs, while higher access levels get a full schema response. The
 * `load_type` parameter controls how patients' connected data are returned:
 * `load_type=basic` returns just basic patient data without any related
 * medical data and `load_type=clinical` returns counts of related medical
 * (and other) data. Every row carries its per-type consent state. For users
 * with `WRITE`, a patient missing a required consent is an identity row:
 * name, country, region, consent state, `informed_consent` and timestamps,
 * every other field null or `0`; the `patient_status` and `monitoring_type`
 * filters keep it whatever they ask for.
 */
export const apiGetPatientsInfiniteOptions = (options?: Options<GetApiV1PatientsData>) => infiniteQueryOptions<GetApiV1PatientsResponse, GetApiV1PatientsError, InfiniteData<GetApiV1PatientsResponse>, QueryKey<Options<GetApiV1PatientsData>>, number | Pick<QueryKey<Options<GetApiV1PatientsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1PatientsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetPatients({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsInfiniteQueryKey(options)
});

/**
 * Create Patient
 *
 * Create a new patient. A **self-only** user role cannot create new patients.
 * If a **managed** user role adds a new patient, it is automatically added to
 * their list of managing patient IDs. If a patient is added by a user with
 * **monitoring access** or higher, they can add this new patient to a list of
 * managed patient IDs of _any_ user with a **managed** visibility role.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Create Patients (52)`, `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPatientsMutation = (options?: Partial<Options<PostApiV1PatientsData>>): UseMutationOptions<PostApiV1PatientsResponse, PostApiV1PatientsError, Options<PostApiV1PatientsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PatientsResponse, PostApiV1PatientsError, Options<PostApiV1PatientsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPatients({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPatientsMinimalQueryKey = (options?: Options<GetApiV1PatientsMinimalData>) => createQueryKey('getApiV1PatientsMinimal', options);

/**
 * Get Patients List Minimal
 *
 * Return minimal info on all patients. Used mostly in a context where we
 * need the IDs of all patients, but not their full data. Patients missing a
 * required consent are identity rows for users with `WRITE`, filtered as in
 * the full list.
 */
export const apiGetPatientsMinimalOptions = (options?: Options<GetApiV1PatientsMinimalData>) => queryOptions<GetApiV1PatientsMinimalResponse, GetApiV1PatientsMinimalError, GetApiV1PatientsMinimalResponse, ReturnType<typeof apiGetPatientsMinimalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsMinimal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsMinimalQueryKey(options)
});

export const apiGetPatientsMeasurementConfigDefaultQueryKey = (options: Options<GetApiV1PatientsMeasurementConfigDefaultData>) => createQueryKey('getApiV1PatientsMeasurementConfigDefault', options);

/**
 * Get Default Measurement Config
 *
 * Get the default self-measurement config for a country. It is the config
 * `POST /patients` stores when the body carries none and the patient's
 * monitoring settings require one.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsMeasurementConfigDefaultOptions = (options: Options<GetApiV1PatientsMeasurementConfigDefaultData>) => queryOptions<GetApiV1PatientsMeasurementConfigDefaultResponse, GetApiV1PatientsMeasurementConfigDefaultError, GetApiV1PatientsMeasurementConfigDefaultResponse, ReturnType<typeof apiGetPatientsMeasurementConfigDefaultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsMeasurementConfigDefault({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsMeasurementConfigDefaultQueryKey(options)
});

/**
 * Create Patient And Connected User
 *
 * Create a new patient and preregister a new user with the `patient` role,
 * connected to the newly created patient by its ID. A **self-only** user role
 * cannot create and preregister new patients. If a **managed** user role adds
 * a new patient, it is automatically added to their list of managing patient
 * IDs. If a patient is added by a user with **monitoring access** or higher,
 * they can add this new patient to a list of managed patient IDs of _any_
 * user with a **managed** visibility role. The new user is set as _not
 * active_, and their
 * password is not set. This endpoint sends a registration mail to the given
 * patient's email that includes an URL pointing to the `finish-patient`
 * endpoint, including encoded one-time tokens.  For `expiry_timedelta`, we use
 * `timedelta` data type, which`pydantic` (de)serializes to JSON using ISO 8601
 * standard on durations (see
 * [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)). The email is sent
 * using API background tasks and this endpoint return a task ID, which then
 * might be inquired for status using the `tasks/api/status/` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Create Patients (52)`, `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPatientsPatientAndUserMutation = (options?: Partial<Options<PostApiV1PatientsPatientAndUserData>>): UseMutationOptions<PostApiV1PatientsPatientAndUserResponse, PostApiV1PatientsPatientAndUserError, Options<PostApiV1PatientsPatientAndUserData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PatientsPatientAndUserResponse, PostApiV1PatientsPatientAndUserError, Options<PostApiV1PatientsPatientAndUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPatientsPatientAndUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create User For Existing Patient
 *
 * Create a new user with the `patient` role for the existing patient. A
 * **self-only** user cannot create user for a patient. The patient DB item is
 * updated:
 * 1. patient status is set from the new study's monitoring settings; a
 * deceased patient is refused instead, with a 422,
 * 2. patient study is updated, which is a scope move: a consent whose
 * text no longer resolves goes stale, and one the new scope newly
 * requires is missing until signed,
 * 3. and their email is updated to match the newly created user's email
 * / username.
 * The new user is set as _not active_, and their password is not set. This
 * endpoint sends a registration mail to the given patient's email that
 * includes an URL pointing to the `finish-patient` endpoint, including encoded
 * one-time tokens.  For `expiry_timedelta`, we use `timedelta` data type,
 * which`pydantic` (de)serializes to JSON using ISO 8601 standard on durations
 * (see [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)). The email is
 * sent using API background tasks and this endpoint return a task ID, which
 * then might be inquired for status using the `tasks/api/status/` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPatientsByPatientIdUserMutation = (options?: Partial<Options<PostApiV1PatientsByPatientIdUserData>>): UseMutationOptions<PostApiV1PatientsByPatientIdUserResponse, PostApiV1PatientsByPatientIdUserError, Options<PostApiV1PatientsByPatientIdUserData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PatientsByPatientIdUserResponse, PostApiV1PatientsByPatientIdUserError, Options<PostApiV1PatientsByPatientIdUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPatientsPatientIdUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Patient
 *
 * Delete a patient by its patient ID. A **self-only** user role cannot delete
 * patients. This endpoint is subject to filtering by data visibility
 * dimension. The deleted patient ID is removed from the list of managed
 * patient IDs of _all_ users with a **managed** visibility role. Optionally
 * (by passing query parameter `delete_user`), all users connected to this
 * patient (i.e., with **self-only** visibility), added by the user who wants
 * to delete the patient, will also be deleted; service accounts they own are
 * flagged `owner_deactivated` first, as in `DELETE /users/{uuid}`. This
 * endpoint raises exception when used on protected patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeletePatientsByPatientIdMutation = (options?: Partial<Options<DeleteApiV1PatientsByPatientIdData>>): UseMutationOptions<DeleteApiV1PatientsByPatientIdResponse, DeleteApiV1PatientsByPatientIdError, Options<DeleteApiV1PatientsByPatientIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PatientsByPatientIdResponse, DeleteApiV1PatientsByPatientIdError, Options<DeleteApiV1PatientsByPatientIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeletePatientsPatientId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPatientsByPatientIdQueryKey = (options: Options<GetApiV1PatientsByPatientIdData>) => createQueryKey('getApiV1PatientsByPatientId', options);

/**
 * Get Patient
 *
 * Get a single patient by its patient ID. This endpoint is subject to
 * filtering by data visibility dimension. The response type is `clinical` (see
 * `get_patients` endpoint), i.e., the patient's connected data are returned as
 * counts of diagnoses, medical data, medications, and symptoms. For
 * **monitoring access** and higher users, counts of patient's alerts,
 * thresholds, and events is also returned. A caller without `WRITE` gets the
 * minimal schema, same as `GET /patients`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdOptions = (options: Options<GetApiV1PatientsByPatientIdData>) => queryOptions<GetApiV1PatientsByPatientIdResponse, GetApiV1PatientsByPatientIdError, GetApiV1PatientsByPatientIdResponse, ReturnType<typeof apiGetPatientsByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdQueryKey(options)
});

/**
 * Update Patient
 *
 * Update/edit a patient given its patient ID. The **admin** role can update
 * all patients, **monitoring** users can update patients based on their
 * visibility, while lower access levels can update only patients they created.
 * This endpoint raises exception when used on protected patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutPatientsByPatientIdMutation = (options?: Partial<Options<PutApiV1PatientsByPatientIdData>>): UseMutationOptions<PutApiV1PatientsByPatientIdResponse, PutApiV1PatientsByPatientIdError, Options<PutApiV1PatientsByPatientIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PatientsByPatientIdResponse, PutApiV1PatientsByPatientIdError, Options<PutApiV1PatientsByPatientIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPatientsPatientId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Ai Output
 *
 * Append one AI output about a patient. Every earlier output stays
 * readable, and the endpoints serving the summary read the newest row of
 * that kind. The record written is the output, so the gate is
 * `AI_OUTPUT_WRITE` plus the patient's visibility - a bit that grants
 * nothing else, which is what keeps the writing account narrow. A repeat
 * of the same `source_run_id` carrying the same payload returns the stored
 * row, and one carrying a different payload is a 409.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ai Output Write (54)` <br /> See the _API description_ for more info.
 */
export const apiPostPatientsByPatientIdAiOutputsMutation = (options?: Partial<Options<PostApiV1PatientsByPatientIdAiOutputsData>>): UseMutationOptions<PostApiV1PatientsByPatientIdAiOutputsResponse, PostApiV1PatientsByPatientIdAiOutputsError, Options<PostApiV1PatientsByPatientIdAiOutputsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PatientsByPatientIdAiOutputsResponse, PostApiV1PatientsByPatientIdAiOutputsError, Options<PostApiV1PatientsByPatientIdAiOutputsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPatientsPatientIdAiOutputs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPatientsByPatientIdConsentQueryKey = (options: Options<GetApiV1PatientsByPatientIdConsentData>) => createQueryKey('getApiV1PatientsByPatientIdConsent', options);

/**
 * Get Patient Consent
 *
 * **Deprecated** - use `GET /{patient_id}/consents`. The ledger projected
 * onto `informed_consent` and its history. Restricted to users who can see
 * the patient.
 *
 * @deprecated
 */
export const apiGetPatientsByPatientIdConsentOptions = (options: Options<GetApiV1PatientsByPatientIdConsentData>) => queryOptions<GetApiV1PatientsByPatientIdConsentResponse, GetApiV1PatientsByPatientIdConsentError, GetApiV1PatientsByPatientIdConsentResponse, ReturnType<typeof apiGetPatientsByPatientIdConsentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdConsent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdConsentQueryKey(options)
});

/**
 * Approve Telemonitoring Consent
 *
 * **Deprecated** - use `PUT /{patient_id}/consents/telemonitoring`. Grants
 * `telemonitoring` with method `app` (`admin` for an admin), signing the
 * text the old app shows (the caller's account language where the
 * patient's level has it, else the patient's consent language, which an
 * admin always takes; 409 when none resolves). A no-op while
 * `telemonitoring` is granted.
 * Only the patient themselves or an admin; does **not** change the
 * patient's status.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 *
 * @deprecated
 */
export const apiPutPatientsByPatientIdApproveConsentTelemonitoringMutation = (options?: Partial<Options<PutApiV1PatientsByPatientIdApproveConsentTelemonitoringData>>): UseMutationOptions<PutApiV1PatientsByPatientIdApproveConsentTelemonitoringResponse, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringError, Options<PutApiV1PatientsByPatientIdApproveConsentTelemonitoringData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PatientsByPatientIdApproveConsentTelemonitoringResponse, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringError, Options<PutApiV1PatientsByPatientIdApproveConsentTelemonitoringData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPatientsPatientIdApproveConsentTelemonitoring({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Paper Consent
 *
 * **Deprecated** - use `PUT /{patient_id}/consents/research`. Grants
 * `research` with method `paper`. Monitoring users who can see the patient;
 * does **not** change the patient's status.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 *
 * @deprecated
 */
export const apiPutPatientsByPatientIdApproveConsentPaperMutation = (options?: Partial<Options<PutApiV1PatientsByPatientIdApproveConsentPaperData>>): UseMutationOptions<PutApiV1PatientsByPatientIdApproveConsentPaperResponse, PutApiV1PatientsByPatientIdApproveConsentPaperError, Options<PutApiV1PatientsByPatientIdApproveConsentPaperData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PatientsByPatientIdApproveConsentPaperResponse, PutApiV1PatientsByPatientIdApproveConsentPaperError, Options<PutApiV1PatientsByPatientIdApproveConsentPaperData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPatientsPatientIdApproveConsentPaper({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Telemonitoring Consent
 *
 * **Deprecated** - use `PUT /{patient_id}/consents/{consent_type}`. Revokes
 * every granted or stale consent with method `app` (`admin` for an admin).
 * Only the patient themselves or an admin; withdrawing a required consent
 * sets an active or onboarded patient `not active`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 *
 * @deprecated
 */
export const apiPutPatientsByPatientIdRevokeConsentTelemonitoringMutation = (options?: Partial<Options<PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringData>>): UseMutationOptions<PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringResponse, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringError, Options<PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringResponse, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringError, Options<PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPatientsPatientIdRevokeConsentTelemonitoring({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Paper Consent
 *
 * **Deprecated** - use `PUT /{patient_id}/consents/{consent_type}`. Revokes
 * every granted or stale consent with method `paper`. Monitoring users who
 * can see the patient; withdrawing a required consent sets an active or
 * onboarded patient `not active`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 *
 * @deprecated
 */
export const apiPutPatientsByPatientIdRevokeConsentPaperMutation = (options?: Partial<Options<PutApiV1PatientsByPatientIdRevokeConsentPaperData>>): UseMutationOptions<PutApiV1PatientsByPatientIdRevokeConsentPaperResponse, PutApiV1PatientsByPatientIdRevokeConsentPaperError, Options<PutApiV1PatientsByPatientIdRevokeConsentPaperData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PatientsByPatientIdRevokeConsentPaperResponse, PutApiV1PatientsByPatientIdRevokeConsentPaperError, Options<PutApiV1PatientsByPatientIdRevokeConsentPaperData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPatientsPatientIdRevokeConsentPaper({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPatientsByPatientIdHealthProQueryKey = (options: Options<GetApiV1PatientsByPatientIdHealthProData>) => createQueryKey('getApiV1PatientsByPatientIdHealthPro', options);

/**
 * Generate Healthpro Reports For Patient
 *
 * Generate HealthPro reports for this patient ID. Health Pro reports are HTML
 * formatted strings that can be copy-pasted into the system. This endpoint
 * support reports timeline by selected the maximum number of reports to
 * generate (sorted by most recent) and by selecting the starting date for any
 * reports. For every date that patient did the measurement, we generate one
 * report. One measurement in this case is:
 * - PPG measurement in Condition 1 and Condition 2
 * - DRI
 * - EMD heart rate from Condition 1
 * - SpO2 from Condition 1
 * - shortness of breath and fatigue score symptoms
 * - systolic and diastolic blood pressure
 *
 * This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdHealthProOptions = (options: Options<GetApiV1PatientsByPatientIdHealthProData>) => queryOptions<GetApiV1PatientsByPatientIdHealthProResponse, GetApiV1PatientsByPatientIdHealthProError, GetApiV1PatientsByPatientIdHealthProResponse, ReturnType<typeof apiGetPatientsByPatientIdHealthProQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdHealthPro({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdHealthProQueryKey(options)
});

export const apiGetPatientsByPatientIdMonitoringInfoQueryKey = (options: Options<GetApiV1PatientsByPatientIdMonitoringInfoData>) => createQueryKey('getApiV1PatientsByPatientIdMonitoringInfo', options);

/**
 * Get Monitoring Info
 *
 * Get HeartCore monitoring info for a patient: last PPG and ECG, the last 5
 * DRIs and LVFPs (each only with its access bit), and complete full
 * measurements per 3/6/9/12-month window (`null` without a measurement
 * config).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Run Heart Core Quicklook (41)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdMonitoringInfoOptions = (options: Options<GetApiV1PatientsByPatientIdMonitoringInfoData>) => queryOptions<GetApiV1PatientsByPatientIdMonitoringInfoResponse, GetApiV1PatientsByPatientIdMonitoringInfoError, GetApiV1PatientsByPatientIdMonitoringInfoResponse, ReturnType<typeof apiGetPatientsByPatientIdMonitoringInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdMonitoringInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdMonitoringInfoQueryKey(options)
});

export const apiGetPatientsByPatientIdPpgsQueryKey = (options: Options<GetApiV1PatientsByPatientIdPpgsData>) => createQueryKey('getApiV1PatientsByPatientIdPpgs', options);

/**
 * Get Patients Ppgs
 *
 * List all PPG data connected to this patient ID. This endpoint is subject to
 * filtering by data visibility dimension. This endpoint returns the metadata
 * for PPG data, not the actual timeseries.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdPpgsOptions = (options: Options<GetApiV1PatientsByPatientIdPpgsData>) => queryOptions<GetApiV1PatientsByPatientIdPpgsResponse, GetApiV1PatientsByPatientIdPpgsError, GetApiV1PatientsByPatientIdPpgsResponse, ReturnType<typeof apiGetPatientsByPatientIdPpgsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdPpgs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdPpgsQueryKey(options)
});

export const apiGetPatientsByPatientIdDiagnosesQueryKey = (options: Options<GetApiV1PatientsByPatientIdDiagnosesData>) => createQueryKey('getApiV1PatientsByPatientIdDiagnoses', options);

/**
 * Get Patients Diagnoses
 *
 * List all diagnoses connected to this patient ID. This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdDiagnosesOptions = (options: Options<GetApiV1PatientsByPatientIdDiagnosesData>) => queryOptions<GetApiV1PatientsByPatientIdDiagnosesResponse, GetApiV1PatientsByPatientIdDiagnosesError, GetApiV1PatientsByPatientIdDiagnosesResponse, ReturnType<typeof apiGetPatientsByPatientIdDiagnosesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdDiagnoses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdDiagnosesQueryKey(options)
});

export const apiGetPatientsByPatientIdMedicaldataQueryKey = (options: Options<GetApiV1PatientsByPatientIdMedicaldataData>) => createQueryKey('getApiV1PatientsByPatientIdMedicaldata', options);

/**
 * Get Patients Medical Data
 *
 * List all medical data connected to this patient ID. This endpoint is subject
 * to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdMedicaldataOptions = (options: Options<GetApiV1PatientsByPatientIdMedicaldataData>) => queryOptions<GetApiV1PatientsByPatientIdMedicaldataResponse, GetApiV1PatientsByPatientIdMedicaldataError, GetApiV1PatientsByPatientIdMedicaldataResponse, ReturnType<typeof apiGetPatientsByPatientIdMedicaldataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdMedicaldata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdMedicaldataQueryKey(options)
});

export const apiGetPatientsByPatientIdMedicationsQueryKey = (options: Options<GetApiV1PatientsByPatientIdMedicationsData>) => createQueryKey('getApiV1PatientsByPatientIdMedications', options);

/**
 * Get Patients Medications
 *
 * List all medications connected to this patient ID. This endpoint is subject
 * to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdMedicationsOptions = (options: Options<GetApiV1PatientsByPatientIdMedicationsData>) => queryOptions<GetApiV1PatientsByPatientIdMedicationsResponse, GetApiV1PatientsByPatientIdMedicationsError, GetApiV1PatientsByPatientIdMedicationsResponse, ReturnType<typeof apiGetPatientsByPatientIdMedicationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdMedications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdMedicationsQueryKey(options)
});

export const apiGetPatientsByPatientIdGdmtQueryKey = (options: Options<GetApiV1PatientsByPatientIdGdmtData>) => createQueryKey('getApiV1PatientsByPatientIdGdmt', options);

/**
 * Get Gdmt Score
 *
 * Compute and return the full GDMT score breakdown for a patient.
 *
 * Score is persisted when it changes. Returns a not-applicable result
 * (score 0, empty medications) when no HF type is assigned.
 *
 * :param patient_id: patient to compute GDMT score for
 * :return: GDMTResult with per-medication breakdown and total score
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdGdmtOptions = (options: Options<GetApiV1PatientsByPatientIdGdmtData>) => queryOptions<GetApiV1PatientsByPatientIdGdmtResponse, GetApiV1PatientsByPatientIdGdmtError, GetApiV1PatientsByPatientIdGdmtResponse, ReturnType<typeof apiGetPatientsByPatientIdGdmtQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdGdmt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdGdmtQueryKey(options)
});

export const apiGetPatientsByPatientIdSymptomsQueryKey = (options: Options<GetApiV1PatientsByPatientIdSymptomsData>) => createQueryKey('getApiV1PatientsByPatientIdSymptoms', options);

/**
 * Get Patients Symptoms
 *
 * List all symptoms connected to this patient ID. This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdSymptomsOptions = (options: Options<GetApiV1PatientsByPatientIdSymptomsData>) => queryOptions<GetApiV1PatientsByPatientIdSymptomsResponse, GetApiV1PatientsByPatientIdSymptomsError, GetApiV1PatientsByPatientIdSymptomsResponse, ReturnType<typeof apiGetPatientsByPatientIdSymptomsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdSymptoms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdSymptomsQueryKey(options)
});

export const apiGetPatientsByPatientIdQuestionnairesQueryKey = (options: Options<GetApiV1PatientsByPatientIdQuestionnairesData>) => createQueryKey('getApiV1PatientsByPatientIdQuestionnaires', options);

/**
 * Get Patient Questionnaires
 *
 * List all patient questionnaires connected to this patient ID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdQuestionnairesOptions = (options: Options<GetApiV1PatientsByPatientIdQuestionnairesData>) => queryOptions<GetApiV1PatientsByPatientIdQuestionnairesResponse, GetApiV1PatientsByPatientIdQuestionnairesError, GetApiV1PatientsByPatientIdQuestionnairesResponse, ReturnType<typeof apiGetPatientsByPatientIdQuestionnairesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdQuestionnaires({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdQuestionnairesQueryKey(options)
});

export const apiGetPatientsByPatientIdComputedQueryKey = (options: Options<GetApiV1PatientsByPatientIdComputedData>) => createQueryKey('getApiV1PatientsByPatientIdComputed', options);

/**
 * Get Patients Computed Data
 *
 * List all Seerlinq-computed data connected to this patient ID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdComputedOptions = (options: Options<GetApiV1PatientsByPatientIdComputedData>) => queryOptions<GetApiV1PatientsByPatientIdComputedResponse, GetApiV1PatientsByPatientIdComputedError, GetApiV1PatientsByPatientIdComputedResponse, ReturnType<typeof apiGetPatientsByPatientIdComputedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdComputed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdComputedQueryKey(options)
});

export const apiGetPatientsByPatientIdComputedInfiniteQueryKey = (options: Options<GetApiV1PatientsByPatientIdComputedData>): QueryKey<Options<GetApiV1PatientsByPatientIdComputedData>> => createQueryKey('getApiV1PatientsByPatientIdComputed', options, true);

/**
 * Get Patients Computed Data
 *
 * List all Seerlinq-computed data connected to this patient ID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdComputedInfiniteOptions = (options: Options<GetApiV1PatientsByPatientIdComputedData>) => infiniteQueryOptions<GetApiV1PatientsByPatientIdComputedResponse, GetApiV1PatientsByPatientIdComputedError, InfiniteData<GetApiV1PatientsByPatientIdComputedResponse>, QueryKey<Options<GetApiV1PatientsByPatientIdComputedData>>, number | Pick<QueryKey<Options<GetApiV1PatientsByPatientIdComputedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1PatientsByPatientIdComputedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetPatientsPatientIdComputed({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdComputedInfiniteQueryKey(options)
});

export const apiGetPatientsByPatientIdDerivedQueryKey = (options: Options<GetApiV1PatientsByPatientIdDerivedData>) => createQueryKey('getApiV1PatientsByPatientIdDerived', options);

/**
 * Get Patients Derived Data
 *
 * List all PPG-derived data connected to this patient ID. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdDerivedOptions = (options: Options<GetApiV1PatientsByPatientIdDerivedData>) => queryOptions<GetApiV1PatientsByPatientIdDerivedResponse, GetApiV1PatientsByPatientIdDerivedError, GetApiV1PatientsByPatientIdDerivedResponse, ReturnType<typeof apiGetPatientsByPatientIdDerivedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdDerived({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdDerivedQueryKey(options)
});

export const apiGetPatientsByPatientIdDerivedInfiniteQueryKey = (options: Options<GetApiV1PatientsByPatientIdDerivedData>): QueryKey<Options<GetApiV1PatientsByPatientIdDerivedData>> => createQueryKey('getApiV1PatientsByPatientIdDerived', options, true);

/**
 * Get Patients Derived Data
 *
 * List all PPG-derived data connected to this patient ID. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdDerivedInfiniteOptions = (options: Options<GetApiV1PatientsByPatientIdDerivedData>) => infiniteQueryOptions<GetApiV1PatientsByPatientIdDerivedResponse, GetApiV1PatientsByPatientIdDerivedError, InfiniteData<GetApiV1PatientsByPatientIdDerivedResponse>, QueryKey<Options<GetApiV1PatientsByPatientIdDerivedData>>, number | Pick<QueryKey<Options<GetApiV1PatientsByPatientIdDerivedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1PatientsByPatientIdDerivedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetPatientsPatientIdDerived({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdDerivedInfiniteQueryKey(options)
});

export const apiGetPatientsByPatientIdAlertsQueryKey = (options: Options<GetApiV1PatientsByPatientIdAlertsData>) => createQueryKey('getApiV1PatientsByPatientIdAlerts', options);

/**
 * Get Patient Alerts
 *
 * List all patient alerts connected to this patient ID. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Alerts (31)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdAlertsOptions = (options: Options<GetApiV1PatientsByPatientIdAlertsData>) => queryOptions<GetApiV1PatientsByPatientIdAlertsResponse, GetApiV1PatientsByPatientIdAlertsError, GetApiV1PatientsByPatientIdAlertsResponse, ReturnType<typeof apiGetPatientsByPatientIdAlertsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdAlerts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdAlertsQueryKey(options)
});

export const apiGetPatientsByPatientIdThresholdsQueryKey = (options: Options<GetApiV1PatientsByPatientIdThresholdsData>) => createQueryKey('getApiV1PatientsByPatientIdThresholds', options);

/**
 * Get Patient Thresholds
 *
 * List all patient-specific thresholds connected to this patient ID. This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdThresholdsOptions = (options: Options<GetApiV1PatientsByPatientIdThresholdsData>) => queryOptions<GetApiV1PatientsByPatientIdThresholdsResponse, GetApiV1PatientsByPatientIdThresholdsError, GetApiV1PatientsByPatientIdThresholdsResponse, ReturnType<typeof apiGetPatientsByPatientIdThresholdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdThresholds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdThresholdsQueryKey(options)
});

export const apiGetPatientsByPatientIdEventsQueryKey = (options: Options<GetApiV1PatientsByPatientIdEventsData>) => createQueryKey('getApiV1PatientsByPatientIdEvents', options);

/**
 * Get Patient Events
 *
 * List all patient events connected to this patient ID. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdEventsOptions = (options: Options<GetApiV1PatientsByPatientIdEventsData>) => queryOptions<GetApiV1PatientsByPatientIdEventsResponse, GetApiV1PatientsByPatientIdEventsError, GetApiV1PatientsByPatientIdEventsResponse, ReturnType<typeof apiGetPatientsByPatientIdEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdEventsQueryKey(options)
});

export const apiGetPatientsByPatientIdMeasurementsQueryKey = (options: Options<GetApiV1PatientsByPatientIdMeasurementsData>) => createQueryKey('getApiV1PatientsByPatientIdMeasurements', options);

/**
 * Get Patient Measurements
 *
 * Consolidated measurements table for one patient: one row per local day,
 * with its measurement sessions as sub-rows. Columns the user may not see
 * are absent from the payload.
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdMeasurementsOptions = (options: Options<GetApiV1PatientsByPatientIdMeasurementsData>) => queryOptions<GetApiV1PatientsByPatientIdMeasurementsResponse, GetApiV1PatientsByPatientIdMeasurementsError, GetApiV1PatientsByPatientIdMeasurementsResponse, ReturnType<typeof apiGetPatientsByPatientIdMeasurementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPatientsPatientIdMeasurements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdMeasurementsQueryKey(options)
});

export const apiGetPatientsByPatientIdMeasurementsInfiniteQueryKey = (options: Options<GetApiV1PatientsByPatientIdMeasurementsData>): QueryKey<Options<GetApiV1PatientsByPatientIdMeasurementsData>> => createQueryKey('getApiV1PatientsByPatientIdMeasurements', options, true);

/**
 * Get Patient Measurements
 *
 * Consolidated measurements table for one patient: one row per local day,
 * with its measurement sessions as sub-rows. Columns the user may not see
 * are absent from the payload.
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsByPatientIdMeasurementsInfiniteOptions = (options: Options<GetApiV1PatientsByPatientIdMeasurementsData>) => infiniteQueryOptions<GetApiV1PatientsByPatientIdMeasurementsResponse, GetApiV1PatientsByPatientIdMeasurementsError, InfiniteData<GetApiV1PatientsByPatientIdMeasurementsResponse>, QueryKey<Options<GetApiV1PatientsByPatientIdMeasurementsData>>, number | Pick<QueryKey<Options<GetApiV1PatientsByPatientIdMeasurementsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1PatientsByPatientIdMeasurementsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetPatientsPatientIdMeasurements({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPatientsByPatientIdMeasurementsInfiniteQueryKey(options)
});

/**
 * Create Ai Feedback
 *
 * Leave one reviewer's verdict on AI output. `output_uuid` judges that
 * output, `patient_id` the patient's outputs in general, and neither the
 * feature named by `kind`. Rows are appended, never updated.
 *
 * `output_uuid` or `patient_id` also requires visibility of that patient -
 * for an output, the output's own patient. An output or patient that does
 * not exist and one the caller cannot read both answer 404. Feedback on the
 * feature also requires `ACCESS_AI_CHAT`.
 *
 * Outside local and CI, and where harness is configured, each new verdict
 * is also forwarded to harness.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiPostAiFeedbackMutation = (options?: Partial<Options<PostApiV1AiFeedbackData>>): UseMutationOptions<PostApiV1AiFeedbackResponse, PostApiV1AiFeedbackError, Options<PostApiV1AiFeedbackData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AiFeedbackResponse, PostApiV1AiFeedbackError, Options<PostApiV1AiFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAiFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetAiOutputsByUuidQueryKey = (options: Options<GetApiV1AiOutputsByUuidData>) => createQueryKey('getApiV1AiOutputsByUuid', options);

/**
 * Get Ai Output
 *
 * Read one stored AI output, with the provenance its writer stored as
 * `metadata`. An output that does not exist and one the caller cannot read
 * both answer 404.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAiOutputsByUuidOptions = (options: Options<GetApiV1AiOutputsByUuidData>) => queryOptions<GetApiV1AiOutputsByUuidResponse, GetApiV1AiOutputsByUuidError, GetApiV1AiOutputsByUuidResponse, ReturnType<typeof apiGetAiOutputsByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAiOutputsUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAiOutputsByUuidQueryKey(options)
});

export const apiGetAiOutputsByUuidFeedbackQueryKey = (options: Options<GetApiV1AiOutputsByUuidFeedbackData>) => createQueryKey('getApiV1AiOutputsByUuidFeedback', options);

/**
 * Get Ai Output Feedback
 *
 * List the current feedback on one AI output: the newest verdict per
 * reviewer and `target`, with the rating scale ignored. A deleted
 * reviewer's verdicts stay stored but are not listed. An output that does
 * not exist and one the caller cannot read both answer 404.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAiOutputsByUuidFeedbackOptions = (options: Options<GetApiV1AiOutputsByUuidFeedbackData>) => queryOptions<GetApiV1AiOutputsByUuidFeedbackResponse, GetApiV1AiOutputsByUuidFeedbackError, GetApiV1AiOutputsByUuidFeedbackResponse, ReturnType<typeof apiGetAiOutputsByUuidFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAiOutputsUuidFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAiOutputsByUuidFeedbackQueryKey(options)
});

export const apiGetDiagnosesListQueryKey = (options?: Options<GetApiV1DiagnosesListData>) => createQueryKey('getApiV1DiagnosesList', options);

/**
 * List Supported Diagnoses
 *
 * List all supported diagnoses.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDiagnosesListOptions = (options?: Options<GetApiV1DiagnosesListData>) => queryOptions<GetApiV1DiagnosesListResponse, GetApiV1DiagnosesListError, GetApiV1DiagnosesListResponse, ReturnType<typeof apiGetDiagnosesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetDiagnosesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetDiagnosesListQueryKey(options)
});

export const apiGetDiagnosesQueryKey = (options?: Options<GetApiV1DiagnosesData>) => createQueryKey('getApiV1Diagnoses', options);

/**
 * Get Diagnoses
 *
 * List all diagnoses in the DB. It is possible to filter by patient IDs and
 * search string based on the `diagnosis_name` field (we use the `glob` syntax,
 * where `*` matches any characters). This endpoint is subject to filtering by
 * data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDiagnosesOptions = (options?: Options<GetApiV1DiagnosesData>) => queryOptions<GetApiV1DiagnosesResponse, GetApiV1DiagnosesError, GetApiV1DiagnosesResponse, ReturnType<typeof apiGetDiagnosesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetDiagnoses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetDiagnosesQueryKey(options)
});

/**
 * Create Diagnosis
 *
 * Create a new diagnosis. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostDiagnosesMutation = (options?: Partial<Options<PostApiV1DiagnosesData>>): UseMutationOptions<PostApiV1DiagnosesResponse, PostApiV1DiagnosesError, Options<PostApiV1DiagnosesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1DiagnosesResponse, PostApiV1DiagnosesError, Options<PostApiV1DiagnosesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostDiagnoses({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Diagnoses Bulk
 *
 * Create new diagnoses in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostDiagnosesBulkMutation = (options?: Partial<Options<PostApiV1DiagnosesBulkData>>): UseMutationOptions<PostApiV1DiagnosesBulkResponse, PostApiV1DiagnosesBulkError, Options<PostApiV1DiagnosesBulkData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1DiagnosesBulkResponse, PostApiV1DiagnosesBulkError, Options<PostApiV1DiagnosesBulkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostDiagnosesBulk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Diagnosis
 *
 * Delete a diagnosis by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteDiagnosesByUuidMutation = (options?: Partial<Options<DeleteApiV1DiagnosesByUuidData>>): UseMutationOptions<DeleteApiV1DiagnosesByUuidResponse, DeleteApiV1DiagnosesByUuidError, Options<DeleteApiV1DiagnosesByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1DiagnosesByUuidResponse, DeleteApiV1DiagnosesByUuidError, Options<DeleteApiV1DiagnosesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteDiagnosesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Diagnosis
 *
 * Update/edit a diagnosis given its UUID. The **admin** role can update all
 * diagnoses, while lower access levels can update only diagnoses they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutDiagnosesByUuidMutation = (options?: Partial<Options<PutApiV1DiagnosesByUuidData>>): UseMutationOptions<PutApiV1DiagnosesByUuidResponse, PutApiV1DiagnosesByUuidError, Options<PutApiV1DiagnosesByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1DiagnosesByUuidResponse, PutApiV1DiagnosesByUuidError, Options<PutApiV1DiagnosesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutDiagnosesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMedicaldataListQueryKey = (options?: Options<GetApiV1MedicaldataListData>) => createQueryKey('getApiV1MedicaldataList', options);

/**
 * List Supported Medical Data
 *
 * List all medical data measurement types supported by Seerlinq (blood
 * pressure, weight, lab results, etc.).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicaldataListOptions = (options?: Options<GetApiV1MedicaldataListData>) => queryOptions<GetApiV1MedicaldataListResponse, GetApiV1MedicaldataListError, GetApiV1MedicaldataListResponse, ReturnType<typeof apiGetMedicaldataListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicaldataList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicaldataListQueryKey(options)
});

export const apiGetMedicaldataQueryKey = (options?: Options<GetApiV1MedicaldataData>) => createQueryKey('getApiV1Medicaldata', options);

/**
 * Get Medical Data
 *
 * List clinical medical data (blood pressure, weight, lab results, etc.).
 * Filter by patient IDs, measurement type (glob syntax), and date range.
 * This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicaldataOptions = (options?: Options<GetApiV1MedicaldataData>) => queryOptions<GetApiV1MedicaldataResponse, GetApiV1MedicaldataError, GetApiV1MedicaldataResponse, ReturnType<typeof apiGetMedicaldataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicaldata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicaldataQueryKey(options)
});

/**
 * Create Medical Data
 *
 * Create new medical data. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicaldataMutation = (options?: Partial<Options<PostApiV1MedicaldataData>>): UseMutationOptions<PostApiV1MedicaldataResponse, PostApiV1MedicaldataError, Options<PostApiV1MedicaldataData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicaldataResponse, PostApiV1MedicaldataError, Options<PostApiV1MedicaldataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicaldata({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMedicaldataLastQueryKey = (options: Options<GetApiV1MedicaldataLastData>) => createQueryKey('getApiV1MedicaldataLast', options);

/**
 * Get Last Medical Data Per Patient
 *
 * Get the last N medical data entries for a patient, ordered by measurement
 * date. Default N=5. This endpoint is subject to filtering by data visibility
 * dimension, last _N_ data points are taken after the filtering.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicaldataLastOptions = (options: Options<GetApiV1MedicaldataLastData>) => queryOptions<GetApiV1MedicaldataLastResponse, GetApiV1MedicaldataLastError, GetApiV1MedicaldataLastResponse, ReturnType<typeof apiGetMedicaldataLastQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicaldataLast({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicaldataLastQueryKey(options)
});

/**
 * Create Medical Data Bulk
 *
 * Create new medical data in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicaldataBulkMutation = (options?: Partial<Options<PostApiV1MedicaldataBulkData>>): UseMutationOptions<PostApiV1MedicaldataBulkResponse, PostApiV1MedicaldataBulkError, Options<PostApiV1MedicaldataBulkData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicaldataBulkResponse, PostApiV1MedicaldataBulkError, Options<PostApiV1MedicaldataBulkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicaldataBulk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Medical Data
 *
 * Delete medical data by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> See the _API description_ for more info.
 */
export const apiDeleteMedicaldataByUuidMutation = (options?: Partial<Options<DeleteApiV1MedicaldataByUuidData>>): UseMutationOptions<DeleteApiV1MedicaldataByUuidResponse, DeleteApiV1MedicaldataByUuidError, Options<DeleteApiV1MedicaldataByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MedicaldataByUuidResponse, DeleteApiV1MedicaldataByUuidError, Options<DeleteApiV1MedicaldataByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMedicaldataUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Medical Data
 *
 * Update/edit medical data given its UUID. The **admin** role can update all
 * medical data, while lower access levels can update only medical data they
 * created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicaldataByUuidMutation = (options?: Partial<Options<PutApiV1MedicaldataByUuidData>>): UseMutationOptions<PutApiV1MedicaldataByUuidResponse, PutApiV1MedicaldataByUuidError, Options<PutApiV1MedicaldataByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1MedicaldataByUuidResponse, PutApiV1MedicaldataByUuidError, Options<PutApiV1MedicaldataByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutMedicaldataUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMedicationsMedicationGroupsQueryKey = (options?: Options<GetApiV1MedicationsMedicationGroupsData>) => createQueryKey('getApiV1MedicationsMedicationGroups', options);

/**
 * List Medication Groups
 *
 * Return all medication drug classes; GDMT-scored classes carry a gdmt
 * section, and medications with dosages within those classes are
 * GDMT-relevant.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicationsMedicationGroupsOptions = (options?: Options<GetApiV1MedicationsMedicationGroupsData>) => queryOptions<GetApiV1MedicationsMedicationGroupsResponse, GetApiV1MedicationsMedicationGroupsError, GetApiV1MedicationsMedicationGroupsResponse, ReturnType<typeof apiGetMedicationsMedicationGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicationsMedicationGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicationsMedicationGroupsQueryKey(options)
});

export const apiGetMedicationsQueryKey = (options?: Options<GetApiV1MedicationsData>) => createQueryKey('getApiV1Medications', options);

/**
 * Get Medications
 *
 * List all medications in the DB. It is possible to filter by patient IDs and
 * search string based on the `medication_name` field (we use the `glob`
 * syntax, where `*` matches any characters). This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicationsOptions = (options?: Options<GetApiV1MedicationsData>) => queryOptions<GetApiV1MedicationsResponse, GetApiV1MedicationsError, GetApiV1MedicationsResponse, ReturnType<typeof apiGetMedicationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicationsQueryKey(options)
});

/**
 * Create Medication
 *
 * Create a new medication. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicationsMutation = (options?: Partial<Options<PostApiV1MedicationsData>>): UseMutationOptions<PostApiV1MedicationsResponse, PostApiV1MedicationsError, Options<PostApiV1MedicationsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicationsResponse, PostApiV1MedicationsError, Options<PostApiV1MedicationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedications({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Medications Bulk
 *
 * Create new medications in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicationsBulkMutation = (options?: Partial<Options<PostApiV1MedicationsBulkData>>): UseMutationOptions<PostApiV1MedicationsBulkResponse, PostApiV1MedicationsBulkError, Options<PostApiV1MedicationsBulkData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicationsBulkResponse, PostApiV1MedicationsBulkError, Options<PostApiV1MedicationsBulkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicationsBulk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Medication
 *
 * Delete a medication by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> See the _API description_ for more info.
 */
export const apiDeleteMedicationsByUuidMutation = (options?: Partial<Options<DeleteApiV1MedicationsByUuidData>>): UseMutationOptions<DeleteApiV1MedicationsByUuidResponse, DeleteApiV1MedicationsByUuidError, Options<DeleteApiV1MedicationsByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MedicationsByUuidResponse, DeleteApiV1MedicationsByUuidError, Options<DeleteApiV1MedicationsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMedicationsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Medication
 *
 * Update/edit a medication given its UUID. The **admin** role can update all
 * medications, while lower access levels can update only medications they
 * created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicationsByUuidMutation = (options?: Partial<Options<PutApiV1MedicationsByUuidData>>): UseMutationOptions<PutApiV1MedicationsByUuidResponse, PutApiV1MedicationsByUuidError, Options<PutApiV1MedicationsByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1MedicationsByUuidResponse, PutApiV1MedicationsByUuidError, Options<PutApiV1MedicationsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutMedicationsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change Medication Dosage
 *
 * Change medication dose/dosage given its UUID. This updates the original
 * medication and sets its `medication_ended` date and creates a new record in
 * the medication table with the same patient ID and medication name, sets its
 * `medication_started` date and sets new dose, unit, and dosage. When creating
 * new medication, the fields that are not defined are copied over from the
 * original medication (i.e., setting only new dosage via this endpoint will
 * create a new medication with the same dose and unit as the old one). The
 * **admin** role can change dosage for all medications, **monitoring** users
 * can change medication dosage for patients based on their visibility, while
 * lower access levels can update only schedules they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicationsChangeByUuidMutation = (options?: Partial<Options<PutApiV1MedicationsChangeByUuidData>>): UseMutationOptions<PutApiV1MedicationsChangeByUuidResponse, PutApiV1MedicationsChangeByUuidError, Options<PutApiV1MedicationsChangeByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1MedicationsChangeByUuidResponse, PutApiV1MedicationsChangeByUuidError, Options<PutApiV1MedicationsChangeByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutMedicationsChangeUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetSymptomsListQueryKey = (options?: Options<GetApiV1SymptomsListData>) => createQueryKey('getApiV1SymptomsList', options);

/**
 * List Supported Symptoms
 *
 * List all supported symptoms.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSymptomsListOptions = (options?: Options<GetApiV1SymptomsListData>) => queryOptions<GetApiV1SymptomsListResponse, GetApiV1SymptomsListError, GetApiV1SymptomsListResponse, ReturnType<typeof apiGetSymptomsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetSymptomsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetSymptomsListQueryKey(options)
});

export const apiGetSymptomsQueryKey = (options?: Options<GetApiV1SymptomsData>) => createQueryKey('getApiV1Symptoms', options);

/**
 * Get Symptoms
 *
 * List all symptoms in the DB. It is possible to filter by patient IDs and
 * search string based on the `symptom_name` field (we use the `glob` syntax,
 * where `*` matches any characters). This endpoint is subject to filtering by
 * data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSymptomsOptions = (options?: Options<GetApiV1SymptomsData>) => queryOptions<GetApiV1SymptomsResponse, GetApiV1SymptomsError, GetApiV1SymptomsResponse, ReturnType<typeof apiGetSymptomsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetSymptoms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetSymptomsQueryKey(options)
});

/**
 * Create Symptom
 *
 * Create a new symptom. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostSymptomsMutation = (options?: Partial<Options<PostApiV1SymptomsData>>): UseMutationOptions<PostApiV1SymptomsResponse, PostApiV1SymptomsError, Options<PostApiV1SymptomsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1SymptomsResponse, PostApiV1SymptomsError, Options<PostApiV1SymptomsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostSymptoms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetSymptomsLastQueryKey = (options: Options<GetApiV1SymptomsLastData>) => createQueryKey('getApiV1SymptomsLast', options);

/**
 * Get Last Symptoms Per Patient
 *
 * List the last _N_ symptoms for a given patient ID and given _N_, ordered
 * by symptom date. This endpoint is subject to filtering by data visibility
 * dimension, last _N_ data points are taken after the filtering.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSymptomsLastOptions = (options: Options<GetApiV1SymptomsLastData>) => queryOptions<GetApiV1SymptomsLastResponse, GetApiV1SymptomsLastError, GetApiV1SymptomsLastResponse, ReturnType<typeof apiGetSymptomsLastQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetSymptomsLast({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetSymptomsLastQueryKey(options)
});

/**
 * Delete Symptom
 *
 * Delete a symptom by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteSymptomsByUuidMutation = (options?: Partial<Options<DeleteApiV1SymptomsByUuidData>>): UseMutationOptions<DeleteApiV1SymptomsByUuidResponse, DeleteApiV1SymptomsByUuidError, Options<DeleteApiV1SymptomsByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1SymptomsByUuidResponse, DeleteApiV1SymptomsByUuidError, Options<DeleteApiV1SymptomsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteSymptomsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Symptom
 *
 * Update/edit a symptom given its UUID. The **admin** role can update all
 * symptoms, while lower access levels can update only symptoms they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutSymptomsByUuidMutation = (options?: Partial<Options<PutApiV1SymptomsByUuidData>>): UseMutationOptions<PutApiV1SymptomsByUuidResponse, PutApiV1SymptomsByUuidError, Options<PutApiV1SymptomsByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1SymptomsByUuidResponse, PutApiV1SymptomsByUuidError, Options<PutApiV1SymptomsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutSymptomsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetQuestionnairesByQuestionnaireTypeByLanguageQueryKey = (options: Options<GetApiV1QuestionnairesByQuestionnaireTypeByLanguageData>) => createQueryKey('getApiV1QuestionnairesByQuestionnaireTypeByLanguage', options);

/**
 * Get Questionnaire
 *
 * Get questionnaire definition given the questionnaire type and language.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesByQuestionnaireTypeByLanguageOptions = (options: Options<GetApiV1QuestionnairesByQuestionnaireTypeByLanguageData>) => queryOptions<GetApiV1QuestionnairesByQuestionnaireTypeByLanguageResponse, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageError, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageResponse, ReturnType<typeof apiGetQuestionnairesByQuestionnaireTypeByLanguageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetQuestionnairesQuestionnaireTypeLanguage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetQuestionnairesByQuestionnaireTypeByLanguageQueryKey(options)
});

export const apiGetQuestionnairesShouldFillByQuestionnaireTypeByPatientIdQueryKey = (options: Options<GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdData>) => createQueryKey('getApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientId', options);

/**
 * Should Fill Questionnaire
 *
 * Check if given patient should fill the given questionnaire.
 */
export const apiGetQuestionnairesShouldFillByQuestionnaireTypeByPatientIdOptions = (options: Options<GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdData>) => queryOptions<GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdResponse, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdError, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdResponse, ReturnType<typeof apiGetQuestionnairesShouldFillByQuestionnaireTypeByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetQuestionnairesShouldFillQuestionnaireTypePatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetQuestionnairesShouldFillByQuestionnaireTypeByPatientIdQueryKey(options)
});

export const apiGetQuestionnairesQueryKey = (options?: Options<GetApiV1QuestionnairesData>) => createQueryKey('getApiV1Questionnaires', options);

/**
 * Get Filled Questionnaires
 *
 * List of filled questionnaires in the DB. It is possible to filter by patient
 * IDs and questionnaire types. Moreover, user can select the strategy for
 * multiple questionnaires per patient, the endpoint can return all patients'
 * questionnaires, the last questionnaire per patient, or the first
 * questionnaire per patient. The `per_patient` parameter aggregates for each
 * questionnaire type. This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesOptions = (options?: Options<GetApiV1QuestionnairesData>) => queryOptions<GetApiV1QuestionnairesResponse, GetApiV1QuestionnairesError, GetApiV1QuestionnairesResponse, ReturnType<typeof apiGetQuestionnairesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetQuestionnaires({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetQuestionnairesQueryKey(options)
});

/**
 * Fill Questionnaire
 *
 * Fill a questionnaire. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostQuestionnairesMutation = (options?: Partial<Options<PostApiV1QuestionnairesData>>): UseMutationOptions<PostApiV1QuestionnairesResponse, PostApiV1QuestionnairesError, Options<PostApiV1QuestionnairesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1QuestionnairesResponse, PostApiV1QuestionnairesError, Options<PostApiV1QuestionnairesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostQuestionnaires({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetQuestionnairesStatsByQuestionnaireTypePatientByPatientIdQueryKey = (options: Options<GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdData>) => createQueryKey('getApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientId', options);

/**
 * Get Questionnaires Stats Per Patient
 *
 * Get summary of filled questionnaires for a given questionnaire type and
 * given patient ID. This returns a responses table with rows encoding
 * questions (as integers) and different filling times as columns. The last
 * column displays summary statistics (ordinal question -> median, continuous
 * question -> mean, choice questions -> mode). This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesStatsByQuestionnaireTypePatientByPatientIdOptions = (options: Options<GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdData>) => queryOptions<GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdResponse, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdError, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdResponse, ReturnType<typeof apiGetQuestionnairesStatsByQuestionnaireTypePatientByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetQuestionnairesStatsQuestionnaireTypePatientPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetQuestionnairesStatsByQuestionnaireTypePatientByPatientIdQueryKey(options)
});

export const apiGetQuestionnairesStatsByQuestionnaireTypeOverallQueryKey = (options: Options<GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallData>) => createQueryKey('getApiV1QuestionnairesStatsByQuestionnaireTypeOverall', options);

/**
 * Get Questionnaires Stats
 *
 * Get summary of filled questionnaires for a given questionnaire type for
 * multiple patients (possible to filter). One questionnaires is selected for
 * each patient based on `per_patient` query parameter: `last` takes the last
 * filled questionnaire per patient, `first` takes the first filled
 * questionnaire per patient, while `aggregate` aggregates all questionnaires
 * for each patient based on the same aggregation logic as summary statistics.
 * This returns a responses table with rows encoding patient IDs and questions
 * as columns. The last row displays summary statistics (ordinal question ->
 * median, continuous question -> mean, choice questions -> mode). This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesStatsByQuestionnaireTypeOverallOptions = (options: Options<GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallData>) => queryOptions<GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallResponse, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallError, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallResponse, ReturnType<typeof apiGetQuestionnairesStatsByQuestionnaireTypeOverallQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetQuestionnairesStatsQuestionnaireTypeOverall({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetQuestionnairesStatsByQuestionnaireTypeOverallQueryKey(options)
});

/**
 * Skip Questionnaire
 *
 * Record that a patient skipped a questionnaire instead of filling it in.
 * Only accepted if the questionnaire is configured as skippable for this
 * patient. This does not create a filled questionnaire - it just pushes
 * the next scheduled prompt out the same way a real fill would.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostQuestionnairesSkipByQuestionnaireTypeByPatientIdMutation = (options?: Partial<Options<PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdData>>): UseMutationOptions<PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdResponse, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdError, Options<PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdResponse, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdError, Options<PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostQuestionnairesSkipQuestionnaireTypePatientId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Filled Questionnaire
 *
 * Delete filled questionnaire by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeleteQuestionnairesByUuidMutation = (options?: Partial<Options<DeleteApiV1QuestionnairesByUuidData>>): UseMutationOptions<DeleteApiV1QuestionnairesByUuidResponse, DeleteApiV1QuestionnairesByUuidError, Options<DeleteApiV1QuestionnairesByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1QuestionnairesByUuidResponse, DeleteApiV1QuestionnairesByUuidError, Options<DeleteApiV1QuestionnairesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteQuestionnairesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Filled Questionnaire
 *
 * Update/edit filled questionnaire given its UUID. The **admin** role can
 * update all questionnaires (and all fields) and **monitoring** users can
 * update questionnaires based on their visibility. Also, **monitoring** users
 * can only update questionnaire comment, not the actual responses.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutQuestionnairesByUuidMutation = (options?: Partial<Options<PutApiV1QuestionnairesByUuidData>>): UseMutationOptions<PutApiV1QuestionnairesByUuidResponse, PutApiV1QuestionnairesByUuidError, Options<PutApiV1QuestionnairesByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1QuestionnairesByUuidResponse, PutApiV1QuestionnairesByUuidError, Options<PutApiV1QuestionnairesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutQuestionnairesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetQuestionnairesGetByQuestionnaireTypeByLanguageQueryKey = (options: Options<GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageData>) => createQueryKey('getApiV2QuestionnairesGetByQuestionnaireTypeByLanguage', options);

/**
 * Get Questionnaire V2
 *
 * Get questionnaire definition given the questionnaire type and language.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesGetByQuestionnaireTypeByLanguageOptions = (options: Options<GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageData>) => queryOptions<GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageResponse, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageError, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageResponse, ReturnType<typeof apiGetQuestionnairesGetByQuestionnaireTypeByLanguageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetV2QuestionnairesGetQuestionnaireTypeLanguage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetQuestionnairesGetByQuestionnaireTypeByLanguageQueryKey(options)
});

export const apiGetQuestionnairesShouldFillByPatientIdQueryKey = (options: Options<GetApiV2QuestionnairesShouldFillByPatientIdData>) => createQueryKey('getApiV2QuestionnairesShouldFillByPatientId', options);

/**
 * Should Fill Questionnaires
 *
 * Check if given patient should fill any of the questionnaires (except
 * `dummy` questionnaire for testing purposes).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesShouldFillByPatientIdOptions = (options: Options<GetApiV2QuestionnairesShouldFillByPatientIdData>) => queryOptions<GetApiV2QuestionnairesShouldFillByPatientIdResponse, GetApiV2QuestionnairesShouldFillByPatientIdError, GetApiV2QuestionnairesShouldFillByPatientIdResponse, ReturnType<typeof apiGetQuestionnairesShouldFillByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetV2QuestionnairesShouldFillPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetQuestionnairesShouldFillByPatientIdQueryKey(options)
});

export const apiGetPpgQueryKey = (options?: Options<GetApiV1PpgData>) => createQueryKey('getApiV1Ppg', options);

/**
 * Get Ppg Data
 *
 * List all PPG data in the DB. It is possible to filter by patient IDs,
 * measurement conditions, measurement devices, measurement origins, and by
 * specifying to -- from datetimes. This endpoint is subject to filtering by
 * data visibility dimension. This endpoint returns only metadata of the PPG,
 * not the actual time series.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPpgOptions = (options?: Options<GetApiV1PpgData>) => queryOptions<GetApiV1PpgResponse, GetApiV1PpgError, GetApiV1PpgResponse, ReturnType<typeof apiGetPpgQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPpg({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPpgQueryKey(options)
});

export const apiGetPpgInfiniteQueryKey = (options?: Options<GetApiV1PpgData>): QueryKey<Options<GetApiV1PpgData>> => createQueryKey('getApiV1Ppg', options, true);

/**
 * Get Ppg Data
 *
 * List all PPG data in the DB. It is possible to filter by patient IDs,
 * measurement conditions, measurement devices, measurement origins, and by
 * specifying to -- from datetimes. This endpoint is subject to filtering by
 * data visibility dimension. This endpoint returns only metadata of the PPG,
 * not the actual time series.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPpgInfiniteOptions = (options?: Options<GetApiV1PpgData>) => infiniteQueryOptions<GetApiV1PpgResponse, GetApiV1PpgError, InfiniteData<GetApiV1PpgResponse>, QueryKey<Options<GetApiV1PpgData>>, number | Pick<QueryKey<Options<GetApiV1PpgData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1PpgData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetPpg({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPpgInfiniteQueryKey(options)
});

export const apiGetPpgLastQueryKey = (options: Options<GetApiV1PpgLastData>) => createQueryKey('getApiV1PpgLast', options);

/**
 * Get Last Ppg Data Per Patient
 *
 * List the last _N_ PPG data for a given patient ID and given _N_, ordered by
 * measurement datetime. This endpoint is subject to filtering by data
 * visibility dimension. This endpoint returns only metadata of the PPG, not
 * the actual time series.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPpgLastOptions = (options: Options<GetApiV1PpgLastData>) => queryOptions<GetApiV1PpgLastResponse, GetApiV1PpgLastError, GetApiV1PpgLastResponse, ReturnType<typeof apiGetPpgLastQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPpgLast({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPpgLastQueryKey(options)
});

/**
 * Delete Ppg
 *
 * Delete PPG data by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeletePpgByUuidMutation = (options?: Partial<Options<DeleteApiV1PpgByUuidData>>): UseMutationOptions<DeleteApiV1PpgByUuidResponse, DeleteApiV1PpgByUuidError, Options<DeleteApiV1PpgByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PpgByUuidResponse, DeleteApiV1PpgByUuidError, Options<DeleteApiV1PpgByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeletePpgUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPpgByUuidQueryKey = (options: Options<GetApiV1PpgByUuidData>) => createQueryKey('getApiV1PpgByUuid', options);

/**
 * Get Ppg Data By Uuid
 *
 * Get single PPG data by its UUID. This endpoint is subject to filtering by
 * data visibility dimension. This endpoint returns the actual PPG data time
 * series for users holding the `PPG_RAW` permission, otherwise returns only
 * metadata of the PPG.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPpgByUuidOptions = (options: Options<GetApiV1PpgByUuidData>) => queryOptions<GetApiV1PpgByUuidResponse, GetApiV1PpgByUuidError, GetApiV1PpgByUuidResponse, ReturnType<typeof apiGetPpgByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPpgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPpgByUuidQueryKey(options)
});

/**
 * Update Ppg
 *
 * Update/edit PPG data given its UUID. Fields that can be updated differ by
 * the user access (see schemas). **Medical** and **monitoring** users can
 * update PPG data that they did not create, but update rules are subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutPpgByUuidMutation = (options?: Partial<Options<PutApiV1PpgByUuidData>>): UseMutationOptions<PutApiV1PpgByUuidResponse, PutApiV1PpgByUuidError, Options<PutApiV1PpgByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PpgByUuidResponse, PutApiV1PpgByUuidError, Options<PutApiV1PpgByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutPpgUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Smartcare Ppg
 *
 * Create a new PPG data measurement from a SmartCare device. This endpoint is
 * subject to filtering by data visibility dimension. The input schema is
 * passed as a query, and the actual CSV file is passed as multipart/form-data.
 * Calling this endpoint will change patient's status to `active` when
 * applicable.
 *
 * The PPG data created using this endpoint are sent to automatic processing to
 * `celery` algorithms. The following algorithms or workflows are automatically
 * triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 * - `afib`: computes probability of atrial fibrillation in the data
 */
export const apiPostPpgSmartcareMutation = (options?: Partial<Options<PostApiV1PpgSmartcareData>>): UseMutationOptions<PostApiV1PpgSmartcareResponse, PostApiV1PpgSmartcareError, Options<PostApiV1PpgSmartcareData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PpgSmartcareResponse, PostApiV1PpgSmartcareError, Options<PostApiV1PpgSmartcareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPpgSmartcare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Berry Oxi Ppg
 *
 * Create a new PPG data measurement from a Berry oximeter device. This
 * endpoint is subject to filtering by data visibility dimension. The data are
 * passed inside the JSON body. Calling this endpoint will change patient's
 * status to `active` when applicable.
 *
 * **Important note**: The PPG time series is passed as a list of lists of
 * floats (`list[list[float]]`), where the outer list length is 2 (as per 2
 * wavelengths: **red** and **IR** -- the order is _important_), and the inner
 * list length is the length of the measurement in samples.
 *
 * The PPG data created using this endpoint are sent to automatic processing to
 * `celery` algorithms. The following algorithms or workflows are automatically
 * triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 * - `afib`: computes probability of atrial fibrillation in the data
 */
export const apiPostPpgBerryMutation = (options?: Partial<Options<PostApiV1PpgBerryData>>): UseMutationOptions<PostApiV1PpgBerryResponse, PostApiV1PpgBerryError, Options<PostApiV1PpgBerryData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PpgBerryResponse, PostApiV1PpgBerryError, Options<PostApiV1PpgBerryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPpgBerry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Viatom Ppg
 *
 * Create a new PPG data measurement from a Viatom O2Ring-family device
 * (Oxyfit). This endpoint is subject to filtering by data visibility
 * dimension. The data are passed inside the JSON body. Calling this
 * endpoint will change patient's status to `active` when applicable.
 *
 * **Important note**: `state_bytes` come from separate parameter polls
 * interleaved into the waveform stream, so they may differ in length from
 * the PPG time series, or be empty.
 *
 * The PPG data created using this endpoint are sent to automatic
 * processing to `celery` algorithms. The following algorithms or workflows
 * are automatically triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 * - `afib`: computes probability of atrial fibrillation in the data
 */
export const apiPostPpgViatomMutation = (options?: Partial<Options<PostApiV1PpgViatomData>>): UseMutationOptions<PostApiV1PpgViatomResponse, PostApiV1PpgViatomError, Options<PostApiV1PpgViatomData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PpgViatomResponse, PostApiV1PpgViatomError, Options<PostApiV1PpgViatomData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPpgViatom({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Samsung Watch Ppg
 *
 * Create a new PPG data measurement from a Samsung smartwatch device. This
 * endpoint is subject to filtering by data visibility dimension. The input
 * schema is passed as a query, and the actual CSV files (one per wavelength)
 * are passed as multipart/form-data. Calling this endpoint will change
 * patient's status to `active` when applicable.
 *
 * The PPG data created using this endpoint are sent to automatic processing to
 * `celery` algorithms. The following algorithms or workflows are automatically
 * triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 */
export const apiPostPpgSamsungMutation = (options?: Partial<Options<PostApiV1PpgSamsungData>>): UseMutationOptions<PostApiV1PpgSamsungResponse, PostApiV1PpgSamsungError, Options<PostApiV1PpgSamsungData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PpgSamsungResponse, PostApiV1PpgSamsungError, Options<PostApiV1PpgSamsungData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPpgSamsung({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Mobile App Ppg
 *
 * Create a new PPG data measurement from the mobile app using the built-in
 * camera. This endpoint is subject to filtering by data visibility dimension.
 * The data are passed inside the JSON body. Calling this endpoint will change
 * patient's status to `active` when applicable.
 */
export const apiPostPpgMobileMutation = (options?: Partial<Options<PostApiV1PpgMobileData>>): UseMutationOptions<PostApiV1PpgMobileResponse, PostApiV1PpgMobileError, Options<PostApiV1PpgMobileData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PpgMobileResponse, PostApiV1PpgMobileError, Options<PostApiV1PpgMobileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPpgMobile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Generic Ppg
 *
 * Create a new PPG generic data measurement. This endpoint is subject to
 * filtering by data visibility dimension. The data are passed inside the JSON
 * body.
 *
 * This endpoint optionally also sends PPG data for automatic processing
 * to `celery` algorithms. The following algorithms or workflows are optionally
 * triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPpgGenericMutation = (options?: Partial<Options<PostApiV1PpgGenericData>>): UseMutationOptions<PostApiV1PpgGenericResponse, PostApiV1PpgGenericError, Options<PostApiV1PpgGenericData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PpgGenericResponse, PostApiV1PpgGenericError, Options<PostApiV1PpgGenericData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPpgGeneric({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetEcgQueryKey = (options?: Options<GetApiV1EcgData>) => createQueryKey('getApiV1Ecg', options);

/**
 * Get Ecg Data
 *
 * List all ECG data in the DB. It is possible to filter by patient IDs,
 * measurement devices, and by specifying to -- from datetimes. This endpoint
 * is subject to filtering by data visibility dimension. This endpoint returns
 * only metadata of the ECG, not the actual time series.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ecg Meta (46)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgOptions = (options?: Options<GetApiV1EcgData>) => queryOptions<GetApiV1EcgResponse, GetApiV1EcgError, GetApiV1EcgResponse, ReturnType<typeof apiGetEcgQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetEcg({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEcgQueryKey(options)
});

export const apiGetEcgInfiniteQueryKey = (options?: Options<GetApiV1EcgData>): QueryKey<Options<GetApiV1EcgData>> => createQueryKey('getApiV1Ecg', options, true);

/**
 * Get Ecg Data
 *
 * List all ECG data in the DB. It is possible to filter by patient IDs,
 * measurement devices, and by specifying to -- from datetimes. This endpoint
 * is subject to filtering by data visibility dimension. This endpoint returns
 * only metadata of the ECG, not the actual time series.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ecg Meta (46)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgInfiniteOptions = (options?: Options<GetApiV1EcgData>) => infiniteQueryOptions<GetApiV1EcgResponse, GetApiV1EcgError, InfiniteData<GetApiV1EcgResponse>, QueryKey<Options<GetApiV1EcgData>>, number | Pick<QueryKey<Options<GetApiV1EcgData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1EcgData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetEcg({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEcgInfiniteQueryKey(options)
});

/**
 * Delete Ecg
 *
 * Delete ECG data by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteEcgByUuidMutation = (options?: Partial<Options<DeleteApiV1EcgByUuidData>>): UseMutationOptions<DeleteApiV1EcgByUuidResponse, DeleteApiV1EcgByUuidError, Options<DeleteApiV1EcgByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1EcgByUuidResponse, DeleteApiV1EcgByUuidError, Options<DeleteApiV1EcgByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteEcgUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetEcgByUuidQueryKey = (options: Options<GetApiV1EcgByUuidData>) => createQueryKey('getApiV1EcgByUuid', options);

/**
 * Get Ecg Data By Uuid
 *
 * Get single ECG data by its UUID. This endpoint is subject to filtering by
 * data visibility dimension. This endpoint returns the actual ECG data time
 * series for users holding the `ECG_RAW` permission, otherwise returns only
 * metadata of the ECG.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ecg Meta (46)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgByUuidOptions = (options: Options<GetApiV1EcgByUuidData>) => queryOptions<GetApiV1EcgByUuidResponse, GetApiV1EcgByUuidError, GetApiV1EcgByUuidResponse, ReturnType<typeof apiGetEcgByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetEcgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEcgByUuidQueryKey(options)
});

/**
 * Update Ecg
 *
 * Update/edit ECG data given its UUID. Fields that can be updated differ by
 * the user access (see schemas). **Medical** and **monitoring** users can
 * update ECG data that they did not create, but update rules are subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ecg Meta (46)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutEcgByUuidMutation = (options?: Partial<Options<PutApiV1EcgByUuidData>>): UseMutationOptions<PutApiV1EcgByUuidResponse, PutApiV1EcgByUuidError, Options<PutApiV1EcgByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1EcgByUuidResponse, PutApiV1EcgByUuidError, Options<PutApiV1EcgByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutEcgUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Alivecor Ecg
 *
 * Create a new ECG data measurement from a AliveCor ECG devices. This endpoint
 * is subject to filtering by data visibility dimension. The data are passed
 * inside the JSON body.
 *
 * This endpoint takes only the measurement metadata and actual ECG time
 * series. To submit other data types, use appropriate endpoints _after_ this
 * request (as you will need UUID of newly saved ECG data for reference):
 * - average beat data block: TBA
 * - beat annotations + AliveCor algorithm determination:
 * `ecg-derived/alivecor`
 * - accelerometer data: TBA
 */
export const apiPostEcgAlivecorMutation = (options?: Partial<Options<PostApiV1EcgAlivecorData>>): UseMutationOptions<PostApiV1EcgAlivecorResponse, PostApiV1EcgAlivecorError, Options<PostApiV1EcgAlivecorData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1EcgAlivecorResponse, PostApiV1EcgAlivecorError, Options<PostApiV1EcgAlivecorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostEcgAlivecor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Generic Ecg
 *
 * Create a new ECG generic data measurement. This endpoint is subject to
 * filtering by data visibility dimension. The data are passed inside the JSON
 * body.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostEcgGenericMutation = (options?: Partial<Options<PostApiV1EcgGenericData>>): UseMutationOptions<PostApiV1EcgGenericResponse, PostApiV1EcgGenericError, Options<PostApiV1EcgGenericData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1EcgGenericResponse, PostApiV1EcgGenericError, Options<PostApiV1EcgGenericData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostEcgGeneric({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetAuxiliaryQueryKey = (options?: Options<GetApiV1AuxiliaryData>) => createQueryKey('getApiV1Auxiliary', options);

/**
 * Get Auxiliary Time Series
 *
 * Get auxiliary time series data for patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliaryOptions = (options?: Options<GetApiV1AuxiliaryData>) => queryOptions<GetApiV1AuxiliaryResponse, GetApiV1AuxiliaryError, GetApiV1AuxiliaryResponse, ReturnType<typeof apiGetAuxiliaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuxiliary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuxiliaryQueryKey(options)
});

export const apiGetAuxiliaryInfiniteQueryKey = (options?: Options<GetApiV1AuxiliaryData>): QueryKey<Options<GetApiV1AuxiliaryData>> => createQueryKey('getApiV1Auxiliary', options, true);

/**
 * Get Auxiliary Time Series
 *
 * Get auxiliary time series data for patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliaryInfiniteOptions = (options?: Options<GetApiV1AuxiliaryData>) => infiniteQueryOptions<GetApiV1AuxiliaryResponse, GetApiV1AuxiliaryError, InfiniteData<GetApiV1AuxiliaryResponse>, QueryKey<Options<GetApiV1AuxiliaryData>>, number | Pick<QueryKey<Options<GetApiV1AuxiliaryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1AuxiliaryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetAuxiliary({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuxiliaryInfiniteQueryKey(options)
});

/**
 * Delete Auxiliary Time Series
 *
 * Delete auxiliary time series data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteAuxiliaryByUuidMutation = (options?: Partial<Options<DeleteApiV1AuxiliaryByUuidData>>): UseMutationOptions<DeleteApiV1AuxiliaryByUuidResponse, DeleteApiV1AuxiliaryByUuidError, Options<DeleteApiV1AuxiliaryByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1AuxiliaryByUuidResponse, DeleteApiV1AuxiliaryByUuidError, Options<DeleteApiV1AuxiliaryByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteAuxiliaryUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetAuxiliaryByUuidQueryKey = (options: Options<GetApiV1AuxiliaryByUuidData>) => createQueryKey('getApiV1AuxiliaryByUuid', options);

/**
 * Get Auxiliary Time Series By Uuid
 *
 * Get auxiliary time series data by UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliaryByUuidOptions = (options: Options<GetApiV1AuxiliaryByUuidData>) => queryOptions<GetApiV1AuxiliaryByUuidResponse, GetApiV1AuxiliaryByUuidError, GetApiV1AuxiliaryByUuidResponse, ReturnType<typeof apiGetAuxiliaryByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuxiliaryUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuxiliaryByUuidQueryKey(options)
});

export const apiGetAuxiliaryEcgByEcgUuidQueryKey = (options: Options<GetApiV1AuxiliaryEcgByEcgUuidData>) => createQueryKey('getApiV1AuxiliaryEcgByEcgUuid', options);

/**
 * Get Auxiliary Data By Ecg Uuid
 *
 * Get all auxiliary data by original ECG UUID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliaryEcgByEcgUuidOptions = (options: Options<GetApiV1AuxiliaryEcgByEcgUuidData>) => queryOptions<GetApiV1AuxiliaryEcgByEcgUuidResponse, GetApiV1AuxiliaryEcgByEcgUuidError, GetApiV1AuxiliaryEcgByEcgUuidResponse, ReturnType<typeof apiGetAuxiliaryEcgByEcgUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuxiliaryEcgEcgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuxiliaryEcgByEcgUuidQueryKey(options)
});

export const apiGetAuxiliaryPpgByPpgUuidQueryKey = (options: Options<GetApiV1AuxiliaryPpgByPpgUuidData>) => createQueryKey('getApiV1AuxiliaryPpgByPpgUuid', options);

/**
 * Get Auxiliary Data By Ppg Uuid
 *
 * Get all auxiliary data by original PPG UUID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliaryPpgByPpgUuidOptions = (options: Options<GetApiV1AuxiliaryPpgByPpgUuidData>) => queryOptions<GetApiV1AuxiliaryPpgByPpgUuidResponse, GetApiV1AuxiliaryPpgByPpgUuidError, GetApiV1AuxiliaryPpgByPpgUuidResponse, ReturnType<typeof apiGetAuxiliaryPpgByPpgUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAuxiliaryPpgPpgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuxiliaryPpgByPpgUuidQueryKey(options)
});

/**
 * Create Auxiliary Time Series Accelerometer
 *
 * Create new auxiliary time series data for accelerometer.
 */
export const apiPostAuxiliaryAccelerometerMutation = (options?: Partial<Options<PostApiV1AuxiliaryAccelerometerData>>): UseMutationOptions<PostApiV1AuxiliaryAccelerometerResponse, PostApiV1AuxiliaryAccelerometerError, Options<PostApiV1AuxiliaryAccelerometerData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuxiliaryAccelerometerResponse, PostApiV1AuxiliaryAccelerometerError, Options<PostApiV1AuxiliaryAccelerometerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAuxiliaryAccelerometer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Auxiliary Time Series Gyrometer
 *
 * Create new auxiliary time series data for gyrometer.
 */
export const apiPostAuxiliaryGyrometerMutation = (options?: Partial<Options<PostApiV1AuxiliaryGyrometerData>>): UseMutationOptions<PostApiV1AuxiliaryGyrometerResponse, PostApiV1AuxiliaryGyrometerError, Options<PostApiV1AuxiliaryGyrometerData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuxiliaryGyrometerResponse, PostApiV1AuxiliaryGyrometerError, Options<PostApiV1AuxiliaryGyrometerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAuxiliaryGyrometer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Alivecor Ecg
 *
 * Create a new alivecore data average beat measurement
 * from a AliveCor ECG devices.
 */
export const apiPostAuxiliaryAlivecorAvgBeatMutation = (options?: Partial<Options<PostApiV1AuxiliaryAlivecorAvgBeatData>>): UseMutationOptions<PostApiV1AuxiliaryAlivecorAvgBeatResponse, PostApiV1AuxiliaryAlivecorAvgBeatError, Options<PostApiV1AuxiliaryAlivecorAvgBeatData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuxiliaryAlivecorAvgBeatResponse, PostApiV1AuxiliaryAlivecorAvgBeatError, Options<PostApiV1AuxiliaryAlivecorAvgBeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAuxiliaryAlivecorAvgBeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetLabelstudioTaskByProjectIdByPpgUuidQueryKey = (options: Options<GetApiV1LabelstudioTaskByProjectIdByPpgUuidData>) => createQueryKey('getApiV1LabelstudioTaskByProjectIdByPpgUuid', options);

/**
 * Get Task
 *
 * Get the Label Studio task for the provided PPG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetLabelstudioTaskByProjectIdByPpgUuidOptions = (options: Options<GetApiV1LabelstudioTaskByProjectIdByPpgUuidData>) => queryOptions<GetApiV1LabelstudioTaskByProjectIdByPpgUuidResponse, GetApiV1LabelstudioTaskByProjectIdByPpgUuidError, GetApiV1LabelstudioTaskByProjectIdByPpgUuidResponse, ReturnType<typeof apiGetLabelstudioTaskByProjectIdByPpgUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetLabelstudioTaskProjectIdPpgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetLabelstudioTaskByProjectIdByPpgUuidQueryKey(options)
});

export const apiGetLabelstudioRedirectByProjectIdByPpgUuidQueryKey = (options: Options<GetApiV1LabelstudioRedirectByProjectIdByPpgUuidData>) => createQueryKey('getApiV1LabelstudioRedirectByProjectIdByPpgUuid', options);

/**
 * Redirect
 *
 * Redirect to the Label Studio task for the provided PPG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetLabelstudioRedirectByProjectIdByPpgUuidOptions = (options: Options<GetApiV1LabelstudioRedirectByProjectIdByPpgUuidData>) => queryOptions<unknown, GetApiV1LabelstudioRedirectByProjectIdByPpgUuidError, unknown, ReturnType<typeof apiGetLabelstudioRedirectByProjectIdByPpgUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetLabelstudioRedirectProjectIdPpgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetLabelstudioRedirectByProjectIdByPpgUuidQueryKey(options)
});

export const apiGetMedicalReportsQueryKey = (options?: Options<GetApiV1MedicalReportsData>) => createQueryKey('getApiV1MedicalReports', options);

/**
 * Get Medical Reports
 *
 * List all medical reports - subject to visibility filtering based on the
 * user's access level in relation to the patients linked with the reports.
 * Optionally filter by patient IDs, date range and report type.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsOptions = (options?: Options<GetApiV1MedicalReportsData>) => queryOptions<GetApiV1MedicalReportsResponse, GetApiV1MedicalReportsError, GetApiV1MedicalReportsResponse, ReturnType<typeof apiGetMedicalReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicalReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicalReportsQueryKey(options)
});

/**
 * Create Medical Report
 *
 * Create a new medical report - subject to visibility filtering based on the
 * user's access level in relation to the patient linked with the report.
 *
 * The patient role can upload only a PDF file (422 otherwise).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsMutation = (options?: Partial<Options<PostApiV1MedicalReportsData>>): UseMutationOptions<PostApiV1MedicalReportsResponse, PostApiV1MedicalReportsError, Options<PostApiV1MedicalReportsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicalReportsResponse, PostApiV1MedicalReportsError, Options<PostApiV1MedicalReportsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicalReports({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Medical Report
 *
 * Delete a medical report by its UUID.
 *
 * 409 once a run was approved or rejected: that pair is ground truth and the
 * report is the only copy of what it was extracted from. Unreviewed runs
 * carry no such value and are dropped along with the report.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> See the _API description_ for more info.
 */
export const apiDeleteMedicalReportsByUuidMutation = (options?: Partial<Options<DeleteApiV1MedicalReportsByUuidData>>): UseMutationOptions<DeleteApiV1MedicalReportsByUuidResponse, DeleteApiV1MedicalReportsByUuidError, Options<DeleteApiV1MedicalReportsByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MedicalReportsByUuidResponse, DeleteApiV1MedicalReportsByUuidError, Options<DeleteApiV1MedicalReportsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMedicalReportsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMedicalReportsByUuidQueryKey = (options: Options<GetApiV1MedicalReportsByUuidData>) => createQueryKey('getApiV1MedicalReportsByUuid', options);

/**
 * Get Medical Report
 *
 * Get all data about a single medical report by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsByUuidOptions = (options: Options<GetApiV1MedicalReportsByUuidData>) => queryOptions<GetApiV1MedicalReportsByUuidResponse, GetApiV1MedicalReportsByUuidError, GetApiV1MedicalReportsByUuidResponse, ReturnType<typeof apiGetMedicalReportsByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicalReportsUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicalReportsByUuidQueryKey(options)
});

/**
 * Update Medical Report
 *
 * Update a medical report by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicalReportsByUuidMutation = (options?: Partial<Options<PutApiV1MedicalReportsByUuidData>>): UseMutationOptions<PutApiV1MedicalReportsByUuidResponse, PutApiV1MedicalReportsByUuidError, Options<PutApiV1MedicalReportsByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1MedicalReportsByUuidResponse, PutApiV1MedicalReportsByUuidError, Options<PutApiV1MedicalReportsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutMedicalReportsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMedicalReportsDownloadByUuidQueryKey = (options: Options<GetApiV1MedicalReportsDownloadByUuidData>) => createQueryKey('getApiV1MedicalReportsDownloadByUuid', options);

/**
 * Download Medical Report
 *
 * Get a streaming response for a medical report object.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsDownloadByUuidOptions = (options: Options<GetApiV1MedicalReportsDownloadByUuidData>) => queryOptions<GetApiV1MedicalReportsDownloadByUuidResponse, GetApiV1MedicalReportsDownloadByUuidError, GetApiV1MedicalReportsDownloadByUuidResponse, ReturnType<typeof apiGetMedicalReportsDownloadByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicalReportsDownloadUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicalReportsDownloadByUuidQueryKey(options)
});

export const apiGetMedicalReportsByUuidDownloadUrlQueryKey = (options: Options<GetApiV1MedicalReportsByUuidDownloadUrlData>) => createQueryKey('getApiV1MedicalReportsByUuidDownloadUrl', options);

/**
 * Get Medical Report Download Url
 *
 * Get a fresh pre-signed URL for downloading of a medical report object.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsByUuidDownloadUrlOptions = (options: Options<GetApiV1MedicalReportsByUuidDownloadUrlData>) => queryOptions<GetApiV1MedicalReportsByUuidDownloadUrlResponse, GetApiV1MedicalReportsByUuidDownloadUrlError, GetApiV1MedicalReportsByUuidDownloadUrlResponse, ReturnType<typeof apiGetMedicalReportsByUuidDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicalReportsUuidDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicalReportsByUuidDownloadUrlQueryKey(options)
});

export const apiGetMedicalReportsByUuidUploadUrlQueryKey = (options: Options<GetApiV1MedicalReportsByUuidUploadUrlData>) => createQueryKey('getApiV1MedicalReportsByUuidUploadUrl', options);

/**
 * Get Medical Report Upload Url
 *
 * Get a pre-signed URL for uploading a medical report. This endpoint
 * can be called repeatedly for re-uploads.
 *
 * 403 for the patient role: the URL carries no size or type conditions, so
 * a patient uploads through `POST /medical-reports` instead.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsByUuidUploadUrlOptions = (options: Options<GetApiV1MedicalReportsByUuidUploadUrlData>) => queryOptions<GetApiV1MedicalReportsByUuidUploadUrlResponse, GetApiV1MedicalReportsByUuidUploadUrlError, GetApiV1MedicalReportsByUuidUploadUrlResponse, ReturnType<typeof apiGetMedicalReportsByUuidUploadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicalReportsUuidUploadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicalReportsByUuidUploadUrlQueryKey(options)
});

/**
 * Create Multifile Medical Report
 *
 * Create a medical report from multiple files either PDFs or images.
 * Accepts either multiple PDF or image files (JPG, PNG, JPEG)
 * Performs OCR on images using Tesseract, converts to PDF and merges all.
 * In case of PDFs, merges them directly with ghostscript.
 * Files are scanned by GuardDuty before processing.
 * Processing will be handled in the separate background worker to prevent
 * memory issues in the main API. The merged PDF is stored in S3 once
 * processing completes.
 * Workflow:
 * 1. Validate patient access and input files
 * 2. Reject the batch if this patient already has the whole of it, or
 * any one file in it
 * 3. Create medical report database record
 * 4. Upload files to S3 temporary location (uploads-multi/{uuid}_0, _1, etc.)
 * 5. Add report to upload queue for GuardDuty monitoring
 * 6. Background cron job checks GuardDuty scan results
 * 7. Once all files are scanned clean, background task:
 * - Downloads files from S3
 * - either: Converts images to PDFs (Tesseract OCR)
 * - or: Merges all PDFs (Ghostscript)
 * - Uploads final PDF to permanent location (reports/{patient_id}/{uuid})
 * - Updates medical report status
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsMultifileMutation = (options?: Partial<Options<PostApiV1MedicalReportsMultifileData>>): UseMutationOptions<PostApiV1MedicalReportsMultifileResponse, PostApiV1MedicalReportsMultifileError, Options<PostApiV1MedicalReportsMultifileData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicalReportsMultifileResponse, PostApiV1MedicalReportsMultifileError, Options<PostApiV1MedicalReportsMultifileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicalReportsMultifile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMedicalReportsByUuidExtractionQueryKey = (options: Options<GetApiV1MedicalReportsByUuidExtractionData>) => createQueryKey('getApiV1MedicalReportsByUuidExtraction', options);

/**
 * Get Medical Report Extraction
 *
 * Get AI extraction results for a medical report.
 *
 * 404 while extraction has not produced anything, including after a page
 * rotation until the new run stores its result, and 404 with a different
 * reason when the report was extracted before results were stored.
 *
 * 403 for the patient role: results are held for a clinician to review.
 * The review endpoints' ownership and upload-status checks are for editing
 * and do not apply to this read.
 *
 * ``failed_pages`` are the pages OCR or the model gave no answer for in
 * this run; a retry listing them in ``pages`` reads them again. Runs stored
 * before pages were read one by one give ``[]``.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsByUuidExtractionOptions = (options: Options<GetApiV1MedicalReportsByUuidExtractionData>) => queryOptions<GetApiV1MedicalReportsByUuidExtractionResponse, GetApiV1MedicalReportsByUuidExtractionError, GetApiV1MedicalReportsByUuidExtractionResponse, ReturnType<typeof apiGetMedicalReportsByUuidExtractionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMedicalReportsUuidExtraction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMedicalReportsByUuidExtractionQueryKey(options)
});

/**
 * Save Medical Report Extraction Draft
 *
 * Save a reviewer's corrections over the stored extraction, before ingest.
 *
 * Applies the fields the request actually carries over the stored result and
 * stamps ``reviewed_at``; the extraction status is untouched, since
 * reviewing is not ingesting. Idempotent, so the frontend can autosave
 * freely — and a partial autosave never resets a field it did not send.
 *
 * The body's ``version`` must match the row's, otherwise the save is refused
 * with a 409; every save bumps it.
 *
 * The draft is written next to the model's output, never over it: the pair
 * is what makes an approved extraction usable as evaluation data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicalReportsByUuidExtractionMutation = (options?: Partial<Options<PutApiV1MedicalReportsByUuidExtractionData>>): UseMutationOptions<PutApiV1MedicalReportsByUuidExtractionResponse, PutApiV1MedicalReportsByUuidExtractionError, Options<PutApiV1MedicalReportsByUuidExtractionData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1MedicalReportsByUuidExtractionResponse, PutApiV1MedicalReportsByUuidExtractionError, Options<PutApiV1MedicalReportsByUuidExtractionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutMedicalReportsUuidExtraction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Extract Medical Report Region
 *
 * Extract candidate entities from a reviewer-selected region of the report.
 *
 * Synchronous on purpose: this backs an interactive "I selected this, what is
 * in it?" action taken while reviewing, so it must answer within the request
 * rather than through the Taskiq pipeline the document-wide extraction uses.
 *
 * Nothing is written — the reviewer approves candidates in the UI and they
 * reach the store through the draft save (``PUT .../extraction``). It still
 * requires write permission rather than read: it is part of the authoring
 * flow, and each call costs an LLM request, so only reviewers who can
 * actually ingest may spend one.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsByUuidExtractionExtractRegionMutation = (options?: Partial<Options<PostApiV1MedicalReportsByUuidExtractionExtractRegionData>>): UseMutationOptions<PostApiV1MedicalReportsByUuidExtractionExtractRegionResponse, PostApiV1MedicalReportsByUuidExtractionExtractRegionError, Options<PostApiV1MedicalReportsByUuidExtractionExtractRegionData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicalReportsByUuidExtractionExtractRegionResponse, PostApiV1MedicalReportsByUuidExtractionExtractRegionError, Options<PostApiV1MedicalReportsByUuidExtractionExtractRegionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicalReportsUuidExtractionExtractRegion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ingest Extraction Approval
 *
 * Ingest the saved draft's entities into the clinical DB.
 *
 * Writes them on the same contract as the sibling create endpoints — same
 * POST schemas, limiter, date-of-birth checks and background work — and
 * marks the report ``ingested``. Entities the caller may not write, or that
 * fail that validation, are counted into ``skipped`` rather than failing the
 * reviewer's whole batch; entities the reviewer flagged ``excluded`` are
 * left out of it entirely. A batch whose kept entities were all skipped is
 * refused with a 422, and the report stays reviewable.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsByUuidExtractionIngestMutation = (options?: Partial<Options<PostApiV1MedicalReportsByUuidExtractionIngestData>>): UseMutationOptions<PostApiV1MedicalReportsByUuidExtractionIngestResponse, PostApiV1MedicalReportsByUuidExtractionIngestError, Options<PostApiV1MedicalReportsByUuidExtractionIngestData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicalReportsByUuidExtractionIngestResponse, PostApiV1MedicalReportsByUuidExtractionIngestError, Options<PostApiV1MedicalReportsByUuidExtractionIngestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicalReportsUuidExtractionIngest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Extraction
 *
 * Reject the extraction instead of ingesting it.
 *
 * Nothing is written to the clinical tables, but the current view is
 * snapshotted the way approval snapshots it: "the model produced this and
 * it was unusable" is a label the evaluation dataset cannot get anywhere
 * else.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsByUuidExtractionRejectMutation = (options?: Partial<Options<PostApiV1MedicalReportsByUuidExtractionRejectData>>): UseMutationOptions<PostApiV1MedicalReportsByUuidExtractionRejectResponse, PostApiV1MedicalReportsByUuidExtractionRejectError, Options<PostApiV1MedicalReportsByUuidExtractionRejectData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicalReportsByUuidExtractionRejectResponse, PostApiV1MedicalReportsByUuidExtractionRejectError, Options<PostApiV1MedicalReportsByUuidExtractionRejectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicalReportsUuidExtractionReject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry Extraction
 *
 * Re-trigger AI extraction for a report whose extraction failed, stalled, or
 * should simply be run again. Allowed on any report with
 * upload_status=success that is not ingested and has no run queued or in
 * progress.
 *
 * Page rotations in the body are stored in the PDF before the run is
 * queued, so a 202 means they are saved. A turned scan page whose only
 * text is its OCR layer loses that layer and is read by OCR from then on.
 * Rotations retire the current extraction: GET 404s until the new run
 * stores one.
 *
 * With rotations or pages in the body the run is page-scoped (see
 * ``ExtractionRetryRequest``); without either it reads every page. Pages
 * alone leave the stored PDF and the current extraction as they are. A
 * run that cannot be queued leaves the report ``failed``, as the response
 * says.
 *
 * A retry stores a new, unreviewed run built from the model's answers
 * alone. Corrections saved on the current extraction are not carried
 * over, not even on the pages a page-scoped run keeps.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsByUuidExtractionRetryMutation = (options?: Partial<Options<PostApiV1MedicalReportsByUuidExtractionRetryData>>): UseMutationOptions<PostApiV1MedicalReportsByUuidExtractionRetryResponse, PostApiV1MedicalReportsByUuidExtractionRetryError, Options<PostApiV1MedicalReportsByUuidExtractionRetryData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MedicalReportsByUuidExtractionRetryResponse, PostApiV1MedicalReportsByUuidExtractionRetryError, Options<PostApiV1MedicalReportsByUuidExtractionRetryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMedicalReportsUuidExtractionRetry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetDerivedQueryKey = (options?: Options<GetApiV1DerivedData>) => createQueryKey('getApiV1Derived', options);

/**
 * Get Ppg Derived Data
 *
 * List all PPG-derived data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDerivedOptions = (options?: Options<GetApiV1DerivedData>) => queryOptions<GetApiV1DerivedResponse, GetApiV1DerivedError, GetApiV1DerivedResponse, ReturnType<typeof apiGetDerivedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetDerived({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetDerivedQueryKey(options)
});

export const apiGetDerivedInfiniteQueryKey = (options?: Options<GetApiV1DerivedData>): QueryKey<Options<GetApiV1DerivedData>> => createQueryKey('getApiV1Derived', options, true);

/**
 * Get Ppg Derived Data
 *
 * List all PPG-derived data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDerivedInfiniteOptions = (options?: Options<GetApiV1DerivedData>) => infiniteQueryOptions<GetApiV1DerivedResponse, GetApiV1DerivedError, InfiniteData<GetApiV1DerivedResponse>, QueryKey<Options<GetApiV1DerivedData>>, number | Pick<QueryKey<Options<GetApiV1DerivedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1DerivedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetDerived({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetDerivedInfiniteQueryKey(options)
});

export const apiGetDerivedByUuidQueryKey = (options: Options<GetApiV1DerivedByUuidData>) => createQueryKey('getApiV1DerivedByUuid', options);

/**
 * Get Ppg Derived Data By Uuid
 *
 * Get single PPG-derived data by its UUID. This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDerivedByUuidOptions = (options: Options<GetApiV1DerivedByUuidData>) => queryOptions<GetApiV1DerivedByUuidResponse, GetApiV1DerivedByUuidError, GetApiV1DerivedByUuidResponse, ReturnType<typeof apiGetDerivedByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetDerivedUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetDerivedByUuidQueryKey(options)
});

/**
 * Update Ppg Derived Data
 *
 * Update single PPG-derived data given its UUID. **Monitoring** users can
 * update PPG-derived data that they did not create, but update rules are
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutDerivedByUuidMutation = (options?: Partial<Options<PutApiV1DerivedByUuidData>>): UseMutationOptions<PutApiV1DerivedByUuidResponse, PutApiV1DerivedByUuidError, Options<PutApiV1DerivedByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1DerivedByUuidResponse, PutApiV1DerivedByUuidError, Options<PutApiV1DerivedByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutDerivedUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Ppg Derived By Ppg Uuid
 *
 * Delete PPG-derived data by the original connected PPG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteDerivedPpgByPpgUuidMutation = (options?: Partial<Options<DeleteApiV1DerivedPpgByPpgUuidData>>): UseMutationOptions<DeleteApiV1DerivedPpgByPpgUuidResponse, DeleteApiV1DerivedPpgByPpgUuidError, Options<DeleteApiV1DerivedPpgByPpgUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1DerivedPpgByPpgUuidResponse, DeleteApiV1DerivedPpgByPpgUuidError, Options<DeleteApiV1DerivedPpgByPpgUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteDerivedPpgPpgUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetDerivedPpgByPpgUuidQueryKey = (options: Options<GetApiV1DerivedPpgByPpgUuidData>) => createQueryKey('getApiV1DerivedPpgByPpgUuid', options);

/**
 * Get Ppg Derived Data By Ppg Uuid
 *
 * Get all PPG-derived data by the original PPG UUID. This endpoint
 * is subject to filtering by data visibility dimension and to the
 * row-level access limiters of the `ppg_derived` table.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDerivedPpgByPpgUuidOptions = (options: Options<GetApiV1DerivedPpgByPpgUuidData>) => queryOptions<GetApiV1DerivedPpgByPpgUuidResponse, GetApiV1DerivedPpgByPpgUuidError, GetApiV1DerivedPpgByPpgUuidResponse, ReturnType<typeof apiGetDerivedPpgByPpgUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetDerivedPpgPpgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetDerivedPpgByPpgUuidQueryKey(options)
});

/**
 * Update Ppg Derived By Ppg Uuid
 *
 * Update PPG-derived data by the original connected PPG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutDerivedPpgByPpgUuidMutation = (options?: Partial<Options<PutApiV1DerivedPpgByPpgUuidData>>): UseMutationOptions<PutApiV1DerivedPpgByPpgUuidResponse, PutApiV1DerivedPpgByPpgUuidError, Options<PutApiV1DerivedPpgByPpgUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1DerivedPpgByPpgUuidResponse, PutApiV1DerivedPpgByPpgUuidError, Options<PutApiV1DerivedPpgByPpgUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutDerivedPpgPpgUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Berry Oxi Ppg Derived Data
 *
 * Create new PPG-derived data. This endpoint is subject to filtering
 * by data visibility dimension.
 */
export const apiPostDerivedBerryMutation = (options?: Partial<Options<PostApiV1DerivedBerryData>>): UseMutationOptions<PostApiV1DerivedBerryResponse, PostApiV1DerivedBerryError, Options<PostApiV1DerivedBerryData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1DerivedBerryResponse, PostApiV1DerivedBerryError, Options<PostApiV1DerivedBerryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostDerivedBerry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Viatom Ppg Derived Data
 *
 * Create new PPG-derived data from a Viatom O2Ring-family device. This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Note that no HRV is produced: the device exposes no per-pulse interval
 * stream, so only SpO2 and pulse rate are aggregated here.
 */
export const apiPostDerivedViatomMutation = (options?: Partial<Options<PostApiV1DerivedViatomData>>): UseMutationOptions<PostApiV1DerivedViatomResponse, PostApiV1DerivedViatomError, Options<PostApiV1DerivedViatomData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1DerivedViatomResponse, PostApiV1DerivedViatomError, Options<PostApiV1DerivedViatomData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostDerivedViatom({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetEcgDerivedScpCodesQueryKey = (options?: Options<GetApiV1EcgDerivedScpCodesData>) => createQueryKey('getApiV1EcgDerivedScpCodes', options);

/**
 * List Ecg Annotations
 *
 * List supported ECG annotations / SCP codes.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerivedScpCodesOptions = (options?: Options<GetApiV1EcgDerivedScpCodesData>) => queryOptions<GetApiV1EcgDerivedScpCodesResponse, GetApiV1EcgDerivedScpCodesError, GetApiV1EcgDerivedScpCodesResponse, ReturnType<typeof apiGetEcgDerivedScpCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetEcgDerivedScpCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEcgDerivedScpCodesQueryKey(options)
});

export const apiGetEcgDerivedQueryKey = (options?: Options<GetApiV1EcgDerivedData>) => createQueryKey('getApiV1EcgDerived', options);

/**
 * Get Ecg Derived Data
 *
 * List all ECG-derived data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerivedOptions = (options?: Options<GetApiV1EcgDerivedData>) => queryOptions<GetApiV1EcgDerivedResponse, GetApiV1EcgDerivedError, GetApiV1EcgDerivedResponse, ReturnType<typeof apiGetEcgDerivedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetEcgDerived({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEcgDerivedQueryKey(options)
});

export const apiGetEcgDerivedInfiniteQueryKey = (options?: Options<GetApiV1EcgDerivedData>): QueryKey<Options<GetApiV1EcgDerivedData>> => createQueryKey('getApiV1EcgDerived', options, true);

/**
 * Get Ecg Derived Data
 *
 * List all ECG-derived data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerivedInfiniteOptions = (options?: Options<GetApiV1EcgDerivedData>) => infiniteQueryOptions<GetApiV1EcgDerivedResponse, GetApiV1EcgDerivedError, InfiniteData<GetApiV1EcgDerivedResponse>, QueryKey<Options<GetApiV1EcgDerivedData>>, number | Pick<QueryKey<Options<GetApiV1EcgDerivedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1EcgDerivedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetEcgDerived({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEcgDerivedInfiniteQueryKey(options)
});

export const apiGetEcgDerivedByUuidQueryKey = (options: Options<GetApiV1EcgDerivedByUuidData>) => createQueryKey('getApiV1EcgDerivedByUuid', options);

/**
 * Get Ecg Derived Data By Uuid
 *
 * Get single ECG-derived data by its UUID. This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerivedByUuidOptions = (options: Options<GetApiV1EcgDerivedByUuidData>) => queryOptions<GetApiV1EcgDerivedByUuidResponse, GetApiV1EcgDerivedByUuidError, GetApiV1EcgDerivedByUuidResponse, ReturnType<typeof apiGetEcgDerivedByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetEcgDerivedUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEcgDerivedByUuidQueryKey(options)
});

/**
 * Update Ecg Derived Data
 *
 * Update single ECG-derived data given its UUID. **Monitoring** users can
 * update ECG-derived data that they did not create, but update rules are
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutEcgDerivedByUuidMutation = (options?: Partial<Options<PutApiV1EcgDerivedByUuidData>>): UseMutationOptions<PutApiV1EcgDerivedByUuidResponse, PutApiV1EcgDerivedByUuidError, Options<PutApiV1EcgDerivedByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1EcgDerivedByUuidResponse, PutApiV1EcgDerivedByUuidError, Options<PutApiV1EcgDerivedByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutEcgDerivedUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Ecg Derived By Ecg Uuid
 *
 * Delete ECG-derived data by the original connected ECG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteEcgDerivedEcgByEcgUuidMutation = (options?: Partial<Options<DeleteApiV1EcgDerivedEcgByEcgUuidData>>): UseMutationOptions<DeleteApiV1EcgDerivedEcgByEcgUuidResponse, DeleteApiV1EcgDerivedEcgByEcgUuidError, Options<DeleteApiV1EcgDerivedEcgByEcgUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1EcgDerivedEcgByEcgUuidResponse, DeleteApiV1EcgDerivedEcgByEcgUuidError, Options<DeleteApiV1EcgDerivedEcgByEcgUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteEcgDerivedEcgEcgUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetEcgDerivedEcgByEcgUuidQueryKey = (options: Options<GetApiV1EcgDerivedEcgByEcgUuidData>) => createQueryKey('getApiV1EcgDerivedEcgByEcgUuid', options);

/**
 * Get Ecg Derived Data By Ecg Uuid
 *
 * Get all ECG-derived data by the original ECG UUID. This endpoint
 * is subject to filtering by data visibility dimension and to the
 * row-level access limiters of the `ecg_derived` table.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerivedEcgByEcgUuidOptions = (options: Options<GetApiV1EcgDerivedEcgByEcgUuidData>) => queryOptions<GetApiV1EcgDerivedEcgByEcgUuidResponse, GetApiV1EcgDerivedEcgByEcgUuidError, GetApiV1EcgDerivedEcgByEcgUuidResponse, ReturnType<typeof apiGetEcgDerivedEcgByEcgUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetEcgDerivedEcgEcgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEcgDerivedEcgByEcgUuidQueryKey(options)
});

/**
 * Update Ecg Derived By Ecg Uuid
 *
 * Update ECG-derived data by the original connected ECG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutEcgDerivedEcgByEcgUuidMutation = (options?: Partial<Options<PutApiV1EcgDerivedEcgByEcgUuidData>>): UseMutationOptions<PutApiV1EcgDerivedEcgByEcgUuidResponse, PutApiV1EcgDerivedEcgByEcgUuidError, Options<PutApiV1EcgDerivedEcgByEcgUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1EcgDerivedEcgByEcgUuidResponse, PutApiV1EcgDerivedEcgByEcgUuidError, Options<PutApiV1EcgDerivedEcgByEcgUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutEcgDerivedEcgEcgUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Alivecor Ecg Derived Data
 *
 * Create new ECG-derived data from AliveCor ECG device. This endpoint is
 * subject to filtering by data visibility dimension.
 */
export const apiPostEcgDerivedAlivecorMutation = (options?: Partial<Options<PostApiV1EcgDerivedAlivecorData>>): UseMutationOptions<PostApiV1EcgDerivedAlivecorResponse, PostApiV1EcgDerivedAlivecorError, Options<PostApiV1EcgDerivedAlivecorData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1EcgDerivedAlivecorResponse, PostApiV1EcgDerivedAlivecorError, Options<PostApiV1EcgDerivedAlivecorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostEcgDerivedAlivecor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetComputedQueryKey = (options?: Options<GetApiV1ComputedData>) => createQueryKey('getApiV1Computed', options);

/**
 * Get Computed Data
 *
 * List all Seerlinq-computed data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputedOptions = (options?: Options<GetApiV1ComputedData>) => queryOptions<GetApiV1ComputedResponse, GetApiV1ComputedError, GetApiV1ComputedResponse, ReturnType<typeof apiGetComputedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetComputed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetComputedQueryKey(options)
});

export const apiGetComputedInfiniteQueryKey = (options?: Options<GetApiV1ComputedData>): QueryKey<Options<GetApiV1ComputedData>> => createQueryKey('getApiV1Computed', options, true);

/**
 * Get Computed Data
 *
 * List all Seerlinq-computed data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputedInfiniteOptions = (options?: Options<GetApiV1ComputedData>) => infiniteQueryOptions<GetApiV1ComputedResponse, GetApiV1ComputedError, InfiniteData<GetApiV1ComputedResponse>, QueryKey<Options<GetApiV1ComputedData>>, number | Pick<QueryKey<Options<GetApiV1ComputedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1ComputedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetComputed({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetComputedInfiniteQueryKey(options)
});

/**
 * Create Computed Data
 *
 * Create new Seerlinq-computed data. This endpoint is available only for
 * Seerlinq algorithms (**monitoring access** + username filtering) and
 * **admin** users.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostComputedMutation = (options?: Partial<Options<PostApiV1ComputedData>>): UseMutationOptions<PostApiV1ComputedResponse, PostApiV1ComputedError, Options<PostApiV1ComputedData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ComputedResponse, PostApiV1ComputedError, Options<PostApiV1ComputedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostComputed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetComputedPpgByPpgUuidLvfpIndicationQueryKey = (options: Options<GetApiV1ComputedPpgByPpgUuidLvfpIndicationData>) => createQueryKey('getApiV1ComputedPpgByPpgUuidLvfpIndication', options);

/**
 * Get Lvfp Indication
 *
 * Whether the LVFP computed for the condition-matched pair this recording
 * belongs to reaches the screening threshold - a boolean, never the
 * value. Either recording of the pair answers. Poll while `status` is
 * `unpaired` or `pending`; `ready`, `bad_quality`, `too_short` and `failed`
 * are terminal.
 *
 * Also needs `ACCESS_LVFP`, or `ALLOW_PAYMENT` for a screening patient.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputedPpgByPpgUuidLvfpIndicationOptions = (options: Options<GetApiV1ComputedPpgByPpgUuidLvfpIndicationData>) => queryOptions<GetApiV1ComputedPpgByPpgUuidLvfpIndicationResponse, GetApiV1ComputedPpgByPpgUuidLvfpIndicationError, GetApiV1ComputedPpgByPpgUuidLvfpIndicationResponse, ReturnType<typeof apiGetComputedPpgByPpgUuidLvfpIndicationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetComputedPpgPpgUuidLvfpIndication({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetComputedPpgByPpgUuidLvfpIndicationQueryKey(options)
});

export const apiGetComputedPpgByPpgUuidQueryKey = (options: Options<GetApiV1ComputedPpgByPpgUuidData>) => createQueryKey('getApiV1ComputedPpgByPpgUuid', options);

/**
 * Get Computed Data By Ppg Uuid
 *
 * List all Seerlinq-computed by the PPG UUID they are connected to. This
 * endpoint is subject to filtering by data visibility dimension and to the
 * row-level access limiters of the `sq_computed` table (DRI/LVFP/AFib).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputedPpgByPpgUuidOptions = (options: Options<GetApiV1ComputedPpgByPpgUuidData>) => queryOptions<GetApiV1ComputedPpgByPpgUuidResponse, GetApiV1ComputedPpgByPpgUuidError, GetApiV1ComputedPpgByPpgUuidResponse, ReturnType<typeof apiGetComputedPpgByPpgUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetComputedPpgPpgUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetComputedPpgByPpgUuidQueryKey(options)
});

export const apiGetComputedLastQueryKey = (options: Options<GetApiV1ComputedLastData>) => createQueryKey('getApiV1ComputedLast', options);

/**
 * Get Last Computed Data Per Patient
 *
 * List the last _N_ Seerlinq-computed data for a given patient ID and given
 * _N_, ordered by measurement datetime. This endpoint is subject to filtering
 * by data visibility dimension, last _N_ data points are taken after the
 * filtering.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputedLastOptions = (options: Options<GetApiV1ComputedLastData>) => queryOptions<GetApiV1ComputedLastResponse, GetApiV1ComputedLastError, GetApiV1ComputedLastResponse, ReturnType<typeof apiGetComputedLastQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetComputedLast({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetComputedLastQueryKey(options)
});

/**
 * Delete Computed Data
 *
 * Delete Seerlinq-computed data by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteComputedByUuidMutation = (options?: Partial<Options<DeleteApiV1ComputedByUuidData>>): UseMutationOptions<DeleteApiV1ComputedByUuidResponse, DeleteApiV1ComputedByUuidError, Options<DeleteApiV1ComputedByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ComputedByUuidResponse, DeleteApiV1ComputedByUuidError, Options<DeleteApiV1ComputedByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteComputedUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Computed Data
 *
 * Update/edit Seerlinq-computed data given its UUID. Fields that can be
 * updated differ by the user access (see schemas). **Medical** and
 * **monitoring** users can update Seerlinq-computed data that they did not
 * create, but update rules are subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutComputedByUuidMutation = (options?: Partial<Options<PutApiV1ComputedByUuidData>>): UseMutationOptions<PutApiV1ComputedByUuidResponse, PutApiV1ComputedByUuidError, Options<PutApiV1ComputedByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ComputedByUuidResponse, PutApiV1ComputedByUuidError, Options<PutApiV1ComputedByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutComputedUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetClinicalStudiesQueryKey = (options?: Options<GetApiV1ClinicalStudiesData>) => createQueryKey('getApiV1ClinicalStudies', options);

/**
 * Get Study Enrollments
 *
 * List of clinical study enrollments in the DB. It is possible to filter by
 * patient IDs and study acronyms. This endpoint is subject to filtering by
 * data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesOptions = (options?: Options<GetApiV1ClinicalStudiesData>) => queryOptions<GetApiV1ClinicalStudiesResponse, GetApiV1ClinicalStudiesError, GetApiV1ClinicalStudiesResponse, ReturnType<typeof apiGetClinicalStudiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinicalStudies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicalStudiesQueryKey(options)
});

export const apiGetClinicalStudiesByStudyAcronymDefinitionQueryKey = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymDefinitionData>) => createQueryKey('getApiV1ClinicalStudiesByStudyAcronymDefinition', options);

/**
 * Get Study Definition
 *
 * Get clinical study definition (protocol).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesByStudyAcronymDefinitionOptions = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymDefinitionData>) => queryOptions<GetApiV1ClinicalStudiesByStudyAcronymDefinitionResponse, GetApiV1ClinicalStudiesByStudyAcronymDefinitionError, GetApiV1ClinicalStudiesByStudyAcronymDefinitionResponse, ReturnType<typeof apiGetClinicalStudiesByStudyAcronymDefinitionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinicalStudiesStudyAcronymDefinition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicalStudiesByStudyAcronymDefinitionQueryKey(options)
});

export const apiGetClinicalStudiesByStudyAcronymVisitsQueryKey = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymVisitsData>) => createQueryKey('getApiV1ClinicalStudiesByStudyAcronymVisits', options);

/**
 * Get Study Visits
 *
 * List all study visits under a clinical study. It is possible to filter by
 * patient IDs. This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesByStudyAcronymVisitsOptions = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymVisitsData>) => queryOptions<GetApiV1ClinicalStudiesByStudyAcronymVisitsResponse, GetApiV1ClinicalStudiesByStudyAcronymVisitsError, GetApiV1ClinicalStudiesByStudyAcronymVisitsResponse, ReturnType<typeof apiGetClinicalStudiesByStudyAcronymVisitsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinicalStudiesStudyAcronymVisits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicalStudiesByStudyAcronymVisitsQueryKey(options)
});

export const apiGetClinicalStudiesByStudyAcronymEnrollPreFillQueryKey = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillData>) => createQueryKey('getApiV1ClinicalStudiesByStudyAcronymEnrollPreFill', options);

/**
 * Prefill Enrollment
 *
 * Get prefill data for patient enrollment, mainly generated schedule.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesByStudyAcronymEnrollPreFillOptions = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillData>) => queryOptions<GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillResponse, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillError, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillResponse, ReturnType<typeof apiGetClinicalStudiesByStudyAcronymEnrollPreFillQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinicalStudiesStudyAcronymEnrollPreFill({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicalStudiesByStudyAcronymEnrollPreFillQueryKey(options)
});

export const apiGetClinicalStudiesByVisitUuidDataPreFillQueryKey = (options: Options<GetApiV1ClinicalStudiesByVisitUuidDataPreFillData>) => createQueryKey('getApiV1ClinicalStudiesByVisitUuidDataPreFill', options);

/**
 * Prefill Study Visit With Data
 *
 * Get study visit prefill data. Given the study visit UUID, this will return
 * the visit data as per definition and for each data type the data that has
 * been already associated and possible existing data in the DB. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesByVisitUuidDataPreFillOptions = (options: Options<GetApiV1ClinicalStudiesByVisitUuidDataPreFillData>) => queryOptions<GetApiV1ClinicalStudiesByVisitUuidDataPreFillResponse, GetApiV1ClinicalStudiesByVisitUuidDataPreFillError, GetApiV1ClinicalStudiesByVisitUuidDataPreFillResponse, ReturnType<typeof apiGetClinicalStudiesByVisitUuidDataPreFillQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinicalStudiesVisitUuidDataPreFill({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicalStudiesByVisitUuidDataPreFillQueryKey(options)
});

/**
 * Enroll Patient To Study
 *
 * Enroll patient to a clinical study. The study enrollment for a specific
 * study (`study_acronym`) must be unique per patient. This endpoint is subject
 * to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesEnrollMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesEnrollData>>): UseMutationOptions<PostApiV1ClinicalStudiesEnrollResponse, PostApiV1ClinicalStudiesEnrollError, Options<PostApiV1ClinicalStudiesEnrollData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesEnrollResponse, PostApiV1ClinicalStudiesEnrollError, Options<PostApiV1ClinicalStudiesEnrollData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesEnroll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Study Visit
 *
 * Create study visit for a patient in a particular clinical study. The study
 * visit for a specific study (`study_acronym`), protocol version
 * (`protocol_version`), and visit type (`visit_type`) must be unique per
 * patient. New study visit cannot be added when the parent patient's
 * enrollment is marked as **inactive**. This endpoint is subject to filtering
 * by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesStudyVisitMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesStudyVisitData>>): UseMutationOptions<PostApiV1ClinicalStudiesStudyVisitResponse, PostApiV1ClinicalStudiesStudyVisitError, Options<PostApiV1ClinicalStudiesStudyVisitData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesStudyVisitResponse, PostApiV1ClinicalStudiesStudyVisitError, Options<PostApiV1ClinicalStudiesStudyVisitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesStudyVisit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Admin Procedures
 *
 * Create admin procedures for a study visit in bulk. This is possible for a
 * single patient ID and single clinical study visit UUID. New administrative
 * procedure(s) cannot be added when the parent patient's enrollment is marked
 * as **inactive**.This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAdminProcedureMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAdminProcedureData>>): UseMutationOptions<PostApiV1ClinicalStudiesAdminProcedureResponse, PostApiV1ClinicalStudiesAdminProcedureError, Options<PostApiV1ClinicalStudiesAdminProcedureData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAdminProcedureResponse, PostApiV1ClinicalStudiesAdminProcedureError, Options<PostApiV1ClinicalStudiesAdminProcedureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAdminProcedure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Patient Enrollment
 *
 * Delete patient enrollment to the clinical study by its UUID. This will also
 * delete all study visits under this study enrollment (cascade) and admin
 * procedures under the study visits.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesEnrollmentByUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesEnrollmentByUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesEnrollmentByUuidResponse, DeleteApiV1ClinicalStudiesEnrollmentByUuidError, Options<DeleteApiV1ClinicalStudiesEnrollmentByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesEnrollmentByUuidResponse, DeleteApiV1ClinicalStudiesEnrollmentByUuidError, Options<DeleteApiV1ClinicalStudiesEnrollmentByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesEnrollmentUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Patient Enrollment
 *
 * Update/edit patient's study enrollment given its UUID. The **admin** role
 * can update all study enrollments, while lower access levels can update only
 * study enrollments they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesEnrollmentByUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesEnrollmentByUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesEnrollmentByUuidResponse, PutApiV1ClinicalStudiesEnrollmentByUuidError, Options<PutApiV1ClinicalStudiesEnrollmentByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesEnrollmentByUuidResponse, PutApiV1ClinicalStudiesEnrollmentByUuidError, Options<PutApiV1ClinicalStudiesEnrollmentByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesEnrollmentUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Study Visit
 *
 * Delete patient's clinical study visit by its UUID. This will also delete all
 * admin procedures under this study visit.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesStudyVisitByUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesStudyVisitByUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesStudyVisitByUuidResponse, DeleteApiV1ClinicalStudiesStudyVisitByUuidError, Options<DeleteApiV1ClinicalStudiesStudyVisitByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesStudyVisitByUuidResponse, DeleteApiV1ClinicalStudiesStudyVisitByUuidError, Options<DeleteApiV1ClinicalStudiesStudyVisitByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesStudyVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Study Visit
 *
 * Update/edit patient's study visit given its UUID. The **admin** role can
 * update all study visits, while lower access levels can update only study
 * visits they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesStudyVisitByUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesStudyVisitByUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesStudyVisitByUuidResponse, PutApiV1ClinicalStudiesStudyVisitByUuidError, Options<PutApiV1ClinicalStudiesStudyVisitByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesStudyVisitByUuidResponse, PutApiV1ClinicalStudiesStudyVisitByUuidError, Options<PutApiV1ClinicalStudiesStudyVisitByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesStudyVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Admin Procedure
 *
 * Delete clinical study visit admin procedure by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAdminProcedureByUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAdminProcedureByUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAdminProcedureByUuidResponse, DeleteApiV1ClinicalStudiesAdminProcedureByUuidError, Options<DeleteApiV1ClinicalStudiesAdminProcedureByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAdminProcedureByUuidResponse, DeleteApiV1ClinicalStudiesAdminProcedureByUuidError, Options<DeleteApiV1ClinicalStudiesAdminProcedureByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAdminProcedureUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Admin Procedure
 *
 * Update/edit patient's administrative procedure given its UUID. The **admin**
 * role can update all administrative procedures, while lower access levels can
 * update only administrative procedures they created.
 *
 * When procedure is marked done, automatically executes configured side
 * effects if not yet completed. Idempotent and safe to retry - will
 * auto-recover on next update if side effects fail.
 *
 * The side effect behavior is configuration-driven, allowing different
 * studies to define which procedures trigger which effects via JSON.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAdminProcedureByUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAdminProcedureByUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAdminProcedureByUuidResponse, PutApiV1ClinicalStudiesAdminProcedureByUuidError, Options<PutApiV1ClinicalStudiesAdminProcedureByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAdminProcedureByUuidResponse, PutApiV1ClinicalStudiesAdminProcedureByUuidError, Options<PutApiV1ClinicalStudiesAdminProcedureByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAdminProcedureUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetClinicalStudiesByStudyAcronymOverviewOverallQueryKey = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallData>) => createQueryKey('getApiV1ClinicalStudiesByStudyAcronymOverviewOverall', options);

/**
 * Get Study Overview
 *
 * Get clinical study overview - all enrolled patients and status of their
 * visits. This returns a table with patient IDs as rows and individual status
 * of a study visit as columns. The detailed overview gives individual also
 * individual data as per visit definition with their respective statuses,
 * while simple (`detailed = False`) overview gives one status per visit.
 * Possible statuses of an individual visit are:
 * - `not-scheduled`: visit does not exists in the DB, so it's not scheduled
 * - `scheduled`: visit exists in the DB, but has no associated data
 * - `started`: visit exists in the DB, but not all required data were
 * associated
 * - `done-required`: visit has all required data points associated
 * - `done-incl-optional`: visit has all required and optional data points
 * associated
 * - `done-multiple`: visit has multiple associated data points for the single
 * required data as per visit definition
 *
 * Possible statuses of individual data are:
 * - `incomplete` - datapoint is not associated
 * - `incomplete-optional` - datapoint is not associated and is optional
 * - `done` - datapoint is associated
 * - `done-multiple` - more than one datapoint is associated
 *
 * This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesByStudyAcronymOverviewOverallOptions = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallData>) => queryOptions<GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallResponse, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallError, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallResponse, ReturnType<typeof apiGetClinicalStudiesByStudyAcronymOverviewOverallQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinicalStudiesStudyAcronymOverviewOverall({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicalStudiesByStudyAcronymOverviewOverallQueryKey(options)
});

export const apiGetClinicalStudiesByStudyAcronymOverviewPatientByPatientIdQueryKey = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdData>) => createQueryKey('getApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientId', options);

/**
 * Get Study Patient Overview
 *
 * Get clinical study overview per patient. This returns a table with
 * individual planned datapoints per visit as rows and visits as columns.
 * Possible statuses of individual data are:
 * - `incomplete` - datapoint is not associated
 * - `incomplete-optional` - datapoint is not associated and is optional
 * - `done` - datapoint is associated
 * - `done-multiple` - more than one datapoint is associated
 * - `None` - data point is not planned for a given visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesByStudyAcronymOverviewPatientByPatientIdOptions = (options: Options<GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdData>) => queryOptions<GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdResponse, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdError, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdResponse, ReturnType<typeof apiGetClinicalStudiesByStudyAcronymOverviewPatientByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinicalStudiesStudyAcronymOverviewPatientPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicalStudiesByStudyAcronymOverviewPatientByPatientIdQueryKey(options)
});

export const apiGetClinicalStudiesCalendarQueryKey = (options?: Options<GetApiV1ClinicalStudiesCalendarData>) => createQueryKey('getApiV1ClinicalStudiesCalendar', options);

/**
 * Get Calendar
 *
 * Get calendar of clinical study visits. Possible to filter by clinical
 * studies, patient IDs, and limit from and to datetimes. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesCalendarOptions = (options?: Options<GetApiV1ClinicalStudiesCalendarData>) => queryOptions<GetApiV1ClinicalStudiesCalendarResponse, GetApiV1ClinicalStudiesCalendarError, GetApiV1ClinicalStudiesCalendarResponse, ReturnType<typeof apiGetClinicalStudiesCalendarQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetClinicalStudiesCalendar({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetClinicalStudiesCalendarQueryKey(options)
});

/**
 * Associate Diagnoses To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationDiagnosesMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationDiagnosesData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationDiagnosesResponse, PostApiV1ClinicalStudiesAssociationDiagnosesError, Options<PostApiV1ClinicalStudiesAssociationDiagnosesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationDiagnosesResponse, PostApiV1ClinicalStudiesAssociationDiagnosesError, Options<PostApiV1ClinicalStudiesAssociationDiagnosesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationDiagnoses({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Diagnosis From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationDiagnosesDiagnosisUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Diagnosis Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationDiagnosesDiagnosisUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Medical Data To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationMedicalDataMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationMedicalDataData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationMedicalDataResponse, PostApiV1ClinicalStudiesAssociationMedicalDataError, Options<PostApiV1ClinicalStudiesAssociationMedicalDataData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationMedicalDataResponse, PostApiV1ClinicalStudiesAssociationMedicalDataError, Options<PostApiV1ClinicalStudiesAssociationMedicalDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationMedicalData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Medical Data From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationMedicalDataMedicalDataUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Medical Data Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationMedicalDataMedicalDataUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Medical Reports To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationMedicalReportsMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationMedicalReportsData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationMedicalReportsResponse, PostApiV1ClinicalStudiesAssociationMedicalReportsError, Options<PostApiV1ClinicalStudiesAssociationMedicalReportsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationMedicalReportsResponse, PostApiV1ClinicalStudiesAssociationMedicalReportsError, Options<PostApiV1ClinicalStudiesAssociationMedicalReportsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationMedicalReports({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Medical Report From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationMedicalReportsMedicalReportUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Medical Report Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationMedicalReportsMedicalReportUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Medications To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationMedicationsMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationMedicationsData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationMedicationsResponse, PostApiV1ClinicalStudiesAssociationMedicationsError, Options<PostApiV1ClinicalStudiesAssociationMedicationsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationMedicationsResponse, PostApiV1ClinicalStudiesAssociationMedicationsError, Options<PostApiV1ClinicalStudiesAssociationMedicationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationMedications({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Medication From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationMedicationsMedicationUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Medication Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationMedicationsMedicationUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Symptoms To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationSymptomsMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationSymptomsData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationSymptomsResponse, PostApiV1ClinicalStudiesAssociationSymptomsError, Options<PostApiV1ClinicalStudiesAssociationSymptomsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationSymptomsResponse, PostApiV1ClinicalStudiesAssociationSymptomsError, Options<PostApiV1ClinicalStudiesAssociationSymptomsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationSymptoms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Symptom From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationSymptomsSymptomUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Symptom Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationSymptomsSymptomUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Questionnaires To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationQuestionnairesMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationQuestionnairesData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationQuestionnairesResponse, PostApiV1ClinicalStudiesAssociationQuestionnairesError, Options<PostApiV1ClinicalStudiesAssociationQuestionnairesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationQuestionnairesResponse, PostApiV1ClinicalStudiesAssociationQuestionnairesError, Options<PostApiV1ClinicalStudiesAssociationQuestionnairesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationQuestionnaires({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Questionnaire From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationQuestionnairesQuestionnaireUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Questionnaire Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationQuestionnairesQuestionnaireUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Events To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationEventsMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationEventsData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationEventsResponse, PostApiV1ClinicalStudiesAssociationEventsError, Options<PostApiV1ClinicalStudiesAssociationEventsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationEventsResponse, PostApiV1ClinicalStudiesAssociationEventsError, Options<PostApiV1ClinicalStudiesAssociationEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Event From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationEventsByEventUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationEventsEventUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Event Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationEventsByEventUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationEventsEventUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Ppgs To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationPpgsMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationPpgsData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationPpgsResponse, PostApiV1ClinicalStudiesAssociationPpgsError, Options<PostApiV1ClinicalStudiesAssociationPpgsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationPpgsResponse, PostApiV1ClinicalStudiesAssociationPpgsError, Options<PostApiV1ClinicalStudiesAssociationPpgsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationPpgs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Ppg From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationPpgsPpgUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Ppg Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationPpgsPpgUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Computed Data To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationComputedMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationComputedData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationComputedResponse, PostApiV1ClinicalStudiesAssociationComputedError, Options<PostApiV1ClinicalStudiesAssociationComputedData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationComputedResponse, PostApiV1ClinicalStudiesAssociationComputedError, Options<PostApiV1ClinicalStudiesAssociationComputedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationComputed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Computed From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationComputedByComputedUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationComputedComputedUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Computed Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationComputedByComputedUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationComputedComputedUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Associate Derived Data To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationDerivedMutation = (options?: Partial<Options<PostApiV1ClinicalStudiesAssociationDerivedData>>): UseMutationOptions<PostApiV1ClinicalStudiesAssociationDerivedResponse, PostApiV1ClinicalStudiesAssociationDerivedError, Options<PostApiV1ClinicalStudiesAssociationDerivedData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ClinicalStudiesAssociationDerivedResponse, PostApiV1ClinicalStudiesAssociationDerivedError, Options<PostApiV1ClinicalStudiesAssociationDerivedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostClinicalStudiesAssociationDerived({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Derived From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidMutation = (options?: Partial<Options<DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData>>): UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponse, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidError, Options<DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteClinicalStudiesAssociationDerivedDerivedUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Derived Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidMutation = (options?: Partial<Options<PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData>>): UseMutationOptions<PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponse, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidError, Options<PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutClinicalStudiesAssociationDerivedDerivedUuidVisitUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetAlertsQueryKey = (options?: Options<GetApiV1AlertsData>) => createQueryKey('getApiV1Alerts', options);

/**
 * Get Alerts
 *
 * List all alerts in the DB. It is possible to filter by patient IDs and
 * search string based on the `alert_variable` field (we use the `glob` syntax,
 * where `*` matches any characters). This endpoint is subject to filtering by
 * data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Alerts (31)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsOptions = (options?: Options<GetApiV1AlertsData>) => queryOptions<GetApiV1AlertsResponse, GetApiV1AlertsError, GetApiV1AlertsResponse, ReturnType<typeof apiGetAlertsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAlerts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAlertsQueryKey(options)
});

/**
 * Create Alert
 *
 * Create an alert for given data. This endpoint optionally sends an alert
 * email to patient's monitoring physician(s). This endpoint is available only
 * for Seerlinq algorithms (monitoring access + username filtering)
 * and admin users. For more info on alerts, see the _Seerlinq Alerting_
 * description.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `View Alerts (31)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostAlertsMutation = (options?: Partial<Options<PostApiV1AlertsData>>): UseMutationOptions<PostApiV1AlertsResponse, PostApiV1AlertsError, Options<PostApiV1AlertsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AlertsResponse, PostApiV1AlertsError, Options<PostApiV1AlertsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAlerts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Alert
 *
 * Delete alert by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteAlertsByUuidMutation = (options?: Partial<Options<DeleteApiV1AlertsByUuidData>>): UseMutationOptions<DeleteApiV1AlertsByUuidResponse, DeleteApiV1AlertsByUuidError, Options<DeleteApiV1AlertsByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1AlertsByUuidResponse, DeleteApiV1AlertsByUuidError, Options<DeleteApiV1AlertsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteAlertsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Alert
 *
 * Update/edit alert given its UUID. The **admin** role can update all alerts
 * and **monitoring** users can update alerts based on their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Alerts (31)` <br /> See the _API description_ for more info.
 */
export const apiPutAlertsByUuidMutation = (options?: Partial<Options<PutApiV1AlertsByUuidData>>): UseMutationOptions<PutApiV1AlertsByUuidResponse, PutApiV1AlertsByUuidError, Options<PutApiV1AlertsByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1AlertsByUuidResponse, PutApiV1AlertsByUuidError, Options<PutApiV1AlertsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutAlertsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rebuild Alerts
 *
 * Rebuild automatic alerts of Seerlinq-computed data after a recompute, so
 * they follow the newest algorithm version. One background task per patient,
 * re-evaluating the newest-version rows of `alert_variable`. Matching old
 * alerts are replaced (seen state and validation carried over), the rest
 * deleted; new alerts are tagged `recomputed`. When anything changed, the
 * patient's watch status is re-evaluated. A second run changes nothing.
 * Check progress via `tasks/api/status/{task_id}`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostAlertsRebuildMutation = (options?: Partial<Options<PostApiV1AlertsRebuildData>>): UseMutationOptions<PostApiV1AlertsRebuildResponse, PostApiV1AlertsRebuildError, Options<PostApiV1AlertsRebuildData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AlertsRebuildResponse, PostApiV1AlertsRebuildError, Options<PostApiV1AlertsRebuildData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAlertsRebuild({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetAlertsMedicalWaitingRoomQueryKey = (options?: Options<GetApiV1AlertsMedicalWaitingRoomData>) => createQueryKey('getApiV1AlertsMedicalWaitingRoom', options);

/**
 * List Medical Waiting Room
 *
 * List medical waiting room. This endpoints lists the aggregate waiting room
 * for a given timespan (30 days by default), where each row details a patient
 * with their risk score (computed as a temporally discounted sum of all alerts
 * with optional weights). The temporal discounting for computing the risk
 * score can be changed using query parameter. The patient visibility is
 * determined using the following key:
 * - users with **monitoring access+** and the **full visibility**:
 * _all_ patients that are in the waiting room
 * - monitoring team **admin** or **member**: _all_ patients from a
 * **region(s)** (and potentially **clinics**) of that team
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsMedicalWaitingRoomOptions = (options?: Options<GetApiV1AlertsMedicalWaitingRoomData>) => queryOptions<GetApiV1AlertsMedicalWaitingRoomResponse, GetApiV1AlertsMedicalWaitingRoomError, GetApiV1AlertsMedicalWaitingRoomResponse, ReturnType<typeof apiGetAlertsMedicalWaitingRoomQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAlertsMedicalWaitingRoom({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAlertsMedicalWaitingRoomQueryKey(options)
});

export const apiGetAlertsTechnicalWaitingRoomQueryKey = (options?: Options<GetApiV1AlertsTechnicalWaitingRoomData>) => createQueryKey('getApiV1AlertsTechnicalWaitingRoom', options);

/**
 * List Technical Waiting Room
 *
 * List technical waiting room. This endpoints lists the aggregate waiting room
 * for a given timespan (30 days by default), where each row details a patient.
 * The patient visibility is determined using the following key:
 * - users with **monitoring access+** and the **full visibility**:
 * _all_ patients that are in the waiting room
 * - monitoring team **admin** or **member**: _all_ patients from a
 * **region(s)** (and potentially **clinics**) of that team
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsTechnicalWaitingRoomOptions = (options?: Options<GetApiV1AlertsTechnicalWaitingRoomData>) => queryOptions<GetApiV1AlertsTechnicalWaitingRoomResponse, GetApiV1AlertsTechnicalWaitingRoomError, GetApiV1AlertsTechnicalWaitingRoomResponse, ReturnType<typeof apiGetAlertsTechnicalWaitingRoomQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAlertsTechnicalWaitingRoom({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAlertsTechnicalWaitingRoomQueryKey(options)
});

export const apiGetAlertsAuditRoomQueryKey = (options?: Options<GetApiV1AlertsAuditRoomData>) => createQueryKey('getApiV1AlertsAuditRoom', options);

/**
 * List Audit Room
 *
 * List alerting audit room, i.e., the patients that did not receive an alert
 * for at least 21 days and it's safe to audit them. The patient visibility is
 * determined using the following key:
 * - users with **monitoring access+** and the **full visibility**:
 * _all_ patients that are in the waiting room
 * - monitoring team **admin** or **member**: _all_ patients from a
 * **region(s)** (and potentially **clinics**) of that team
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsAuditRoomOptions = (options?: Options<GetApiV1AlertsAuditRoomData>) => queryOptions<GetApiV1AlertsAuditRoomResponse, GetApiV1AlertsAuditRoomError, GetApiV1AlertsAuditRoomResponse, ReturnType<typeof apiGetAlertsAuditRoomQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAlertsAuditRoom({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAlertsAuditRoomQueryKey(options)
});

/**
 * Mark Alert Seen
 *
 * Mark given alert as seen by its UUID. For more info on alerts, see the
 * _Seerlinq Alerting_ description. The **admin** role can mark as seen all
 * alerts and **medical** and **monitoring** users can validate alerts based on
 * their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiPutAlertsMarkSeenByUuidMutation = (options?: Partial<Options<PutApiV1AlertsMarkSeenByUuidData>>): UseMutationOptions<PutApiV1AlertsMarkSeenByUuidResponse, PutApiV1AlertsMarkSeenByUuidError, Options<PutApiV1AlertsMarkSeenByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1AlertsMarkSeenByUuidResponse, PutApiV1AlertsMarkSeenByUuidError, Options<PutApiV1AlertsMarkSeenByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutAlertsMarkSeenUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark All Alerts Seen
 *
 * Mark all alerts for a given patient ID and of given kind(s) as seen. For
 * more info on alerts, see the _Seerlinq Alerting_ description. The **admin**
 * role can mark as seen all alerts and **medical** and **monitoring**
 * users can mark alerts as seen based on their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiPutAlertsMarkAllSeenByPatientIdMutation = (options?: Partial<Options<PutApiV1AlertsMarkAllSeenByPatientIdData>>): UseMutationOptions<PutApiV1AlertsMarkAllSeenByPatientIdResponse, PutApiV1AlertsMarkAllSeenByPatientIdError, Options<PutApiV1AlertsMarkAllSeenByPatientIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1AlertsMarkAllSeenByPatientIdResponse, PutApiV1AlertsMarkAllSeenByPatientIdError, Options<PutApiV1AlertsMarkAllSeenByPatientIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutAlertsMarkAllSeenPatientId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Waiting Room Patient
 *
 * Update the waiting-room-editable subset of a patient's fields (risk flag,
 * the two monitoring notes, and the four monitoring statuses) given its
 * patient ID. Gated on the waiting-room policy so anyone who can view the
 * waiting room can also act on it, scoped to their patient visibility. Raises
 * when used on protected patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiPutAlertsByPatientIdWaitingRoomMutation = (options?: Partial<Options<PutApiV1AlertsByPatientIdWaitingRoomData>>): UseMutationOptions<PutApiV1AlertsByPatientIdWaitingRoomResponse, PutApiV1AlertsByPatientIdWaitingRoomError, Options<PutApiV1AlertsByPatientIdWaitingRoomData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1AlertsByPatientIdWaitingRoomResponse, PutApiV1AlertsByPatientIdWaitingRoomError, Options<PutApiV1AlertsByPatientIdWaitingRoomData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutAlertsPatientIdWaitingRoom({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate Alert
 *
 * Validate alert given its UUID. When the alert is validated, the alert
 * quality is automatically computed as a difference between automatic
 * `alert_type` and user-defined `alert_validation` fields. For more info on
 * alerts, see the _Seerlinq Alerting_ description. The **admin** role can
 * validate all alerts and **monitoring** users can validate alerts based on
 * their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `View Alerts (31)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostAlertsValidateByUuidMutation = (options?: Partial<Options<PostApiV1AlertsValidateByUuidData>>): UseMutationOptions<PostApiV1AlertsValidateByUuidResponse, PostApiV1AlertsValidateByUuidError, Options<PostApiV1AlertsValidateByUuidData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AlertsValidateByUuidResponse, PostApiV1AlertsValidateByUuidError, Options<PostApiV1AlertsValidateByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostAlertsValidateUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetAlertsSourceDataByUuidQueryKey = (options: Options<GetApiV1AlertsSourceDataByUuidData>) => createQueryKey('getApiV1AlertsSourceDataByUuid', options);

/**
 * Get Source Alert Data
 *
 * Get source data for an alert given alert UUID. The source data for the alert
 * can be either medical data, symptom, Seerlinq-computed data, PPG-derived
 * data, or ECG-derived data. The **admin** role can retrieve all source data
 * for alerts and **monitoring** users can retrieve source data alerts based on
 * their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Alerts (31)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsSourceDataByUuidOptions = (options: Options<GetApiV1AlertsSourceDataByUuidData>) => queryOptions<GetApiV1AlertsSourceDataByUuidResponse, GetApiV1AlertsSourceDataByUuidError, GetApiV1AlertsSourceDataByUuidResponse, ReturnType<typeof apiGetAlertsSourceDataByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAlertsSourceDataUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAlertsSourceDataByUuidQueryKey(options)
});

export const apiGetSchedulesQueryKey = (options?: Options<GetApiV1SchedulesData>) => createQueryKey('getApiV1Schedules', options);

/**
 * Get Schedules
 *
 * List all patients' schedules. It is possible to filter by patient IDs,
 * schedule types, and specific data names regarding the schedule. This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSchedulesOptions = (options?: Options<GetApiV1SchedulesData>) => queryOptions<GetApiV1SchedulesResponse, GetApiV1SchedulesError, GetApiV1SchedulesResponse, ReturnType<typeof apiGetSchedulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetSchedules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetSchedulesQueryKey(options)
});

/**
 * Create Schedule
 *
 * Create a new patient schedule. A **self-only** user role cannot create new
 * patient's schedule. This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostSchedulesMutation = (options?: Partial<Options<PostApiV1SchedulesData>>): UseMutationOptions<PostApiV1SchedulesResponse, PostApiV1SchedulesError, Options<PostApiV1SchedulesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1SchedulesResponse, PostApiV1SchedulesError, Options<PostApiV1SchedulesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostSchedules({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Schedule
 *
 * Delete a schedule by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeleteSchedulesByUuidMutation = (options?: Partial<Options<DeleteApiV1SchedulesByUuidData>>): UseMutationOptions<DeleteApiV1SchedulesByUuidResponse, DeleteApiV1SchedulesByUuidError, Options<DeleteApiV1SchedulesByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1SchedulesByUuidResponse, DeleteApiV1SchedulesByUuidError, Options<DeleteApiV1SchedulesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteSchedulesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Schedule
 *
 * Update/edit a schedule given its UUID. The **admin** role can update all
 * schedules, **monitoring** users can update patient schedules based on their
 * visibility, while lower access levels can update only schedules they
 * created. **Self-roles** (typically users in the `patient` role) can only
 * update schedule times.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutSchedulesByUuidMutation = (options?: Partial<Options<PutApiV1SchedulesByUuidData>>): UseMutationOptions<PutApiV1SchedulesByUuidResponse, PutApiV1SchedulesByUuidError, Options<PutApiV1SchedulesByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1SchedulesByUuidResponse, PutApiV1SchedulesByUuidError, Options<PutApiV1SchedulesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutSchedulesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetSchedulesCheckByPatientIdQueryKey = (options: Options<GetApiV1SchedulesCheckByPatientIdData>) => createQueryKey('getApiV1SchedulesCheckByPatientId', options);

/**
 * Check Schedule Done
 *
 * Check whether the given patient finished their scheduled measurements. This
 * reads all **active** schedules for a given patient ID, checks whether those
 * schedules are within a date/time window (i.e., now minus given
 * `check_back_window`), and then checks whether all scheduled measurements are
 * recorded in the DB. The `schedule_timedelta` allows for a wiggle room, and
 * the difference between actual measurement times and scheduled times is
 * computed as an absolute value. For `schedule_timedelta` and
 * `check_back_window` we use `timedelta` data type, which `pydantic`
 * (de)serializes to JSON using ISO 8601 standard on durations (see
 * [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSchedulesCheckByPatientIdOptions = (options: Options<GetApiV1SchedulesCheckByPatientIdData>) => queryOptions<GetApiV1SchedulesCheckByPatientIdResponse, GetApiV1SchedulesCheckByPatientIdError, GetApiV1SchedulesCheckByPatientIdResponse, ReturnType<typeof apiGetSchedulesCheckByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetSchedulesCheckPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetSchedulesCheckByPatientIdQueryKey(options)
});

export const apiGetSchedulesNextMeasurementByPatientIdQueryKey = (options: Options<GetApiV1SchedulesNextMeasurementByPatientIdData>) => createQueryKey('getApiV1SchedulesNextMeasurementByPatientId', options);

/**
 * Get Next Measurement
 *
 * Get the next scheduled measurement time for a patient in their
 * timezone.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSchedulesNextMeasurementByPatientIdOptions = (options: Options<GetApiV1SchedulesNextMeasurementByPatientIdData>) => queryOptions<GetApiV1SchedulesNextMeasurementByPatientIdResponse, GetApiV1SchedulesNextMeasurementByPatientIdError, GetApiV1SchedulesNextMeasurementByPatientIdResponse, ReturnType<typeof apiGetSchedulesNextMeasurementByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetSchedulesNextMeasurementPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetSchedulesNextMeasurementByPatientIdQueryKey(options)
});

export const apiGetSchedulesComplianceByPatientIdQueryKey = (options: Options<GetApiV1SchedulesComplianceByPatientIdData>) => createQueryKey('getApiV1SchedulesComplianceByPatientId', options);

/**
 * Get Compliance
 *
 * Get schedule compliance for a patient in their timezone. Each schedule
 * reports two ratios: `compliance_ratio` is hard, day-exact adherence to the
 * anchored grid as required for regulatory reporting; `soft_compliance_ratio`
 * is frequency-tolerant, allowing measurement days up to
 * `soft_tolerance_days` off the grid.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSchedulesComplianceByPatientIdOptions = (options: Options<GetApiV1SchedulesComplianceByPatientIdData>) => queryOptions<GetApiV1SchedulesComplianceByPatientIdResponse, GetApiV1SchedulesComplianceByPatientIdError, GetApiV1SchedulesComplianceByPatientIdResponse, ReturnType<typeof apiGetSchedulesComplianceByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetSchedulesCompliancePatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetSchedulesComplianceByPatientIdQueryKey(options)
});

export const apiGetThresholdsQueryKey = (options?: Options<GetApiV1ThresholdsData>) => createQueryKey('getApiV1Thresholds', options);

/**
 * Get Thresholds
 *
 * List all patient-specific threshold in the DB. It is possible to filter by
 * patient IDs and search string based on the `threshold_variable` field (we
 * use the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiGetThresholdsOptions = (options?: Options<GetApiV1ThresholdsData>) => queryOptions<GetApiV1ThresholdsResponse, GetApiV1ThresholdsError, GetApiV1ThresholdsResponse, ReturnType<typeof apiGetThresholdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetThresholds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetThresholdsQueryKey(options)
});

/**
 * Create Threshold
 *
 * Create new patient-specific threshold. The threshold for a single variable
 * (`threshold_variable`), trigger (`threshold_trigger`), type
 * (`threshold_type`), and same "threshold settings" (`threshold_settings`)
 * must be unique per patient. When user tries to create new threshold for the
 * same patient ID, same threshold variable, same trigger, same type, and with
 * same threshold settings, this endpoint raises an error. To update
 * patient-specific threshold, use the update endpoint. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `View Thresholds (32)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostThresholdsMutation = (options?: Partial<Options<PostApiV1ThresholdsData>>): UseMutationOptions<PostApiV1ThresholdsResponse, PostApiV1ThresholdsError, Options<PostApiV1ThresholdsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ThresholdsResponse, PostApiV1ThresholdsError, Options<PostApiV1ThresholdsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostThresholds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetThresholdsDefaultQueryKey = (options?: Options<GetApiV1ThresholdsDefaultData>) => createQueryKey('getApiV1ThresholdsDefault', options);

/**
 * Get Default Thresholds
 *
 * List all Seerlinq-wide default thresholds. These thresholds are defined in
 * the `common` code and are shared across all relevant components of the
 * Seerlinq stack (notably, the same thresholds are used for algorithms inside
 * `codebase` repository).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiGetThresholdsDefaultOptions = (options?: Options<GetApiV1ThresholdsDefaultData>) => queryOptions<GetApiV1ThresholdsDefaultResponse, GetApiV1ThresholdsDefaultError, GetApiV1ThresholdsDefaultResponse, ReturnType<typeof apiGetThresholdsDefaultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetThresholdsDefault({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetThresholdsDefaultQueryKey(options)
});

/**
 * Delete Threshold
 *
 * Delete patient-specific threshold by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiDeleteThresholdsByUuidMutation = (options?: Partial<Options<DeleteApiV1ThresholdsByUuidData>>): UseMutationOptions<DeleteApiV1ThresholdsByUuidResponse, DeleteApiV1ThresholdsByUuidError, Options<DeleteApiV1ThresholdsByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ThresholdsByUuidResponse, DeleteApiV1ThresholdsByUuidError, Options<DeleteApiV1ThresholdsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteThresholdsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Threshold
 *
 * Update/edit patient-specific threshold given its UUID. Upon updating, the
 * old threshold value is saved to the threshold history, which is a simple
 * list with change dates and old values. The **admin** role can update all
 * thresholds and **monitoring** users can update patient thresholds based on
 * their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiPutThresholdsByUuidMutation = (options?: Partial<Options<PutApiV1ThresholdsByUuidData>>): UseMutationOptions<PutApiV1ThresholdsByUuidResponse, PutApiV1ThresholdsByUuidError, Options<PutApiV1ThresholdsByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ThresholdsByUuidResponse, PutApiV1ThresholdsByUuidError, Options<PutApiV1ThresholdsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutThresholdsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetEventsCategoriesQueryKey = (options?: Options<GetApiV1EventsCategoriesData>) => createQueryKey('getApiV1EventsCategories', options);

/**
 * List Event Categories
 *
 * List all event categories, their relevant category types and category
 * details.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiGetEventsCategoriesOptions = (options?: Options<GetApiV1EventsCategoriesData>) => queryOptions<GetApiV1EventsCategoriesResponse, GetApiV1EventsCategoriesError, GetApiV1EventsCategoriesResponse, ReturnType<typeof apiGetEventsCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetEventsCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEventsCategoriesQueryKey(options)
});

export const apiGetEventsQueryKey = (options?: Options<GetApiV1EventsData>) => createQueryKey('getApiV1Events', options);

/**
 * Get Events
 *
 * List all patients' events in the DB. It is possible to filter by patient
 * IDs, types of events, and search string based on the `event_description`
 * field (we use the `glob` syntax, where `*` matches any characters) This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiGetEventsOptions = (options?: Options<GetApiV1EventsData>) => queryOptions<GetApiV1EventsResponse, GetApiV1EventsError, GetApiV1EventsResponse, ReturnType<typeof apiGetEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetEventsQueryKey(options)
});

/**
 * Create Event
 *
 * Create new patient event. This endpoint is subject to filtering by data
 * visibility dimension. Only **monitoring** users can create a death event,
 * and a patient can have only one.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `View Events (33)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostEventsMutation = (options?: Partial<Options<PostApiV1EventsData>>): UseMutationOptions<PostApiV1EventsResponse, PostApiV1EventsError, Options<PostApiV1EventsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1EventsResponse, PostApiV1EventsError, Options<PostApiV1EventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Event
 *
 * Delete patient event by its UUID. Only **monitoring** users can delete a
 * death event.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiDeleteEventsByUuidMutation = (options?: Partial<Options<DeleteApiV1EventsByUuidData>>): UseMutationOptions<DeleteApiV1EventsByUuidResponse, DeleteApiV1EventsByUuidError, Options<DeleteApiV1EventsByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1EventsByUuidResponse, DeleteApiV1EventsByUuidError, Options<DeleteApiV1EventsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteEventsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Event
 *
 * Update/edit patient event given its UUID. The **admin** role can update all
 * events and users with `VIEW_EVENTS` can update patient events based on
 * their visibility. Only **monitoring** users can update a death event.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiPutEventsByUuidMutation = (options?: Partial<Options<PutApiV1EventsByUuidData>>): UseMutationOptions<PutApiV1EventsByUuidResponse, PutApiV1EventsByUuidError, Options<PutApiV1EventsByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1EventsByUuidResponse, PutApiV1EventsByUuidError, Options<PutApiV1EventsByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutEventsUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMessagingQueryKey = (options?: Options<GetApiV1MessagingData>) => createQueryKey('getApiV1Messaging', options);

/**
 * Get All Messages
 *
 * List all messages belonging to _any_ patient ID. A **self-only** user role
 * cannot list all messages, rather they can use a specific endpoint with
 * the patient ID as the path parameter to get the last message for a
 * particular patient ID. It is possible to filter filter by patient IDs and
 * whether messages are active. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMessagingOptions = (options?: Options<GetApiV1MessagingData>) => queryOptions<GetApiV1MessagingResponse, GetApiV1MessagingError, GetApiV1MessagingResponse, ReturnType<typeof apiGetMessagingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMessaging({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMessagingQueryKey(options)
});

/**
 * Create Message
 *
 * Create a new message. This endpoint is subject to filtering by data
 * visibility dimension. A **self-only** user role cannot create a new message.
 * This endpoint also sets all previous messages for a patient as deactivated
 * (regardless of their expiry), i.e., only **one** message per patient can be
 * active at any given time.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMessagingMutation = (options?: Partial<Options<PostApiV1MessagingData>>): UseMutationOptions<PostApiV1MessagingResponse, PostApiV1MessagingError, Options<PostApiV1MessagingData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MessagingResponse, PostApiV1MessagingError, Options<PostApiV1MessagingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMessaging({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMessagingByPatientIdQueryKey = (options: Options<GetApiV1MessagingByPatientIdData>) => createQueryKey('getApiV1MessagingByPatientId', options);

/**
 * Get Last Message
 *
 * Get the last active message for a given patient ID. If the message expires,
 * it will be returned, but the message status will list it as expired. There
 * is no difference between no messages whatsoever and all messages being
 * deactivated. This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMessagingByPatientIdOptions = (options: Options<GetApiV1MessagingByPatientIdData>) => queryOptions<GetApiV1MessagingByPatientIdResponse, GetApiV1MessagingByPatientIdError, GetApiV1MessagingByPatientIdResponse, ReturnType<typeof apiGetMessagingByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMessagingPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMessagingByPatientIdQueryKey(options)
});

/**
 * Delete Message
 *
 * Delete a message by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeleteMessagingByUuidMutation = (options?: Partial<Options<DeleteApiV1MessagingByUuidData>>): UseMutationOptions<DeleteApiV1MessagingByUuidResponse, DeleteApiV1MessagingByUuidError, Options<DeleteApiV1MessagingByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MessagingByUuidResponse, DeleteApiV1MessagingByUuidError, Options<DeleteApiV1MessagingByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMessagingUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Message
 *
 * Update/edit a message given its UUID. The **admin** role can update all
 * messages, while lower access levels can update only messages they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMessagingByUuidMutation = (options?: Partial<Options<PutApiV1MessagingByUuidData>>): UseMutationOptions<PutApiV1MessagingByUuidResponse, PutApiV1MessagingByUuidError, Options<PutApiV1MessagingByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1MessagingByUuidResponse, PutApiV1MessagingByUuidError, Options<PutApiV1MessagingByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutMessagingUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetStudyTextQueryKey = (options?: Options<GetApiV1StudyTextData>) => createQueryKey('getApiV1StudyText', options);

/**
 * Get All Study Texts
 *
 * Get the list of study texts.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetStudyTextOptions = (options?: Options<GetApiV1StudyTextData>) => queryOptions<GetApiV1StudyTextResponse, GetApiV1StudyTextError, GetApiV1StudyTextResponse, ReturnType<typeof apiGetStudyTextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetStudyText({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetStudyTextQueryKey(options)
});

/**
 * Create Study Text
 *
 * Publish a Seerlinq study text. Texts are append-only final legal texts:
 * new content is a new version, higher than every version of its lineage
 * (consent type, monitoring type, country, region, clinic, physician and
 * language), and publishing it stales every patient it now resolves for
 * who signed another text, unless it is a patch version of their text's
 * lineage - `patients_to_resign` says how many, over all patients. The
 * language is an ISO 639-1 code with an optional region
 * (`language[-REGION]`), matched exactly. Only consent types signed on a
 * text take one (422 otherwise). The text may refer to patient fields with
 * `python` string formatting, e.g. `{patient.full_name}`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostStudyTextMutation = (options?: Partial<Options<PostApiV1StudyTextData>>): UseMutationOptions<PostApiV1StudyTextResponse, PostApiV1StudyTextError, Options<PostApiV1StudyTextData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1StudyTextResponse, PostApiV1StudyTextError, Options<PostApiV1StudyTextData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostStudyText({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetStudyTextAboutByTextByLanguageQueryKey = (options: Options<GetApiV1StudyTextAboutByTextByLanguageData>) => createQueryKey('getApiV1StudyTextAboutByTextByLanguage', options);

/**
 * About Seerlinq
 *
 * Get "About Seerlinq" text.
 */
export const apiGetStudyTextAboutByTextByLanguageOptions = (options: Options<GetApiV1StudyTextAboutByTextByLanguageData>) => queryOptions<GetApiV1StudyTextAboutByTextByLanguageResponse, GetApiV1StudyTextAboutByTextByLanguageError, GetApiV1StudyTextAboutByTextByLanguageResponse, ReturnType<typeof apiGetStudyTextAboutByTextByLanguageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetStudyTextAboutTextLanguage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetStudyTextAboutByTextByLanguageQueryKey(options)
});

export const apiGetStudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageQueryKey = (options: Options<GetApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageData>) => createQueryKey('getApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguage', options);

/**
 * Get Consent Text
 *
 * The text of a consent a patient is asked to sign: at the most specific
 * level (physician > clinic > region > country > global) with a text in
 * any language, the lineage in exactly the language or locale given (404 when
 * the level has none), then its newest version. For a given `patient_id`
 * the lookup uses the patient's monitoring type and scope, ignoring the
 * path's monitoring type; a patient account without one gets its own.
 */
export const apiGetStudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageOptions = (options: Options<GetApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageData>) => queryOptions<GetApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageResponse, GetApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageError, GetApiV1StudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageResponse, ReturnType<typeof apiGetStudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetStudyTextConsentConsentTypeMonitoringTypeTextLanguage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetStudyTextConsentByConsentTypeByMonitoringTypeByTextLanguageQueryKey(options)
});

export const apiGetStudyTextByMonitoringTypeByTextLanguageQueryKey = (options: Options<GetApiV1StudyTextByMonitoringTypeByTextLanguageData>) => createQueryKey('getApiV1StudyTextByMonitoringTypeByTextLanguage', options);

/**
 * Get Study Text
 *
 * **Deprecated** - use
 * `GET /consent/telemonitoring/{monitoring_type}/{text_language}`,
 * which this endpoint is pinned to. For a `patient_id` whose level has no
 * text in the language, the text in their consent language.
 *
 * @deprecated
 */
export const apiGetStudyTextByMonitoringTypeByTextLanguageOptions = (options: Options<GetApiV1StudyTextByMonitoringTypeByTextLanguageData>) => queryOptions<GetApiV1StudyTextByMonitoringTypeByTextLanguageResponse, GetApiV1StudyTextByMonitoringTypeByTextLanguageError, GetApiV1StudyTextByMonitoringTypeByTextLanguageResponse, ReturnType<typeof apiGetStudyTextByMonitoringTypeByTextLanguageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetStudyTextMonitoringTypeTextLanguage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetStudyTextByMonitoringTypeByTextLanguageQueryKey(options)
});

/**
 * Delete Study Text
 *
 * Delete a Seerlinq study text nobody signed, e.g. a mistake to republish.
 * Its patients fall back to the text below it; a delete never stales
 * anyone, since a signed text cannot be deleted.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeleteStudyTextByUuidMutation = (options?: Partial<Options<DeleteApiV1StudyTextByUuidData>>): UseMutationOptions<DeleteApiV1StudyTextByUuidResponse, DeleteApiV1StudyTextByUuidError, Options<DeleteApiV1StudyTextByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1StudyTextByUuidResponse, DeleteApiV1StudyTextByUuidError, Options<DeleteApiV1StudyTextByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteStudyTextUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetStudyTextByUuidQueryKey = (options: Options<GetApiV1StudyTextByUuidData>) => createQueryKey('getApiV1StudyTextByUuid', options);

/**
 * Get Study Text By Uuid
 *
 * One text by its UUID, e.g. the signed version for the re-sign diff.
 * `MONITORING_READ`, or a patient for a text they signed or one resolving
 * for them.
 */
export const apiGetStudyTextByUuidOptions = (options: Options<GetApiV1StudyTextByUuidData>) => queryOptions<GetApiV1StudyTextByUuidResponse, GetApiV1StudyTextByUuidError, GetApiV1StudyTextByUuidResponse, ReturnType<typeof apiGetStudyTextByUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetStudyTextUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetStudyTextByUuidQueryKey(options)
});

export const apiGetLimitersQueryKey = (options?: Options<GetApiV1LimitersData>) => createQueryKey('getApiV1Limiters', options);

/**
 * Get Limiters
 *
 * Get the list of all access limiters.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetLimitersOptions = (options?: Options<GetApiV1LimitersData>) => queryOptions<GetApiV1LimitersResponse, GetApiV1LimitersError, GetApiV1LimitersResponse, ReturnType<typeof apiGetLimitersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetLimiters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetLimitersQueryKey(options)
});

/**
 * Create Limiter
 *
 * Create a new access limiter.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostLimitersMutation = (options?: Partial<Options<PostApiV1LimitersData>>): UseMutationOptions<PostApiV1LimitersResponse, PostApiV1LimitersError, Options<PostApiV1LimitersData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1LimitersResponse, PostApiV1LimitersError, Options<PostApiV1LimitersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostLimiters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Limiter
 *
 * Delete an access limiter given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteLimitersByUuidMutation = (options?: Partial<Options<DeleteApiV1LimitersByUuidData>>): UseMutationOptions<DeleteApiV1LimitersByUuidResponse, DeleteApiV1LimitersByUuidError, Options<DeleteApiV1LimitersByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1LimitersByUuidResponse, DeleteApiV1LimitersByUuidError, Options<DeleteApiV1LimitersByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteLimitersUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Limiter
 *
 * Update/edit an access limiter given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutLimitersByUuidMutation = (options?: Partial<Options<PutApiV1LimitersByUuidData>>): UseMutationOptions<PutApiV1LimitersByUuidResponse, PutApiV1LimitersByUuidError, Options<PutApiV1LimitersByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1LimitersByUuidResponse, PutApiV1LimitersByUuidError, Options<PutApiV1LimitersByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutLimitersUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Push Notifications To Users
 *
 * Send push notification to multiple users by UUID.
 * Sends to all registered devices for all targeted users.
 *
 * Notes:
 * - Queues ticket IDs for later receipt verification by cron job (~15 min)
 * - Invalid tokens will be removed when receipts indicate delivery failure
 * - Returns success if Expo accepts the request
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPushNotificationsSendMutation = (options?: Partial<Options<PostApiV1PushNotificationsSendData>>): UseMutationOptions<PostApiV1PushNotificationsSendResponse, PostApiV1PushNotificationsSendError, Options<PostApiV1PushNotificationsSendData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PushNotificationsSendResponse, PostApiV1PushNotificationsSendError, Options<PostApiV1PushNotificationsSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPushNotificationsSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Push Notification To Patient
 *
 * Send push notification to a single patient by ID, to every device of the
 * patient's connected accounts.
 *
 * Notes:
 * - `path` is passed through to the client as `data.path` for deep linking
 * - recorded in the notification ledger as `kind=manual`, in `language` or
 * else the language of an account it reaches, and audited as a note naming
 * the sending admin
 * - Returns 404 when the patient has no device registered; a send Expo
 * refused for every device answers 200 with 0 queued
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPushNotificationsSendToPatientMutation = (options?: Partial<Options<PostApiV1PushNotificationsSendToPatientData>>): UseMutationOptions<PostApiV1PushNotificationsSendToPatientResponse, PostApiV1PushNotificationsSendToPatientError, Options<PostApiV1PushNotificationsSendToPatientData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PushNotificationsSendToPatientResponse, PostApiV1PushNotificationsSendToPatientError, Options<PostApiV1PushNotificationsSendToPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPushNotificationsSendToPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Templated Push Notification
 *
 * Send one of the notification engine's own messages, rendered from
 * `notifications.json`, without waiting for the event that would trigger it.
 *
 * Notes:
 * - only `user_uuid`'s own devices are addressed
 * - the ledger row is `kind=manual` with a `manual:<uuid>` key, so a copy
 * review never consumes a real event
 * - `force` sends outside the 05:00-21:59 local window
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPushNotificationsSendTemplatedMutation = (options?: Partial<Options<PostApiV1PushNotificationsSendTemplatedData>>): UseMutationOptions<PostApiV1PushNotificationsSendTemplatedResponse, PostApiV1PushNotificationsSendTemplatedError, Options<PostApiV1PushNotificationsSendTemplatedData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PushNotificationsSendTemplatedResponse, PostApiV1PushNotificationsSendTemplatedError, Options<PostApiV1PushNotificationsSendTemplatedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostPushNotificationsSendTemplated({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetPushNotificationsLogQueryKey = (options?: Options<GetApiV1PushNotificationsLogData>) => createQueryKey('getApiV1PushNotificationsLog', options);

/**
 * Get Patient Notification Log
 *
 * What each patient was told, when, and in which language: the ledger, paged
 * by `limit` and `offset`, with `total` for the rows the filters match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPushNotificationsLogOptions = (options?: Options<GetApiV1PushNotificationsLogData>) => queryOptions<GetApiV1PushNotificationsLogResponse, GetApiV1PushNotificationsLogError, GetApiV1PushNotificationsLogResponse, ReturnType<typeof apiGetPushNotificationsLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetPushNotificationsLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPushNotificationsLogQueryKey(options)
});

export const apiGetPushNotificationsLogInfiniteQueryKey = (options?: Options<GetApiV1PushNotificationsLogData>): QueryKey<Options<GetApiV1PushNotificationsLogData>> => createQueryKey('getApiV1PushNotificationsLog', options, true);

/**
 * Get Patient Notification Log
 *
 * What each patient was told, when, and in which language: the ledger, paged
 * by `limit` and `offset`, with `total` for the rows the filters match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPushNotificationsLogInfiniteOptions = (options?: Options<GetApiV1PushNotificationsLogData>) => infiniteQueryOptions<GetApiV1PushNotificationsLogResponse, GetApiV1PushNotificationsLogError, InfiniteData<GetApiV1PushNotificationsLogResponse>, QueryKey<Options<GetApiV1PushNotificationsLogData>>, number | Pick<QueryKey<Options<GetApiV1PushNotificationsLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1PushNotificationsLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetPushNotificationsLog({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetPushNotificationsLogInfiniteQueryKey(options)
});

export const apiGetTasksApiStatusByTaskIdQueryKey = (options: Options<GetApiV1TasksApiStatusByTaskIdData>) => createQueryKey('getApiV1TasksApiStatusByTaskId', options);

/**
 * Is Api Task Ready
 *
 * Check whether background API task is ready.
 */
export const apiGetTasksApiStatusByTaskIdOptions = (options: Options<GetApiV1TasksApiStatusByTaskIdData>) => queryOptions<GetApiV1TasksApiStatusByTaskIdResponse, GetApiV1TasksApiStatusByTaskIdError, GetApiV1TasksApiStatusByTaskIdResponse, ReturnType<typeof apiGetTasksApiStatusByTaskIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksApiStatusTaskId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksApiStatusByTaskIdQueryKey(options)
});

export const apiGetTasksApiTaskIdsQueryKey = (options?: Options<GetApiV1TasksApiTaskIdsData>) => createQueryKey('getApiV1TasksApiTaskIds', options);

/**
 * Get All Api Task Ids
 *
 * List all task IDs that are saved in the result backend.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksApiTaskIdsOptions = (options?: Options<GetApiV1TasksApiTaskIdsData>) => queryOptions<GetApiV1TasksApiTaskIdsResponse, GetApiV1TasksApiTaskIdsError, GetApiV1TasksApiTaskIdsResponse, ReturnType<typeof apiGetTasksApiTaskIdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksApiTaskIds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksApiTaskIdsQueryKey(options)
});

export const apiGetTasksApiResultByTaskIdQueryKey = (options: Options<GetApiV1TasksApiResultByTaskIdData>) => createQueryKey('getApiV1TasksApiResultByTaskId', options);

/**
 * Get Api Task Result
 *
 * Get info on the background API task result. For a user with **medical
 * access** or below, this returns whether the task is done and whether it
 * errored (and if so, the stacktrace). For a user with **monitoring access**
 * and higher, it also returns the full result, including logs - unless the
 * task was kicked with `hide_result`.
 */
export const apiGetTasksApiResultByTaskIdOptions = (options: Options<GetApiV1TasksApiResultByTaskIdData>) => queryOptions<GetApiV1TasksApiResultByTaskIdResponse, GetApiV1TasksApiResultByTaskIdError, GetApiV1TasksApiResultByTaskIdResponse, ReturnType<typeof apiGetTasksApiResultByTaskIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksApiResultTaskId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksApiResultByTaskIdQueryKey(options)
});

export const apiGetTasksWorkerStatusByTaskIdQueryKey = (options: Options<GetApiV1TasksWorkerStatusByTaskIdData>) => createQueryKey('getApiV1TasksWorkerStatusByTaskId', options);

/**
 * Worker Task Status
 *
 * Check status of background `celery` task.
 */
export const apiGetTasksWorkerStatusByTaskIdOptions = (options: Options<GetApiV1TasksWorkerStatusByTaskIdData>) => queryOptions<GetApiV1TasksWorkerStatusByTaskIdResponse, GetApiV1TasksWorkerStatusByTaskIdError, GetApiV1TasksWorkerStatusByTaskIdResponse, ReturnType<typeof apiGetTasksWorkerStatusByTaskIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerStatusTaskId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerStatusByTaskIdQueryKey(options)
});

export const apiGetTasksWorkerResultByTaskIdQueryKey = (options: Options<GetApiV1TasksWorkerResultByTaskIdData>) => createQueryKey('getApiV1TasksWorkerResultByTaskId', options);

/**
 * Get Worker Task Result
 *
 * Get info on the background `celery` task result. For a user without **admin
 * access**, this returns the task status, date time when the task was
 * finished (or failed), and the error stacktrace if the task failed. For a
 * user with **admin access**, it also returns the full result as returned
 * by Seerlinq algorithms.
 */
export const apiGetTasksWorkerResultByTaskIdOptions = (options: Options<GetApiV1TasksWorkerResultByTaskIdData>) => queryOptions<GetApiV1TasksWorkerResultByTaskIdResponse, GetApiV1TasksWorkerResultByTaskIdError, GetApiV1TasksWorkerResultByTaskIdResponse, ReturnType<typeof apiGetTasksWorkerResultByTaskIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerResultTaskId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerResultByTaskIdQueryKey(options)
});

export const apiGetTasksWorkerQuicklookByTaskIdQueryKey = (options: Options<GetApiV1TasksWorkerQuicklookByTaskIdData>) => createQueryKey('getApiV1TasksWorkerQuicklookByTaskId', options);

/**
 * Render Quicklook Html Worker Result
 *
 * Render the result of a _QuickLook_ `celery` task as a HTML page.
 * Access is checked against specific QuickLook permissions based on the
 * algorithm type.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerQuicklookByTaskIdOptions = (options: Options<GetApiV1TasksWorkerQuicklookByTaskIdData>) => queryOptions<GetApiV1TasksWorkerQuicklookByTaskIdResponse, GetApiV1TasksWorkerQuicklookByTaskIdError, GetApiV1TasksWorkerQuicklookByTaskIdResponse, ReturnType<typeof apiGetTasksWorkerQuicklookByTaskIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerQuicklookTaskId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerQuicklookByTaskIdQueryKey(options)
});

export const apiGetTasksWorkerQuicklookByTaskIdPdfQueryKey = (options: Options<GetApiV1TasksWorkerQuicklookByTaskIdPdfData>) => createQueryKey('getApiV1TasksWorkerQuicklookByTaskIdPdf', options);

/**
 * Render Quicklook Pdf Worker Result
 *
 * Render the result of a _QuickLook_ `celery` task as a PDF file.
 * Access is checked against specific QuickLook permissions based on the
 * algorithm type. To obtain a PDF result, submit the task with
 * `report_format=pdf`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerQuicklookByTaskIdPdfOptions = (options: Options<GetApiV1TasksWorkerQuicklookByTaskIdPdfData>) => queryOptions<unknown, GetApiV1TasksWorkerQuicklookByTaskIdPdfError, unknown, ReturnType<typeof apiGetTasksWorkerQuicklookByTaskIdPdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerQuicklookTaskIdPdf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerQuicklookByTaskIdPdfQueryKey(options)
});

export const apiGetTasksWorkerQuicklookByTaskIdJsonQueryKey = (options: Options<GetApiV1TasksWorkerQuicklookByTaskIdJsonData>) => createQueryKey('getApiV1TasksWorkerQuicklookByTaskIdJson', options);

/**
 * Render Quicklook Json Worker Result
 *
 * Render the result of a _QuickLook_ `celery` task as a JSON report.
 * Access is checked against specific QuickLook permissions based on the
 * algorithm type. **HeartCore Master** reports are additionally filtered
 * per viewer: only sections the rendering user's permission bits allow
 * (matched on `section_key`) are returned. To obtain a JSON result, submit
 * the task with `report_format=json`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerQuicklookByTaskIdJsonOptions = (options: Options<GetApiV1TasksWorkerQuicklookByTaskIdJsonData>) => queryOptions<GetApiV1TasksWorkerQuicklookByTaskIdJsonResponse, GetApiV1TasksWorkerQuicklookByTaskIdJsonError, GetApiV1TasksWorkerQuicklookByTaskIdJsonResponse, ReturnType<typeof apiGetTasksWorkerQuicklookByTaskIdJsonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerQuicklookTaskIdJson({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerQuicklookByTaskIdJsonQueryKey(options)
});

export const apiGetTasksWorkerQuicklookShareByTaskIdQueryKey = (options: Options<GetApiV1TasksWorkerQuicklookShareByTaskIdData>) => createQueryKey('getApiV1TasksWorkerQuicklookShareByTaskId', options);

/**
 * Share Quicklook Analysis
 *
 * Share the result of a _QuickLook_ `celery` task externally. THis endpoint
 * will generate a URL containing one-time tokens and anyone with the correct
 * URL will be able to see the analysis without being logged in. The token
 * expires after 1:00:00 hours.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerQuicklookShareByTaskIdOptions = (options: Options<GetApiV1TasksWorkerQuicklookShareByTaskIdData>) => queryOptions<GetApiV1TasksWorkerQuicklookShareByTaskIdResponse, GetApiV1TasksWorkerQuicklookShareByTaskIdError, GetApiV1TasksWorkerQuicklookShareByTaskIdResponse, ReturnType<typeof apiGetTasksWorkerQuicklookShareByTaskIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerQuicklookShareTaskId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerQuicklookShareByTaskIdQueryKey(options)
});

export const apiGetTasksWorkerQuicklookSharedByTaskIdQueryKey = (options: Options<GetApiV1TasksWorkerQuicklookSharedByTaskIdData>) => createQueryKey('getApiV1TasksWorkerQuicklookSharedByTaskId', options);

/**
 * Render Shared Quicklook Html Worker Result
 *
 * Render the result of a **shared** _QuickLook_ `celery` task as a HTML page.
 * Note, that anyone with the correct link will be able to see this analysis.
 * The one-time tokens are provided as query parameters and the token expires
 * after 1:00:00 hours.
 */
export const apiGetTasksWorkerQuicklookSharedByTaskIdOptions = (options: Options<GetApiV1TasksWorkerQuicklookSharedByTaskIdData>) => queryOptions<GetApiV1TasksWorkerQuicklookSharedByTaskIdResponse, GetApiV1TasksWorkerQuicklookSharedByTaskIdError, GetApiV1TasksWorkerQuicklookSharedByTaskIdResponse, ReturnType<typeof apiGetTasksWorkerQuicklookSharedByTaskIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerQuicklookSharedTaskId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerQuicklookSharedByTaskIdQueryKey(options)
});

export const apiGetTasksWorkerListTasksQueryKey = (options?: Options<GetApiV1TasksWorkerListTasksData>) => createQueryKey('getApiV1TasksWorkerListTasks', options);

/**
 * Get All Celery Tasks And Queues
 *
 * List all registered `celery` tasks.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerListTasksOptions = (options?: Options<GetApiV1TasksWorkerListTasksData>) => queryOptions<GetApiV1TasksWorkerListTasksResponse, GetApiV1TasksWorkerListTasksError, GetApiV1TasksWorkerListTasksResponse, ReturnType<typeof apiGetTasksWorkerListTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerListTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerListTasksQueryKey(options)
});

export const apiGetTasksWorkerListQuicklookTasksQueryKey = (options?: Options<GetApiV1TasksWorkerListQuicklookTasksData>) => createQueryKey('getApiV1TasksWorkerListQuicklookTasks', options);

/**
 * Get Quicklook Celery Tasks
 *
 * List _QuickLook_ `celery` tasks, i.e., tasks that return HTML analysis and
 * can be submitted and inspected by users with **monitoring access**
 * and higher.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerListQuicklookTasksOptions = (options?: Options<GetApiV1TasksWorkerListQuicklookTasksData>) => queryOptions<GetApiV1TasksWorkerListQuicklookTasksResponse, GetApiV1TasksWorkerListQuicklookTasksError, GetApiV1TasksWorkerListQuicklookTasksResponse, ReturnType<typeof apiGetTasksWorkerListQuicklookTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetTasksWorkerListQuicklookTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetTasksWorkerListQuicklookTasksQueryKey(options)
});

/**
 * Submit Ppg Worker Task
 *
 * Submit background `celery` task. This endpoints allows submitting any task
 * that have PPGs as an task input, and is only for admins. When you are
 * **monitoring** user and want to submit a _QuickLook_ analysis task, see
 * `tasks/worker/quicklook/ppg` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkerSubmitPpgMutation = (options?: Partial<Options<PostApiV1TasksWorkerSubmitPpgData>>): UseMutationOptions<PostApiV1TasksWorkerSubmitPpgResponse, PostApiV1TasksWorkerSubmitPpgError, Options<PostApiV1TasksWorkerSubmitPpgData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1TasksWorkerSubmitPpgResponse, PostApiV1TasksWorkerSubmitPpgError, Options<PostApiV1TasksWorkerSubmitPpgData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostTasksWorkerSubmitPpg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Patient Worker Task
 *
 * Submit background `celery` task. This endpoints allows submitting any task
 * that have patient IDs as an task input, and is only for admins. When you are
 * **monitoring** user and want to submit a _QuickLook_ analysis task, see
 * `tasks/worker/quicklook/patient` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkerSubmitPatientMutation = (options?: Partial<Options<PostApiV1TasksWorkerSubmitPatientData>>): UseMutationOptions<PostApiV1TasksWorkerSubmitPatientResponse, PostApiV1TasksWorkerSubmitPatientError, Options<PostApiV1TasksWorkerSubmitPatientData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1TasksWorkerSubmitPatientResponse, PostApiV1TasksWorkerSubmitPatientError, Options<PostApiV1TasksWorkerSubmitPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostTasksWorkerSubmitPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Ppg Worker Workflow
 *
 * Submit background registered `celery` workflows. This endpoint allows
 * submitting one of registered Seerlinq DAG workflow and is only for admins.
 * If you want to submit a custom workflow, see `tasks/workflow/build`
 * endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkflowSubmitMutation = (options?: Partial<Options<PostApiV1TasksWorkflowSubmitData>>): UseMutationOptions<PostApiV1TasksWorkflowSubmitResponse, PostApiV1TasksWorkflowSubmitError, Options<PostApiV1TasksWorkflowSubmitData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1TasksWorkflowSubmitResponse, PostApiV1TasksWorkflowSubmitError, Options<PostApiV1TasksWorkflowSubmitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostTasksWorkflowSubmit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Build And Submit Worker Workflow
 *
 * Build and submit background `celery` workflow. This endpoint allows
 * submitting tasks in a custom DAG workflow and is only for admins.
 * Tasks in workflow can receive arguments and keyword arguments.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkflowBuildMutation = (options?: Partial<Options<PostApiV1TasksWorkflowBuildData>>): UseMutationOptions<PostApiV1TasksWorkflowBuildResponse, PostApiV1TasksWorkflowBuildError, Options<PostApiV1TasksWorkflowBuildData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1TasksWorkflowBuildResponse, PostApiV1TasksWorkflowBuildError, Options<PostApiV1TasksWorkflowBuildData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostTasksWorkflowBuild({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Ppg Quicklook Task
 *
 * Submit a _QuickLook_ analysis task with PPGs as an input. _QuickLook_ tasks
 * are tasks that return valid HTML page containing the tables and plots
 * resulting from the analysis. For rendering the final analysis (when the task
 * is ready), use the
 * `tasks/worker/quicklook/{task_id}` endpoint (HTML),
 * `tasks/worker/quicklook/{task_id}/pdf` (PDF), or
 * `tasks/worker/quicklook/{task_id}/json` (JSON).
 *
 * Permission is checked based on the task type:
 * - PPG timeseries / AUC / beats tasks require `PPG_RAW`
 * - AFib task requires `AFIB` (on top of `PPG_RAW`)
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Raw (42)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkerQuicklookPpgMutation = (options?: Partial<Options<PostApiV1TasksWorkerQuicklookPpgData>>): UseMutationOptions<PostApiV1TasksWorkerQuicklookPpgResponse, PostApiV1TasksWorkerQuicklookPpgError, Options<PostApiV1TasksWorkerQuicklookPpgData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1TasksWorkerQuicklookPpgResponse, PostApiV1TasksWorkerQuicklookPpgError, Options<PostApiV1TasksWorkerQuicklookPpgData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostTasksWorkerQuicklookPpg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Patient Quicklook Task
 *
 * Submit a _QuickLook_ analysis task with patient IDs as an input. _QuickLook_
 * tasks are tasks that return valid HTML page containing the tables and plots
 * resulting from the analysis. For rendering the final analysis (when the task
 * is ready), use the
 * `tasks/worker/quicklook/{task_id}` endpoint (HTML),
 * `tasks/worker/quicklook/{task_id}/pdf` (PDF), or
 * `tasks/worker/quicklook/{task_id}/json` (JSON).
 *
 * Permission is checked based on the task type:
 * - DRI tasks require `ACCESS_DRI`
 * - LVFP tasks require `ACCESS_LVFP`
 * - HeartCore tasks require `RUN_HEART_CORE_QUICKLOOK`
 *
 * The **HeartCore Master** _QuickLook_ cannot be submitted here — use the
 * dedicated `tasks/worker/quicklook/heartcore-master/{patient_id}` endpoint,
 * which computes the per-section permission allowlist.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkerQuicklookPatientMutation = (options?: Partial<Options<PostApiV1TasksWorkerQuicklookPatientData>>): UseMutationOptions<PostApiV1TasksWorkerQuicklookPatientResponse, PostApiV1TasksWorkerQuicklookPatientError, Options<PostApiV1TasksWorkerQuicklookPatientData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1TasksWorkerQuicklookPatientResponse, PostApiV1TasksWorkerQuicklookPatientError, Options<PostApiV1TasksWorkerQuicklookPatientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostTasksWorkerQuicklookPatient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Heartcore Quicklook
 *
 * Submit Seerlinq's famed _QuickLook_ analysis **HeartCore** report for a
 * given patient ID. _QuickLook_ tasks are tasks that return valid HTML page
 * containing the tables and plots resulting from the analysis. For rendering
 * the final analysis (when the task is ready), use the
 * `tasks/worker/quicklook/{task_id}` endpoint (HTML),
 * `tasks/worker/quicklook/{task_id}/pdf` (PDF), or
 * `tasks/worker/quicklook/{task_id}/json` (JSON).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Run Heart Core Quicklook (41)` <br /> See the _API description_ for more info.
 */
export const apiPutTasksWorkerQuicklookHeartcoreByPatientIdMutation = (options?: Partial<Options<PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdData>>): UseMutationOptions<PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdResponse, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdError, Options<PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdResponse, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdError, Options<PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutTasksWorkerQuicklookHeartcorePatientId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Heartcore Master Quicklook
 *
 * Submit the **HeartCore Master** _QuickLook_ analysis for a given patient ID,
 * i.e., the JSON-only union of all patient-level report sections. The rendered
 * sections are the *permitted* sections minus `skip_sections`, where permitted
 * is derived from the user's permission bits. For rendering the final analysis
 * (when the task is ready), use the
 * `tasks/worker/quicklook/{task_id}/json` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Run Heart Core Quicklook (41)` <br /> See the _API description_ for more info.
 */
export const apiPutTasksWorkerQuicklookHeartcoreMasterByPatientIdMutation = (options?: Partial<Options<PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdData>>): UseMutationOptions<PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdResponse, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdError, Options<PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdResponse, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdError, Options<PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutTasksWorkerQuicklookHeartcoreMasterPatientId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetUtilsCountriesQueryKey = (options?: Options<GetApiV1UtilsCountriesData>) => createQueryKey('getApiV1UtilsCountries', options);

/**
 * Get Countries Regions
 *
 * List countries and their regions.
 *
 * Uses common_name where available (e.g., "South Korea" not
 * "Korea, Republic of").
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetUtilsCountriesOptions = (options?: Options<GetApiV1UtilsCountriesData>) => queryOptions<GetApiV1UtilsCountriesResponse, GetApiV1UtilsCountriesError, GetApiV1UtilsCountriesResponse, ReturnType<typeof apiGetUtilsCountriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetUtilsCountries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetUtilsCountriesQueryKey(options)
});

export const apiGetUtilsErrorCodesByLanguageQueryKey = (options: Options<GetApiV1UtilsErrorCodesByLanguageData>) => createQueryKey('getApiV1UtilsErrorCodesByLanguage', options);

/**
 * Get Error Codes
 *
 * Get all error codes and their corresponding messages.
 *
 * This endpoint is used by frontend clients to load error messages
 * based on the user's selected language.
 */
export const apiGetUtilsErrorCodesByLanguageOptions = (options: Options<GetApiV1UtilsErrorCodesByLanguageData>) => queryOptions<GetApiV1UtilsErrorCodesByLanguageResponse, GetApiV1UtilsErrorCodesByLanguageError, GetApiV1UtilsErrorCodesByLanguageResponse, ReturnType<typeof apiGetUtilsErrorCodesByLanguageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetUtilsErrorCodesLanguage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetUtilsErrorCodesByLanguageQueryKey(options)
});

export const apiGetUtilsSupportContactByLanguageQueryKey = (options: Options<GetApiV1UtilsSupportContactByLanguageData>) => createQueryKey('getApiV1UtilsSupportContactByLanguage', options);

/**
 * Get Support Contact Info
 *
 * Get support phone and email for a language and optional patient country.
 *
 * Public, clients show it before login.
 */
export const apiGetUtilsSupportContactByLanguageOptions = (options: Options<GetApiV1UtilsSupportContactByLanguageData>) => queryOptions<GetApiV1UtilsSupportContactByLanguageResponse, GetApiV1UtilsSupportContactByLanguageError, GetApiV1UtilsSupportContactByLanguageResponse, ReturnType<typeof apiGetUtilsSupportContactByLanguageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetUtilsSupportContactLanguage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetUtilsSupportContactByLanguageQueryKey(options)
});

export const apiGetMonitoringSettingsMonitoringQueryKey = (options?: Options<GetApiV1MonitoringSettingsMonitoringData>) => createQueryKey('getApiV1MonitoringSettingsMonitoring', options);

/**
 * Get Monitoring Settings List
 *
 * Get the list of all monitoring settings.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMonitoringSettingsMonitoringOptions = (options?: Options<GetApiV1MonitoringSettingsMonitoringData>) => queryOptions<GetApiV1MonitoringSettingsMonitoringResponse, GetApiV1MonitoringSettingsMonitoringError, GetApiV1MonitoringSettingsMonitoringResponse, ReturnType<typeof apiGetMonitoringSettingsMonitoringQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMonitoringSettingsMonitoring({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMonitoringSettingsMonitoringQueryKey(options)
});

/**
 * Create Monitoring Settings
 *
 * Create a new monitoring settings set. The monitoring settings for a given
 * monitoring type, country, region, clinic, and physician must be unique. To
 * update settings for the given audience, use the update endpoint.
 * `required_consents` defaults to what the legacy `consent_type` stands for:
 * `1` `telemonitoring`, `2` `research`; `screening` requires none and
 * takes no other (422). Given `required_consents` alone, `consent_type` is
 * `1` when they include `telemonitoring`, else `2`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMonitoringSettingsMonitoringMutation = (options?: Partial<Options<PostApiV1MonitoringSettingsMonitoringData>>): UseMutationOptions<PostApiV1MonitoringSettingsMonitoringResponse, PostApiV1MonitoringSettingsMonitoringError, Options<PostApiV1MonitoringSettingsMonitoringData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MonitoringSettingsMonitoringResponse, PostApiV1MonitoringSettingsMonitoringError, Options<PostApiV1MonitoringSettingsMonitoringData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMonitoringSettingsMonitoring({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMonitoringSettingsMonitoringByPatientIdQueryKey = (options: Options<GetApiV1MonitoringSettingsMonitoringByPatientIdData>) => createQueryKey('getApiV1MonitoringSettingsMonitoringByPatientId', options);

/**
 * Get Monitoring Settings For Patient
 *
 * Get monitoring settings set for a given patient ID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMonitoringSettingsMonitoringByPatientIdOptions = (options: Options<GetApiV1MonitoringSettingsMonitoringByPatientIdData>) => queryOptions<GetApiV1MonitoringSettingsMonitoringByPatientIdResponse, GetApiV1MonitoringSettingsMonitoringByPatientIdError, GetApiV1MonitoringSettingsMonitoringByPatientIdResponse, ReturnType<typeof apiGetMonitoringSettingsMonitoringByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMonitoringSettingsMonitoringPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMonitoringSettingsMonitoringByPatientIdQueryKey(options)
});

/**
 * Delete Monitoring Settings
 *
 * Delete an monitoring settings set given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteMonitoringSettingsMonitoringByUuidMutation = (options?: Partial<Options<DeleteApiV1MonitoringSettingsMonitoringByUuidData>>): UseMutationOptions<DeleteApiV1MonitoringSettingsMonitoringByUuidResponse, DeleteApiV1MonitoringSettingsMonitoringByUuidError, Options<DeleteApiV1MonitoringSettingsMonitoringByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MonitoringSettingsMonitoringByUuidResponse, DeleteApiV1MonitoringSettingsMonitoringByUuidError, Options<DeleteApiV1MonitoringSettingsMonitoringByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMonitoringSettingsMonitoringUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Monitoring Settings
 *
 * Update/edit a monitoring settings set given its UUID. A changed
 * `consent_type` sent without `required_consents` replaces them with what it
 * stands for (`1` `telemonitoring`, `2` `research`) unless they already
 * include it; `required_consents` sent without a changed `consent_type` set
 * it as on create. Required consents on `screening` are a 422.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMonitoringSettingsMonitoringByUuidMutation = (options?: Partial<Options<PutApiV1MonitoringSettingsMonitoringByUuidData>>): UseMutationOptions<PutApiV1MonitoringSettingsMonitoringByUuidResponse, PutApiV1MonitoringSettingsMonitoringByUuidError, Options<PutApiV1MonitoringSettingsMonitoringByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1MonitoringSettingsMonitoringByUuidResponse, PutApiV1MonitoringSettingsMonitoringByUuidError, Options<PutApiV1MonitoringSettingsMonitoringByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutMonitoringSettingsMonitoringUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetMonitoringSettingsQuestionnairesQueryKey = (options?: Options<GetApiV1MonitoringSettingsQuestionnairesData>) => createQueryKey('getApiV1MonitoringSettingsQuestionnaires', options);

/**
 * Get Questionnaires Automaton Settings
 *
 * Get the list of all questionnaire automaton settings.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMonitoringSettingsQuestionnairesOptions = (options?: Options<GetApiV1MonitoringSettingsQuestionnairesData>) => queryOptions<GetApiV1MonitoringSettingsQuestionnairesResponse, GetApiV1MonitoringSettingsQuestionnairesError, GetApiV1MonitoringSettingsQuestionnairesResponse, ReturnType<typeof apiGetMonitoringSettingsQuestionnairesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetMonitoringSettingsQuestionnaires({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetMonitoringSettingsQuestionnairesQueryKey(options)
});

/**
 * Create Questionnaires Automaton Settings
 *
 * Create a new questionnaire automaton settings set. The questionnaire
 * automaton settings for a given questionnaire ID (type), monitoring type,
 * country, region, clinic, and physician must be unique. To update settings
 * for the given audience and questionnaire type, use the update endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMonitoringSettingsQuestionnairesMutation = (options?: Partial<Options<PostApiV1MonitoringSettingsQuestionnairesData>>): UseMutationOptions<PostApiV1MonitoringSettingsQuestionnairesResponse, PostApiV1MonitoringSettingsQuestionnairesError, Options<PostApiV1MonitoringSettingsQuestionnairesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1MonitoringSettingsQuestionnairesResponse, PostApiV1MonitoringSettingsQuestionnairesError, Options<PostApiV1MonitoringSettingsQuestionnairesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostMonitoringSettingsQuestionnaires({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Questionnaires Automaton Settings
 *
 * Delete a questionnaire automaton settings set given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteMonitoringSettingsQuestionnairesByUuidMutation = (options?: Partial<Options<DeleteApiV1MonitoringSettingsQuestionnairesByUuidData>>): UseMutationOptions<DeleteApiV1MonitoringSettingsQuestionnairesByUuidResponse, DeleteApiV1MonitoringSettingsQuestionnairesByUuidError, Options<DeleteApiV1MonitoringSettingsQuestionnairesByUuidData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1MonitoringSettingsQuestionnairesByUuidResponse, DeleteApiV1MonitoringSettingsQuestionnairesByUuidError, Options<DeleteApiV1MonitoringSettingsQuestionnairesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteMonitoringSettingsQuestionnairesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Questionnaires Automaton Settings
 *
 * Update/edit a monitoring settings set given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMonitoringSettingsQuestionnairesByUuidMutation = (options?: Partial<Options<PutApiV1MonitoringSettingsQuestionnairesByUuidData>>): UseMutationOptions<PutApiV1MonitoringSettingsQuestionnairesByUuidResponse, PutApiV1MonitoringSettingsQuestionnairesByUuidError, Options<PutApiV1MonitoringSettingsQuestionnairesByUuidData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1MonitoringSettingsQuestionnairesByUuidResponse, PutApiV1MonitoringSettingsQuestionnairesByUuidError, Options<PutApiV1MonitoringSettingsQuestionnairesByUuidData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutMonitoringSettingsQuestionnairesUuid({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clean Audit Logs
 *
 * Clean a selected query of audit logs. It is possible to filter by the audit
 * table, item UUID, audit item action (`update` or `delete`), audit tags,
 * audit user UUID, and specifying to -- from datetimes. At least one filter
 * is required. The purge itself is recorded as a `delete` item of the
 * `audit` table, carrying the filters and the number of rows removed.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteAuditMutation = (options?: Partial<Options<DeleteApiV1AuditData>>): UseMutationOptions<DeleteApiV1AuditResponse, DeleteApiV1AuditError, Options<DeleteApiV1AuditData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1AuditResponse, DeleteApiV1AuditError, Options<DeleteApiV1AuditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiDeleteAudit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetAuditQueryKey = (options?: Options<GetApiV1AuditData>) => createQueryKey('getApiV1Audit', options);

/**
 * Get Audit Logs
 *
 * List all audit items in the DB. An audit item is a historical record of
 * either an updated or deleted row. It is possible to filter by the audit
 * table, item UUID, audit item action (`update` or `delete`), audit tags,
 * audit user UUID, and specifying to -- from datetimes.
 *
 * When `audit_table` is given, `create` items are synthesized from the
 * source table's `created_at`, or from the snapshot of a deleted row
 * (creation is never written to the audit table). They carry no tags, so
 * any `audit_tags` filter excludes them.
 *
 * Items are ordered newest first. Pagination is opt-in (`paginate`).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuditOptions = (options?: Options<GetApiV1AuditData>) => queryOptions<GetApiV1AuditResponse, GetApiV1AuditError, GetApiV1AuditResponse, ReturnType<typeof apiGetAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuditQueryKey(options)
});

export const apiGetAuditInfiniteQueryKey = (options?: Options<GetApiV1AuditData>): QueryKey<Options<GetApiV1AuditData>> => createQueryKey('getApiV1Audit', options, true);

/**
 * Get Audit Logs
 *
 * List all audit items in the DB. An audit item is a historical record of
 * either an updated or deleted row. It is possible to filter by the audit
 * table, item UUID, audit item action (`update` or `delete`), audit tags,
 * audit user UUID, and specifying to -- from datetimes.
 *
 * When `audit_table` is given, `create` items are synthesized from the
 * source table's `created_at`, or from the snapshot of a deleted row
 * (creation is never written to the audit table). They carry no tags, so
 * any `audit_tags` filter excludes them.
 *
 * Items are ordered newest first. Pagination is opt-in (`paginate`).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuditInfiniteOptions = (options?: Options<GetApiV1AuditData>) => infiniteQueryOptions<GetApiV1AuditResponse, GetApiV1AuditError, InfiniteData<GetApiV1AuditResponse>, QueryKey<Options<GetApiV1AuditData>>, number | Pick<QueryKey<Options<GetApiV1AuditData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1AuditData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetAudit({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAuditInfiniteQueryKey(options)
});

/**
 * Add Tags To Audit Logs
 *
 * Add tags to a selected query of audit logs. It is possible to filter by the
 * audit table, item UUID, audit item action (`update` or `delete`), audit
 * tags, audit user UUID, and specifying to -- from datetimes.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutAuditMutation = (options?: Partial<Options<PutApiV1AuditData>>): UseMutationOptions<PutApiV1AuditResponse, PutApiV1AuditError, Options<PutApiV1AuditData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1AuditResponse, PutApiV1AuditError, Options<PutApiV1AuditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutAudit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetAnalyticsComputedQueryKey = (options?: Options<GetApiV1AnalyticsComputedData>) => createQueryKey('getApiV1AnalyticsComputed', options);

/**
 * Get Counts Seerlinq Computed
 *
 * Get counts of Seerlinq-computed data per given temporal grouping frequency.
 * This will group all data from Seerlinq-computed table by time and by
 * measurement type and count number of records and unique patients (by
 * computing unique items by patient ID). Optionally, filtering by datetimes is
 * possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsComputedOptions = (options?: Options<GetApiV1AnalyticsComputedData>) => queryOptions<GetApiV1AnalyticsComputedResponse, GetApiV1AnalyticsComputedError, GetApiV1AnalyticsComputedResponse, ReturnType<typeof apiGetAnalyticsComputedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAnalyticsComputed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAnalyticsComputedQueryKey(options)
});

export const apiGetAnalyticsPpgQueryKey = (options?: Options<GetApiV1AnalyticsPpgData>) => createQueryKey('getApiV1AnalyticsPpg', options);

/**
 * Get Counts Ppg Data
 *
 * Get counts of PPG data per given temporal grouping frequency. This will
 * group all data from PPG table by time, measurement device, and measurement
 * condition and count number of records and unique patients (by computing
 * unique items by patient ID). Optionally, filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsPpgOptions = (options?: Options<GetApiV1AnalyticsPpgData>) => queryOptions<GetApiV1AnalyticsPpgResponse, GetApiV1AnalyticsPpgError, GetApiV1AnalyticsPpgResponse, ReturnType<typeof apiGetAnalyticsPpgQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAnalyticsPpg({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAnalyticsPpgQueryKey(options)
});

export const apiGetAnalyticsEcgQueryKey = (options?: Options<GetApiV1AnalyticsEcgData>) => createQueryKey('getApiV1AnalyticsEcg', options);

/**
 * Get Counts Ecg Data
 *
 * Get counts of ECG data per given temporal grouping frequency. This will
 * group all data from ECG table by time and by measurement device and count
 * number of records and unique patients (by computing unique items by patient
 * ID). Optionally, filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsEcgOptions = (options?: Options<GetApiV1AnalyticsEcgData>) => queryOptions<GetApiV1AnalyticsEcgResponse, GetApiV1AnalyticsEcgError, GetApiV1AnalyticsEcgResponse, ReturnType<typeof apiGetAnalyticsEcgQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAnalyticsEcg({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAnalyticsEcgQueryKey(options)
});

export const apiGetAnalyticsEventsQueryKey = (options?: Options<GetApiV1AnalyticsEventsData>) => createQueryKey('getApiV1AnalyticsEvents', options);

/**
 * Get Counts Events
 *
 * Get counts of events data per given temporal grouping frequency. This will
 * group all data from patient's event table by time and by event category,
 * event category type, event category details, and count number of records and
 * unique patients (by computing unique items by patient ID). Optionally,
 * filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsEventsOptions = (options?: Options<GetApiV1AnalyticsEventsData>) => queryOptions<GetApiV1AnalyticsEventsResponse, GetApiV1AnalyticsEventsError, GetApiV1AnalyticsEventsResponse, ReturnType<typeof apiGetAnalyticsEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAnalyticsEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAnalyticsEventsQueryKey(options)
});

export const apiGetAnalyticsAuditQueryKey = (options?: Options<GetApiV1AnalyticsAuditData>) => createQueryKey('getApiV1AnalyticsAudit', options);

/**
 * Get Counts Audit Items
 *
 * Get counts of audit items per given temporal grouping frequency. This will
 * group all data from audit table by time and by measurement type and count
 * number of records and unique patients (by computing unique items by patient
 * ID). Optionally, filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsAuditOptions = (options?: Options<GetApiV1AnalyticsAuditData>) => queryOptions<GetApiV1AnalyticsAuditResponse, GetApiV1AnalyticsAuditError, GetApiV1AnalyticsAuditResponse, ReturnType<typeof apiGetAnalyticsAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAnalyticsAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAnalyticsAuditQueryKey(options)
});

export const apiGetAnalyticsAlertsQueryKey = (options?: Options<GetApiV1AnalyticsAlertsData>) => createQueryKey('getApiV1AnalyticsAlerts', options);

/**
 * Get Counts Alert Items
 *
 * Get counts of alert items per given temporal grouping frequency. This will
 * group all data from alert table by time and by measurement type and count
 * number of records and unique patients (by computing unique items by patient
 * ID). Optionally, filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsAlertsOptions = (options?: Options<GetApiV1AnalyticsAlertsData>) => queryOptions<GetApiV1AnalyticsAlertsResponse, GetApiV1AnalyticsAlertsError, GetApiV1AnalyticsAlertsResponse, ReturnType<typeof apiGetAnalyticsAlertsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetAnalyticsAlerts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetAnalyticsAlertsQueryKey(options)
});

export const apiGetBillingAccountQueryKey = (options?: Options<GetApiV1BillingAccountData>) => createQueryKey('getApiV1BillingAccount', options);

/**
 * Get My Account
 *
 * Your billing account and its credit balance. 404 for an account that has
 * none; a screening account gets one when it is created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Allow Payment (56)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingAccountOptions = (options?: Options<GetApiV1BillingAccountData>) => queryOptions<GetApiV1BillingAccountResponse, GetApiV1BillingAccountError, GetApiV1BillingAccountResponse, ReturnType<typeof apiGetBillingAccountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetBillingAccount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetBillingAccountQueryKey(options)
});

export const apiGetBillingLedgerQueryKey = (options?: Options<GetApiV1BillingLedgerData>) => createQueryKey('getApiV1BillingLedger', options);

/**
 * Get Ledger
 *
 * Every credit change on your account, newest first: a spend for each flow
 * whose result was delivered, and adjustments by an admin. Ledger rows never
 * change, so every sort is by creation. Empty for an account that has none.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Allow Payment (56)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingLedgerOptions = (options?: Options<GetApiV1BillingLedgerData>) => queryOptions<GetApiV1BillingLedgerResponse, GetApiV1BillingLedgerError, GetApiV1BillingLedgerResponse, ReturnType<typeof apiGetBillingLedgerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetBillingLedger({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetBillingLedgerQueryKey(options)
});

export const apiGetBillingLedgerInfiniteQueryKey = (options?: Options<GetApiV1BillingLedgerData>): QueryKey<Options<GetApiV1BillingLedgerData>> => createQueryKey('getApiV1BillingLedger', options, true);

/**
 * Get Ledger
 *
 * Every credit change on your account, newest first: a spend for each flow
 * whose result was delivered, and adjustments by an admin. Ledger rows never
 * change, so every sort is by creation. Empty for an account that has none.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Allow Payment (56)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingLedgerInfiniteOptions = (options?: Options<GetApiV1BillingLedgerData>) => infiniteQueryOptions<GetApiV1BillingLedgerResponse, GetApiV1BillingLedgerError, InfiniteData<GetApiV1BillingLedgerResponse>, QueryKey<Options<GetApiV1BillingLedgerData>>, number | Pick<QueryKey<Options<GetApiV1BillingLedgerData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1BillingLedgerData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetBillingLedger({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetBillingLedgerInfiniteQueryKey(options)
});

/**
 * Create Payment User
 *
 * Register a paid-screening account: a login that records PPG measurements
 * and pays for each delivered result from its credits. **Only `username`,
 * `password` and `email` are required**; `initial_credits` defaults to
 * 101. The patient and physician rows are filled in with fixed stand-ins
 * (name "Screening Account", country Slovakia, date of birth 1900-01-01,
 * sex `other`, race `Unknown / Not Reported`, no phone), because none of
 * it describes a real person.
 *
 * One call creates everything the account needs:
 *
 * - the login, with the permission that opens the paid-screening feature
 * - the patient the measurements hang off, as its own `screening`
 * monitoring type, so it stays out of the waiting room, the alerts and
 * the reminder emails; staff still see it in `GET /patients/` and its
 * physician in `GET /physicians/`
 * - the physician record connecting the login to that patient, which is
 * what makes those measurements visible to this account and no other
 * - the billing account with the starting credits
 *
 * Usernames are unique, so repeating the call with the same one is refused
 * rather than creating a second set. The caller must hold every
 * permission the account is given.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostBillingUsersMutation = (options?: Partial<Options<PostApiV1BillingUsersData>>): UseMutationOptions<PostApiV1BillingUsersResponse, PostApiV1BillingUsersError, Options<PostApiV1BillingUsersData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1BillingUsersResponse, PostApiV1BillingUsersError, Options<PostApiV1BillingUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostBillingUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetBillingScreeningUsersQueryKey = (options?: Options<GetApiV1BillingScreeningUsersData>) => createQueryKey('getApiV1BillingScreeningUsers', options);

/**
 * List Screening Users
 *
 * Every paid-screening user with what provisioning should have given them:
 * the permission, the physician record, the patient, the account and its
 * balance, credits spent and recordings stored. `missing` is empty exactly
 * when the account works end to end, so an account broken after
 * provisioning shows here; repair it with the ordinary user, patient and
 * physician endpoints, then `PUT /billing/users/{uuid}/credits`.
 *
 * Listed by role: the permission bitmask cannot be masked in SQL reliably.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingScreeningUsersOptions = (options?: Options<GetApiV1BillingScreeningUsersData>) => queryOptions<GetApiV1BillingScreeningUsersResponse, GetApiV1BillingScreeningUsersError, GetApiV1BillingScreeningUsersResponse, ReturnType<typeof apiGetBillingScreeningUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetBillingScreeningUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetBillingScreeningUsersQueryKey(options)
});

export const apiGetBillingScreeningUsersInfiniteQueryKey = (options?: Options<GetApiV1BillingScreeningUsersData>): QueryKey<Options<GetApiV1BillingScreeningUsersData>> => createQueryKey('getApiV1BillingScreeningUsers', options, true);

/**
 * List Screening Users
 *
 * Every paid-screening user with what provisioning should have given them:
 * the permission, the physician record, the patient, the account and its
 * balance, credits spent and recordings stored. `missing` is empty exactly
 * when the account works end to end, so an account broken after
 * provisioning shows here; repair it with the ordinary user, patient and
 * physician endpoints, then `PUT /billing/users/{uuid}/credits`.
 *
 * Listed by role: the permission bitmask cannot be masked in SQL reliably.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingScreeningUsersInfiniteOptions = (options?: Options<GetApiV1BillingScreeningUsersData>) => infiniteQueryOptions<GetApiV1BillingScreeningUsersResponse, GetApiV1BillingScreeningUsersError, InfiniteData<GetApiV1BillingScreeningUsersResponse>, QueryKey<Options<GetApiV1BillingScreeningUsersData>>, number | Pick<QueryKey<Options<GetApiV1BillingScreeningUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiV1BillingScreeningUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiGetBillingScreeningUsers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetBillingScreeningUsersInfiniteQueryKey(options)
});

export const apiGetBillingUsersByUserUuidAccountQueryKey = (options: Options<GetApiV1BillingUsersByUserUuidAccountData>) => createQueryKey('getApiV1BillingUsersByUserUuidAccount', options);

/**
 * Get User Account
 *
 * A user's billing account and its credit balance. 404 for an unknown
 * user, or one with no billing account.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingUsersByUserUuidAccountOptions = (options: Options<GetApiV1BillingUsersByUserUuidAccountData>) => queryOptions<GetApiV1BillingUsersByUserUuidAccountResponse, GetApiV1BillingUsersByUserUuidAccountError, GetApiV1BillingUsersByUserUuidAccountResponse, ReturnType<typeof apiGetBillingUsersByUserUuidAccountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetBillingUsersUserUuidAccount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetBillingUsersByUserUuidAccountQueryKey(options)
});

/**
 * Set Credits
 *
 * Put a screening account's credits at an exact figure. The difference is
 * posted to the ledger under the given note, so the balance is still the
 * sum of its entries; the account is locked while the difference is worked
 * out, so a recording charged at the same moment is never overwritten. A
 * balance that already matches returns null, so repeating a request
 * changes nothing.
 *
 * Refused for a user who is not a screening account, 404 for one with no
 * billing account.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPutBillingUsersByUserUuidCreditsMutation = (options?: Partial<Options<PutApiV1BillingUsersByUserUuidCreditsData>>): UseMutationOptions<PutApiV1BillingUsersByUserUuidCreditsResponse, PutApiV1BillingUsersByUserUuidCreditsError, Options<PutApiV1BillingUsersByUserUuidCreditsData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1BillingUsersByUserUuidCreditsResponse, PutApiV1BillingUsersByUserUuidCreditsError, Options<PutApiV1BillingUsersByUserUuidCreditsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPutBillingUsersUserUuidCredits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetHfComorbiditiesByPatientIdQueryKey = (options: Options<GetApiV1HfComorbiditiesByPatientIdData>) => createQueryKey('getApiV1HfComorbiditiesByPatientId', options);

/**
 * Get Comorbidities
 *
 * List all comorbidities for a given patient ID. This endpoint is subject to
 * filtering by data visibility dimension. If `full=true`, this endpoint
 * returns all tracked comorbidities (when not found in DB, it will assume a
 * "No" value).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfComorbiditiesByPatientIdOptions = (options: Options<GetApiV1HfComorbiditiesByPatientIdData>) => queryOptions<GetApiV1HfComorbiditiesByPatientIdResponse, GetApiV1HfComorbiditiesByPatientIdError, GetApiV1HfComorbiditiesByPatientIdResponse, ReturnType<typeof apiGetHfComorbiditiesByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetHfComorbiditiesPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetHfComorbiditiesByPatientIdQueryKey(options)
});

/**
 * Create Comorbidities
 *
 * Create new comorbidities in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 * Extra validation will not allow diagnoses not part of the HF validation
 * study.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfComorbiditiesMutation = (options?: Partial<Options<PostApiV1HfComorbiditiesData>>): UseMutationOptions<PostApiV1HfComorbiditiesResponse, PostApiV1HfComorbiditiesError, Options<PostApiV1HfComorbiditiesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1HfComorbiditiesResponse, PostApiV1HfComorbiditiesError, Options<PostApiV1HfComorbiditiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostHfComorbidities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetHfVitalsByPatientIdQueryKey = (options: Options<GetApiV1HfVitalsByPatientIdData>) => createQueryKey('getApiV1HfVitalsByPatientId', options);

/**
 * Get Vitals
 *
 * List all vital data for a given patient ID. This endpoint is subject to
 * filtering by data visibility dimension. This endpoint returns only medical
 * data that are marked as **vitals**, i.e., heart rate, systolic and diastolic
 * blood pressure, and SpO2. Note that this endpoint only returns SpO2 added to
 * the database as medical data, NOT SpO2 computed from PPG (which is part of
 * the PPG-derived table).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfVitalsByPatientIdOptions = (options: Options<GetApiV1HfVitalsByPatientIdData>) => queryOptions<GetApiV1HfVitalsByPatientIdResponse, GetApiV1HfVitalsByPatientIdError, GetApiV1HfVitalsByPatientIdResponse, ReturnType<typeof apiGetHfVitalsByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetHfVitalsPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetHfVitalsByPatientIdQueryKey(options)
});

export const apiGetHfLabDataByPatientIdQueryKey = (options: Options<GetApiV1HfLabDataByPatientIdData>) => createQueryKey('getApiV1HfLabDataByPatientId', options);

/**
 * Get Lab Data
 *
 * List all lab data for a given patient ID. This endpoint is subject to
 * filtering by data visibility dimension. This endpoint returns only medical
 * data that are marked as **lab data**, i.e., NT-proBNP, BNP, urea,
 * creatinine, hemoglobin, and hematocrit. Moreover, it automatically
 * computes (where the data is available) extra variables:
 *
 * * ePVS
 * * CKD-EPI (glomerular filtration rate estimate)
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfLabDataByPatientIdOptions = (options: Options<GetApiV1HfLabDataByPatientIdData>) => queryOptions<GetApiV1HfLabDataByPatientIdResponse, GetApiV1HfLabDataByPatientIdError, GetApiV1HfLabDataByPatientIdResponse, ReturnType<typeof apiGetHfLabDataByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetHfLabDataPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetHfLabDataByPatientIdQueryKey(options)
});

export const apiGetHfBasicMedDataByPatientIdQueryKey = (options: Options<GetApiV1HfBasicMedDataByPatientIdData>) => createQueryKey('getApiV1HfBasicMedDataByPatientId', options);

/**
 * Get Basic Medical Data
 *
 * List all basic medical data for a given patient ID. This endpoint is subject
 * to filtering by data visibility dimension. This endpoint returns only
 * medical data that are marked as **basic medical data**, i.e., weight, dry
 * weight, temperature, and respiratory rate. Moreover, it automatically
 * computes (where the data is available) extra variables:
 *
 * * CHA2DS2-VA score (Atrial Fibrillation Stroke Risk)
 * * BMI
 * * BSA (body surface area) (Du Bois formula)
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfBasicMedDataByPatientIdOptions = (options: Options<GetApiV1HfBasicMedDataByPatientIdData>) => queryOptions<GetApiV1HfBasicMedDataByPatientIdResponse, GetApiV1HfBasicMedDataByPatientIdError, GetApiV1HfBasicMedDataByPatientIdResponse, ReturnType<typeof apiGetHfBasicMedDataByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetHfBasicMedDataPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetHfBasicMedDataByPatientIdQueryKey(options)
});

export const apiGetHfExamsByPatientIdQueryKey = (options: Options<GetApiV1HfExamsByPatientIdData>) => createQueryKey('getApiV1HfExamsByPatientId', options);

/**
 * Get Exams
 *
 * List all exams for a given patient ID. This endpoint is subject to
 * filtering by data visibility dimension. This endpoint returns only medical
 * data that are marked as **exams**, and includes all variables related to RHC
 * and ECHO examinations. Moreover, it automatically computes (where the data
 * is available) extra variables:
 *
 * * congestion score
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfExamsByPatientIdOptions = (options: Options<GetApiV1HfExamsByPatientIdData>) => queryOptions<GetApiV1HfExamsByPatientIdResponse, GetApiV1HfExamsByPatientIdError, GetApiV1HfExamsByPatientIdResponse, ReturnType<typeof apiGetHfExamsByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetHfExamsPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetHfExamsByPatientIdQueryKey(options)
});

export const apiGetHfSymptomsByPatientIdQueryKey = (options: Options<GetApiV1HfSymptomsByPatientIdData>) => createQueryKey('getApiV1HfSymptomsByPatientId', options);

/**
 * Get Symptoms
 *
 * List all symptoms that are considered as HF-related for a given patient
 * ID. This endpoint is subject to filtering by data visibility dimension. This
 * endpoint returns only symptoms that are part of the HF validation study,
 * i.e., shortness of breath and fatigue score.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfSymptomsByPatientIdOptions = (options: Options<GetApiV1HfSymptomsByPatientIdData>) => queryOptions<GetApiV1HfSymptomsByPatientIdResponse, GetApiV1HfSymptomsByPatientIdError, GetApiV1HfSymptomsByPatientIdResponse, ReturnType<typeof apiGetHfSymptomsByPatientIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetHfSymptomsPatientId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetHfSymptomsByPatientIdQueryKey(options)
});

/**
 * Create Data
 *
 * Create new medical data in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 * Extra validation will not allow data types not part of the HF validation
 * study.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfDataMutation = (options?: Partial<Options<PostApiV1HfDataData>>): UseMutationOptions<PostApiV1HfDataResponse, PostApiV1HfDataError, Options<PostApiV1HfDataData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1HfDataResponse, PostApiV1HfDataError, Options<PostApiV1HfDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostHfData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Symptoms
 *
 * Create new study endpoints symptoms in bulk. This is possible only for a
 * single patient ID. This endpoint is subject to filtering by data visibility
 * dimension. Extra validation will not allow data types not part of the HF
 * validation study and at the same time all required measurements must be part
 * of the request.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfSymptomsMutation = (options?: Partial<Options<PostApiV1HfSymptomsData>>): UseMutationOptions<PostApiV1HfSymptomsResponse, PostApiV1HfSymptomsError, Options<PostApiV1HfSymptomsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1HfSymptomsResponse, PostApiV1HfSymptomsError, Options<PostApiV1HfSymptomsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostHfSymptoms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Rhc Exams Data
 *
 * Create new medical study RHC exams data in bulk. This is possible only for a
 * single patient ID. This endpoint is subject to filtering by data visibility
 * dimension. This endpoint is for medical study exams connected to the
 * right heart catheterization. Extra validation will not allow data types not
 * part of the HF validation study and at the same time all required
 * measurements (as per study protocol) must be part of the request.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfExamsRhcMutation = (options?: Partial<Options<PostApiV1HfExamsRhcData>>): UseMutationOptions<PostApiV1HfExamsRhcResponse, PostApiV1HfExamsRhcError, Options<PostApiV1HfExamsRhcData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1HfExamsRhcResponse, PostApiV1HfExamsRhcError, Options<PostApiV1HfExamsRhcData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostHfExamsRhc({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Lhc Exams Data
 *
 * Create new medical study LHC exams data in bulk. This is possible only for a
 * single patient ID. This endpoint is subject to filtering by data visibility
 * dimension. This endpoint is for medical study exams connected to the
 * left heart catheterization. Extra validation will not allow data types not
 * part of the HF validation study.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfExamsLhcMutation = (options?: Partial<Options<PostApiV1HfExamsLhcData>>): UseMutationOptions<PostApiV1HfExamsLhcResponse, PostApiV1HfExamsLhcError, Options<PostApiV1HfExamsLhcData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1HfExamsLhcResponse, PostApiV1HfExamsLhcError, Options<PostApiV1HfExamsLhcData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostHfExamsLhc({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Echo Exams Data
 *
 * Create new medical study ECHO exams data in bulk. This is possible only for
 * a single patient ID. This endpoint is subject to filtering by data
 * visibility dimension. This endpoint is for medical study exams connected to
 * the echocardiogram. Extra validation will not allow data types not part of
 * the HF validation study.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfExamsEchoMutation = (options?: Partial<Options<PostApiV1HfExamsEchoData>>): UseMutationOptions<PostApiV1HfExamsEchoResponse, PostApiV1HfExamsEchoError, Options<PostApiV1HfExamsEchoData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1HfExamsEchoResponse, PostApiV1HfExamsEchoError, Options<PostApiV1HfExamsEchoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiPostHfExamsEcho({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetHealthcheckerQueryKey = (options?: Options<GetApiHealthcheckerData>) => createQueryKey('getApiHealthchecker', options);

/**
 * Health Check
 *
 * Simple API health check. No authentication required.
 */
export const apiGetHealthcheckerOptions = (options?: Options<GetApiHealthcheckerData>) => queryOptions<GetApiHealthcheckerResponse, DefaultError, GetApiHealthcheckerResponse, ReturnType<typeof apiGetHealthcheckerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetHealthchecker({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetHealthcheckerQueryKey(options)
});

export const apiGetHealthQueryKey = (options?: Options<GetApiHealthData>) => createQueryKey('getApiHealth', options);

/**
 * Service Status
 *
 * API and connected services health. Return statuses and latency for overall
 * service, DB, Redis cache, and background tasks backend and broker.
 */
export const apiGetHealthOptions = (options?: Options<GetApiHealthData>) => queryOptions<GetApiHealthResponse, DefaultError, GetApiHealthResponse, ReturnType<typeof apiGetHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetHealthQueryKey(options)
});

export const apiGetInfoQueryKey = (options?: Options<GetApiInfoData>) => createQueryKey('getApiInfo', options);

/**
 * Api Info
 *
 * Get basic info on the API: environment, version, base URL and server time.
 */
export const apiGetInfoOptions = (options?: Options<GetApiInfoData>) => queryOptions<GetApiInfoResponse, GetApiInfoError, GetApiInfoResponse, ReturnType<typeof apiGetInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetInfoQueryKey(options)
});
